/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Agents_Agent_LabelInputs */
/** @typedef {{ name: NonNullable<unknown>, title: NonNullable<unknown> }} Agents_Answer_By_ParentInputs */
/** @typedef {{}} Agents_Answer_Raised_FromInputs */
/** @typedef {{}} Agents_ArchiveInputs */
/** @typedef {{}} Agents_Archived_EmptyInputs */
/** @typedef {{}} Agents_AttachInputs */
/** @typedef {{ name: NonNullable<unknown>, reason: NonNullable<unknown> }} Agents_Attachment_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_Attachment_RemoveInputs */
/** @typedef {{}} Agents_AttachmentsInputs */
/** @typedef {{}} Agents_Bookmark_AddInputs */
/** @typedef {{}} Agents_Bookmark_RemoveInputs */
/** @typedef {{}} Agents_Browser_Read_OnlyInputs */
/** @typedef {{}} Agents_CancelInputs */
/** @typedef {{}} Agents_Case_ChatInputs */
/** @typedef {{}} Agents_Case_Chat_FailedInputs */
/** @typedef {{}} Agents_Change_ActionInputs */
/** @typedef {{}} Agents_Change_Agent_BodyInputs */
/** @typedef {{ agent: NonNullable<unknown> }} Agents_Change_Agent_TitleInputs */
/** @typedef {{}} Agents_Change_CompletedInputs */
/** @typedef {{}} Agents_Change_CreatedInputs */
/** @typedef {{}} Agents_Change_DelegatedInputs */
/** @typedef {{}} Agents_Change_DeletedInputs */
/** @typedef {{}} Agents_Change_DroppedInputs */
/** @typedef {{}} Agents_Change_Next_ReplyInputs */
/** @typedef {{}} Agents_Change_Obj_ActionInputs */
/** @typedef {{}} Agents_Change_Obj_CaseInputs */
/** @typedef {{}} Agents_Change_Obj_ChatInputs */
/** @typedef {{}} Agents_Change_Obj_OtherInputs */
/** @typedef {{}} Agents_Change_Obj_PageInputs */
/** @typedef {{}} Agents_Change_Obj_PersonInputs */
/** @typedef {{}} Agents_Change_Obj_WaitingInputs */
/** @typedef {{}} Agents_Change_PostedInputs */
/** @typedef {{}} Agents_Change_ReopenedInputs */
/** @typedef {{}} Agents_Change_UpdatedInputs */
/** @typedef {{}} Agents_ChangesInputs */
/** @typedef {{}} Agents_Child_QueuedInputs */
/** @typedef {{}} Agents_Child_RunningInputs */
/** @typedef {{}} Agents_Child_WaitingInputs */
/** @typedef {{}} Agents_ChildrenInputs */
/** @typedef {{}} Agents_Col_AgentInputs */
/** @typedef {{}} Agents_Col_CaseInputs */
/** @typedef {{}} Agents_Col_CostInputs */
/** @typedef {{}} Agents_Col_CreatedInputs */
/** @typedef {{}} Agents_Col_NameInputs */
/** @typedef {{}} Agents_Col_UpdatedInputs */
/** @typedef {{}} Agents_Composer_ShrinkInputs */
/** @typedef {{}} Agents_Conditions_CloseInputs */
/** @typedef {{}} Agents_Conditions_DrawerInputs */
/** @typedef {{}} Agents_Conditions_OpenInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Conditions_Open_DeviceInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Conditions_Open_Device_WarningInputs */
/** @typedef {{}} Agents_Conditions_Open_WarningInputs */
/** @typedef {{}} Agents_CopiedInputs */
/** @typedef {{}} Agents_CopyInputs */
/** @typedef {{}} Agents_Cwd_LabelInputs */
/** @typedef {{ value: NonNullable<unknown> }} Agents_Cwd_MissingInputs */
/** @typedef {{}} Agents_Cwd_Missing_NoteInputs */
/** @typedef {{}} Agents_Cwd_NoneInputs */
/** @typedef {{}} Agents_Cwd_None_NoteInputs */
/** @typedef {{}} Agents_Cwd_OtherInputs */
/** @typedef {{}} Agents_Cwd_OutsideInputs */
/** @typedef {{}} Agents_Delegate_StepInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Delegate_Step_FailedInputs */
/** @typedef {{}} Agents_Delegate_Step_OpenInputs */
/** @typedef {{}} Agents_DeleteInputs */
/** @typedef {{}} Agents_Delete_BodyInputs */
/** @typedef {{ names: NonNullable<unknown> }} Agents_Delete_Many_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Agents_Delete_Many_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Delete_TitleInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_AwayInputs */
/** @typedef {{}} Agents_Device_Away_ShortInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_ComingInputs */
/** @typedef {{}} Agents_Device_LabelInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_OfflineInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_Offline_PickInputs */
/** @typedef {{}} Agents_Device_ReadyInputs */
/** @typedef {{ self: NonNullable<unknown>, device: NonNullable<unknown> }} Agents_Device_Unreachable_LineInputs */
/** @typedef {{}} Agents_Devices_AddInputs */
/** @typedef {{}} Agents_Devices_Never_SeenInputs */
/** @typedef {{}} Agents_Draft_Ask_In_ChatInputs */
/** @typedef {{}} Agents_Draft_Copy_OriginalInputs */
/** @typedef {{}} Agents_Draft_Copy_SubjectInputs */
/** @typedef {{}} Agents_Draft_OpenInputs */
/** @typedef {{}} Agents_Draft_Open_OriginalInputs */
/** @typedef {{}} Agents_Draft_OriginalInputs */
/** @typedef {{}} Agents_Draft_Reason_PlaceholderInputs */
/** @typedef {{}} Agents_Draft_Reply_ToInputs */
/** @typedef {{}} Agents_Draft_Save_FailedInputs */
/** @typedef {{}} Agents_Draft_SideInputs */
/** @typedef {{}} Agents_Draft_Side_SourceInputs */
/** @typedef {{ lang: NonNullable<unknown> }} Agents_Draft_Side_TextInputs */
/** @typedef {{}} Agents_Draft_SlackInputs */
/** @typedef {{}} Agents_Draft_Slack_AgainInputs */
/** @typedef {{ error: NonNullable<unknown> }} Agents_Draft_Slack_FailedInputs */
/** @typedef {{}} Agents_Draft_Slack_PlacedInputs */
/** @typedef {{}} Agents_Draft_Slack_PlacingInputs */
/** @typedef {{}} Agents_Draft_Slack_Request_FailedInputs */
/** @typedef {{}} Agents_Draft_Slack_StaleInputs */
/** @typedef {{}} Agents_Draft_StaleInputs */
/** @typedef {{}} Agents_Draft_SubjectInputs */
/** @typedef {{}} Agents_Draft_TextInputs */
/** @typedef {{}} Agents_Draft_ThreadInputs */
/** @typedef {{}} Agents_Draft_To_UnknownInputs */
/** @typedef {{}} Agents_Draft_TranslationInputs */
/** @typedef {{}} Agents_Effort_LabelInputs */
/** @typedef {{}} Agents_EmptyInputs */
/** @typedef {{}} Agents_Empty_ActiveInputs */
/** @typedef {{}} Agents_FilterInputs */
/** @typedef {{}} Agents_Filter_ActiveInputs */
/** @typedef {{}} Agents_Filter_AllInputs */
/** @typedef {{}} Agents_Filter_ArchivedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_From_ParentInputs */
/** @typedef {{}} Agents_GoInputs */
/** @typedef {{ h: NonNullable<unknown>, m: NonNullable<unknown> }} Agents_Hours_MinutesInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Image_NInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Limit_DaysInputs */
/** @typedef {{ error: NonNullable<unknown>, at: NonNullable<unknown> }} Agents_Limit_ErrorInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Limit_HoursInputs */
/** @typedef {{ model: NonNullable<unknown> }} Agents_Limit_ModelInputs */
/** @typedef {{}} Agents_Limit_NoneInputs */
/** @typedef {{}} Agents_Limit_OffInputs */
/** @typedef {{ when: NonNullable<unknown> }} Agents_Limit_ResetsInputs */
/** @typedef {{}} Agents_Limit_TitleInputs */
/** @typedef {{}} Agents_Limit_WeekInputs */
/** @typedef {{}} Agents_ListInputs */
/** @typedef {{}} Agents_Load_FailedInputs */
/** @typedef {{}} Agents_Loading_OlderInputs */
/** @typedef {{}} Agents_Mark_CompactedInputs */
/** @typedef {{}} Agents_Mark_ReadInputs */
/** @typedef {{}} Agents_Mark_RewoundInputs */
/** @typedef {{}} Agents_Mark_StoppedInputs */
/** @typedef {{}} Agents_Mark_WithdrawnInputs */
/** @typedef {{}} Agents_MenuInputs */
/** @typedef {{}} Agents_Message_EditedInputs */
/** @typedef {{}} Agents_Message_RemovedInputs */
/** @typedef {{ m: NonNullable<unknown>, s: NonNullable<unknown> }} Agents_Minutes_SecondsInputs */
/** @typedef {{}} Agents_Model_Cli_DefaultInputs */
/** @typedef {{}} Agents_Model_LabelInputs */
/** @typedef {{}} Agents_More_ConditionsInputs */
/** @typedef {{}} Agents_NavInputs */
/** @typedef {{}} Agents_NewInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_New_HintInputs */
/** @typedef {{}} Agents_No_Agent_YetInputs */
/** @typedef {{}} Agents_No_DeviceInputs */
/** @typedef {{}} Agents_Not_FoundInputs */
/** @typedef {{}} Agents_Notice_AnsweredInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_AskedInputs */
/** @typedef {{}} Agents_Notice_EndedInputs */
/** @typedef {{ error: NonNullable<unknown> }} Agents_Notice_FailedInputs */
/** @typedef {{}} Agents_Notice_InstructedInputs */
/** @typedef {{}} Agents_Notice_OtherInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_RaisedInputs */
/** @typedef {{}} Agents_Notice_ReadInputs */
/** @typedef {{}} Agents_Notice_RetriedInputs */
/** @typedef {{}} Agents_Notice_StartedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_Step_ClosedInputs */
/** @typedef {{}} Agents_Notice_StoppedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_Turn_AddedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Notices_CountInputs */
/** @typedef {{}} Agents_Open_SettingsInputs */
/** @typedef {{}} Agents_Other_McpInputs */
/** @typedef {{}} Agents_Other_Mcp_ShortInputs */
/** @typedef {{}} Agents_Other_Mcp_WarningInputs */
/** @typedef {{}} Agents_OutlineInputs */
/** @typedef {{}} Agents_Outline_SideInputs */
/** @typedef {{}} Agents_Parent_ChatInputs */
/** @typedef {{}} Agents_Pc_AgentsInputs */
/** @typedef {{}} Agents_Pc_Auth_OkInputs */
/** @typedef {{ account: NonNullable<unknown> }} Agents_Pc_Auth_Ok_AccountInputs */
/** @typedef {{}} Agents_Pc_Auth_OutInputs */
/** @typedef {{}} Agents_Pc_Auth_UnknownInputs */
/** @typedef {{ agent: NonNullable<unknown> }} Agents_Pc_CompactInputs */
/** @typedef {{}} Agents_Pc_Compact_NoteInputs */
/** @typedef {{}} Agents_Pc_ConcurrencyInputs */
/** @typedef {{}} Agents_Pc_Concurrency_NoteInputs */
/** @typedef {{}} Agents_Pc_Default_AgentInputs */
/** @typedef {{}} Agents_Pc_Default_CwdInputs */
/** @typedef {{}} Agents_Pc_Default_Cwd_NoteInputs */
/** @typedef {{}} Agents_Pc_Default_ModelInputs */
/** @typedef {{}} Agents_Pc_DefaultsInputs */
/** @typedef {{}} Agents_Pc_DescriptionInputs */
/** @typedef {{}} Agents_Pc_LoginInputs */
/** @typedef {{}} Agents_Pc_Login_AgainInputs */
/** @typedef {{}} Agents_Pc_Login_CodeInputs */
/** @typedef {{}} Agents_Pc_Login_Code_HintInputs */
/** @typedef {{ error: NonNullable<unknown> }} Agents_Pc_Login_ErrorInputs */
/** @typedef {{}} Agents_Pc_Login_FailedInputs */
/** @typedef {{}} Agents_Pc_Login_OpenInputs */
/** @typedef {{}} Agents_Pc_Login_Open_CopyInputs */
/** @typedef {{}} Agents_Pc_Login_Paste_HintInputs */
/** @typedef {{}} Agents_Pc_Login_PreparingInputs */
/** @typedef {{}} Agents_Pc_Login_SentInputs */
/** @typedef {{}} Agents_Pc_Login_VerifyingInputs */
/** @typedef {{}} Agents_Pc_NameInputs */
/** @typedef {{}} Agents_Pc_Other_McpInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_AllInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_NoneInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_NoteInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_ReadInputs */
/** @typedef {{}} Agents_Pc_ParallelInputs */
/** @typedef {{}} Agents_Pc_QuietInputs */
/** @typedef {{}} Agents_Pc_Quiet_NoteInputs */
/** @typedef {{}} Agents_Pc_SerialInputs */
/** @typedef {{}} Agents_Pc_TitleInputs */
/** @typedef {{}} Agents_Pc_Usage_LimitsInputs */
/** @typedef {{}} Agents_Pc_Usage_Limits_NoteInputs */
/** @typedef {{}} Agents_Pc_WorkdirsInputs */
/** @typedef {{}} Agents_Pc_Workdirs_NoneInputs */
/** @typedef {{}} Agents_Pc_Workdirs_NoteInputs */
/** @typedef {{}} Agents_Pending_AfterInputs */
/** @typedef {{}} Agents_Pending_NextInputs */
/** @typedef {{}} Agents_Pending_Reading_NowInputs */
/** @typedef {{}} Agents_Pending_WithdrawingInputs */
/** @typedef {{}} Agents_Post_LabelInputs */
/** @typedef {{}} Agents_Post_PlaceholderInputs */
/** @typedef {{}} Agents_Post_Placeholder_RunningInputs */
/** @typedef {{}} Agents_Reach_No_SignerInputs */
/** @typedef {{ device: NonNullable<unknown>, self: NonNullable<unknown> }} Agents_Reach_Not_TrustedInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Reach_Not_Trusted_UnnamedInputs */
/** @typedef {{ self: NonNullable<unknown>, device: NonNullable<unknown> }} Agents_Reach_Own_OnlyInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Reach_Self_OnlyInputs */
/** @typedef {{}} Agents_Read_NowInputs */
/** @typedef {{}} Agents_Related_ChangedInputs */
/** @typedef {{}} Agents_RenameInputs */
/** @typedef {{}} Agents_Rename_ActionInputs */
/** @typedef {{}} Agents_Request_FailedInputs */
/** @typedef {{}} Agents_RetryInputs */
/** @typedef {{}} Agents_Rewind_ActionInputs */
/** @typedef {{}} Agents_Rewind_CheckingInputs */
/** @typedef {{}} Agents_Rewind_ConversationInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_Conversation_NInputs */
/** @typedef {{}} Agents_Rewind_Conversation_OneInputs */
/** @typedef {{}} Agents_Rewind_FailedInputs */
/** @typedef {{}} Agents_Rewind_FilesInputs */
/** @typedef {{}} Agents_Rewind_Files_BashInputs */
/** @typedef {{}} Agents_Rewind_Files_CodexInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_Files_NInputs */
/** @typedef {{}} Agents_Rewind_Files_NoneInputs */
/** @typedef {{}} Agents_Rewind_Files_OffInputs */
/** @typedef {{}} Agents_Rewind_HereInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_MoreInputs */
/** @typedef {{}} Agents_Rewind_TitleInputs */
/** @typedef {{}} Agents_Rewind_TrameriaInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_Trameria_NInputs */
/** @typedef {{}} Agents_Rewind_Trameria_NoneInputs */
/** @typedef {{}} Agents_Row_AskingInputs */
/** @typedef {{}} Agents_Row_DelegatingInputs */
/** @typedef {{}} Agents_Row_QueuedInputs */
/** @typedef {{}} Agents_Row_UnreadInputs */
/** @typedef {{}} Agents_Row_WorkingInputs */
/** @typedef {{}} Agents_Save_FailedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_SecondsInputs */
/** @typedef {{}} Agents_SendInputs */
/** @typedef {{}} Agents_Send_FailedInputs */
/** @typedef {{}} Agents_Send_Hint_EnterInputs */
/** @typedef {{ mod: NonNullable<unknown> }} Agents_Send_Hint_ModInputs */
/** @typedef {{}} Agents_SendingInputs */
/** @typedef {{}} Agents_Side_CloseInputs */
/** @typedef {{}} Agents_Side_Composer_PlaceholderInputs */
/** @typedef {{}} Agents_Side_FromInputs */
/** @typedef {{}} Agents_Side_LabelInputs */
/** @typedef {{}} Agents_Side_NewInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Side_OpenInputs */
/** @typedef {{}} Agents_Side_Open_PageInputs */
/** @typedef {{}} Agents_Side_PlaceholderInputs */
/** @typedef {{}} Agents_Side_Reply_GoneInputs */
/** @typedef {{}} Agents_Side_StartInputs */
/** @typedef {{}} Agents_Signal_Slack_DraftInputs */
/** @typedef {{ caseTitle: NonNullable<unknown>, steps: NonNullable<unknown> }} Agents_Signal_Step_ReadyInputs */
/** @typedef {{}} Agents_Signal_Turn_AwaitingInputs */
/** @typedef {{}} Agents_Signal_Turn_DeclinedInputs */
/** @typedef {{}} Agents_Signal_Turn_WithdrawnInputs */
/** @typedef {{ caseTitle: NonNullable<unknown>, title: NonNullable<unknown> }} Agents_Signal_Wait_TargetInputs */
/** @typedef {{}} Agents_SomeoneInputs */
/** @typedef {{}} Agents_StartInputs */
/** @typedef {{}} Agents_Status_CompactingInputs */
/** @typedef {{}} Agents_Status_StartingInputs */
/** @typedef {{}} Agents_Status_StoppingInputs */
/** @typedef {{}} Agents_Status_ThinkingInputs */
/** @typedef {{}} Agents_Status_WaitingInputs */
/** @typedef {{}} Agents_Status_WritingInputs */
/** @typedef {{}} Agents_StopInputs */
/** @typedef {{}} Agents_Stop_FailedInputs */
/** @typedef {{}} Agents_Suggest_LoadingInputs */
/** @typedef {{}} Agents_Tap_To_WithdrawInputs */
/** @typedef {{}} Agents_This_Pc_NameInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Agents_Time_RangeInputs */
/** @typedef {{}} Agents_TitleInputs */
/** @typedef {{}} Agents_Title_LabelInputs */
/** @typedef {{}} Agents_Title_PlaceholderInputs */
/** @typedef {{}} Agents_To_EndInputs */
/** @typedef {{}} Agents_Turn_AfterInputs */
/** @typedef {{}} Agents_Turn_AnswerInputs */
/** @typedef {{}} Agents_Turn_Answer_FailedInputs */
/** @typedef {{}} Agents_Turn_BeforeInputs */
/** @typedef {{}} Agents_Turn_Browser_Read_OnlyInputs */
/** @typedef {{}} Agents_Turn_Cause_ApprovedInputs */
/** @typedef {{}} Agents_Turn_Cause_ConversationInputs */
/** @typedef {{}} Agents_Turn_Cause_HumanInputs */
/** @typedef {{}} Agents_Turn_ChangedInputs */
/** @typedef {{}} Agents_Turn_Check_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_Choice_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_ChosenInputs */
/** @typedef {{}} Agents_Turn_CloseInputs */
/** @typedef {{}} Agents_Turn_Closed_AlreadyInputs */
/** @typedef {{}} Agents_Turn_CommentInputs */
/** @typedef {{}} Agents_Turn_Comment_PlaceholderInputs */
/** @typedef {{ count: NonNullable<unknown> }} Agents_Turn_CountInputs */
/** @typedef {{}} Agents_Turn_Current_AboveInputs */
/** @typedef {{}} Agents_Turn_Date_ClearInputs */
/** @typedef {{}} Agents_Turn_Date_PickInputs */
/** @typedef {{}} Agents_Turn_Edited_By_YouInputs */
/** @typedef {{}} Agents_Turn_FoldInputs */
/** @typedef {{}} Agents_Turn_Form_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_Turn_FromInputs */
/** @typedef {{}} Agents_Turn_Hand_OverInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_Turn_Held_ByInputs */
/** @typedef {{}} Agents_Turn_HistoryInputs */
/** @typedef {{}} Agents_Turn_Kind_CheckInputs */
/** @typedef {{}} Agents_Turn_Kind_Draft_EmailInputs */
/** @typedef {{}} Agents_Turn_Kind_Draft_SlackInputs */
/** @typedef {{}} Agents_Turn_Kind_OperateInputs */
/** @typedef {{}} Agents_Turn_Kind_ProvideInputs */
/** @typedef {{}} Agents_Turn_LabelInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Turn_Line_DoneInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Turn_Line_WithdrawnInputs */
/** @typedef {{}} Agents_Turn_LinksInputs */
/** @typedef {{}} Agents_Turn_MultiInputs */
/** @typedef {{}} Agents_Turn_Need_FixInputs */
/** @typedef {{}} Agents_Turn_Need_ReasonInputs */
/** @typedef {{}} Agents_Turn_NoInputs */
/** @typedef {{}} Agents_Turn_Operate_PlaceholderInputs */
/** @typedef {{ at: NonNullable<unknown>, count: NonNullable<unknown> }} Agents_Turn_PlaceInputs */
/** @typedef {{}} Agents_Turn_ProposalInputs */
/** @typedef {{}} Agents_Turn_Proposal_AcceptInputs */
/** @typedef {{}} Agents_Turn_Proposal_CurrentInputs */
/** @typedef {{}} Agents_Turn_Proposal_KeepInputs */
/** @typedef {{}} Agents_Turn_Provide_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_RecommendedInputs */
/** @typedef {{}} Agents_Turn_Result_DoneInputs */
/** @typedef {{}} Agents_Turn_Result_FailedInputs */
/** @typedef {{}} Agents_Turn_Result_FixInputs */
/** @typedef {{}} Agents_Turn_Result_OkInputs */
/** @typedef {{}} Agents_Turn_Result_SentInputs */
/** @typedef {{}} Agents_Turn_Result_UnsentInputs */
/** @typedef {{}} Agents_Turn_RewrittenInputs */
/** @typedef {{}} Agents_Turn_Text_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_Ui_ConfirmInputs */
/** @typedef {{}} Agents_Turn_Ui_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_View_DraftInputs */
/** @typedef {{}} Agents_Turn_View_QuestionInputs */
/** @typedef {{}} Agents_Turn_View_RequestInputs */
/** @typedef {{}} Agents_Turn_YesInputs */
/** @typedef {{}} Agents_UnarchiveInputs */
/** @typedef {{}} Agents_UndoInputs */
/** @typedef {{}} Agents_Undo_AllInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Undo_All_TitleInputs */
/** @typedef {{}} Agents_Undo_ConflictInputs */
/** @typedef {{}} Agents_Undo_CreatedInputs */
/** @typedef {{}} Agents_Undo_DoneInputs */
/** @typedef {{}} Agents_Undo_FailedInputs */
/** @typedef {{ title: NonNullable<unknown>, op: NonNullable<unknown> }} Agents_Undo_TitleInputs */
/** @typedef {{}} Agents_Undo_UpdatedInputs */
/** @typedef {{}} Agents_Undo_WorkingInputs */
/** @typedef {{}} Agents_Unread_From_HereInputs */
/** @typedef {{}} Agents_UntitledInputs */
/** @typedef {{}} Agents_Usage_Cache_ReadInputs */
/** @typedef {{}} Agents_Usage_Cache_WriteInputs */
/** @typedef {{}} Agents_Usage_CompactInputs */
/** @typedef {{}} Agents_Usage_Compact_FailedInputs */
/** @typedef {{}} Agents_Usage_ContextInputs */
/** @typedef {{}} Agents_Usage_CostInputs */
/** @typedef {{}} Agents_Usage_EmptyInputs */
/** @typedef {{}} Agents_Usage_InputInputs */
/** @typedef {{}} Agents_Usage_LabelInputs */
/** @typedef {{}} Agents_Usage_OutputInputs */
/** @typedef {{}} Agents_Usage_SessionInputs */
/** @typedef {{ value: NonNullable<unknown> }} Agents_Value_MissingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_ViaInputs */
/** @typedef {{}} Agents_View_LabelInputs */
/** @typedef {{}} Agents_Wait_Turn_ClosedInputs */
/** @typedef {{}} Agents_Wait_Turn_OpenInputs */
/** @typedef {{}} Agents_WithdrawInputs */
/** @typedef {{}} Agents_Withdraw_FailedInputs */
/** @typedef {{}} Agents_Withdraw_Too_LateInputs */
/** @typedef {{}} Blocks_Callout_BlueInputs */
/** @typedef {{ color: NonNullable<unknown> }} Blocks_Callout_Change_ColorInputs */
/** @typedef {{}} Blocks_Callout_ColorInputs */
/** @typedef {{}} Blocks_Callout_GreenInputs */
/** @typedef {{}} Blocks_Callout_PurpleInputs */
/** @typedef {{}} Blocks_Callout_RedInputs */
/** @typedef {{}} Blocks_Callout_Title_PlaceholderInputs */
/** @typedef {{}} Blocks_Callout_YellowInputs */
/** @typedef {{}} Blocks_CloseInputs */
/** @typedef {{}} Blocks_Code_CopyInputs */
/** @typedef {{}} Blocks_CopiedInputs */
/** @typedef {{}} Blocks_Copy_FailedInputs */
/** @typedef {{}} Blocks_Fence_CancelInputs */
/** @typedef {{}} Blocks_Fence_Edit_SourceInputs */
/** @typedef {{}} Blocks_Fence_SaveInputs */
/** @typedef {{}} Blocks_Fence_SourceInputs */
/** @typedef {{}} Blocks_File_ActionsInputs */
/** @typedef {{}} Blocks_File_Copy_LinkInputs */
/** @typedef {{}} Blocks_File_DeleteInputs */
/** @typedef {{}} Blocks_File_DownloadInputs */
/** @typedef {{}} Blocks_File_EnlargeInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_File_Enlarge_NamedInputs */
/** @typedef {{}} Blocks_File_Reset_WidthInputs */
/** @typedef {{}} Blocks_File_ResizeInputs */
/** @typedef {{ heading: NonNullable<unknown> }} Blocks_Footnote_BodyInputs */
/** @typedef {{ label: NonNullable<unknown> }} Blocks_Footnote_CreateInputs */
/** @typedef {{}} Blocks_Footnote_GoneInputs */
/** @typedef {{ heading: NonNullable<unknown> }} Blocks_Footnote_HeadingInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Footnote_NamedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Footnote_To_DefInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_Footnote_To_RefInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_Footnote_UnreferencedInputs */
/** @typedef {{ error: NonNullable<unknown> }} Blocks_Mermaid_FailedInputs */
/** @typedef {{}} Blocks_Table_Add_AboveInputs */
/** @typedef {{}} Blocks_Table_Add_BelowInputs */
/** @typedef {{}} Blocks_Table_Add_ColInputs */
/** @typedef {{}} Blocks_Table_Add_LeftInputs */
/** @typedef {{}} Blocks_Table_Add_RightInputs */
/** @typedef {{}} Blocks_Table_Add_RowInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Table_Col_ActionsInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Table_Col_ResizeInputs */
/** @typedef {{}} Blocks_Table_Delete_ColInputs */
/** @typedef {{}} Blocks_Table_Delete_RowInputs */
/** @typedef {{}} Blocks_Table_Freeze_HereInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Table_Row_ActionsInputs */
/** @typedef {{}} Blocks_Table_UnfreezeInputs */
/** @typedef {{}} Blocks_Toggle_CloseInputs */
/** @typedef {{}} Blocks_Toggle_OpenInputs */
/** @typedef {{}} Blocks_Upload_AbortedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_Upload_CancelInputs */
/** @typedef {{}} Blocks_Upload_FailedInputs */
/** @typedef {{}} Blocks_Upload_Failed_NetworkInputs */
/** @typedef {{ status: NonNullable<unknown> }} Blocks_Upload_Failed_StatusInputs */
/** @typedef {{}} Blocks_Upload_Too_LargeInputs */
/** @typedef {{}} Blocks_UploadsInputs */
/** @typedef {{}} Cases_Action_TitleInputs */
/** @typedef {{}} Cases_Action_Title_PlaceholderInputs */
/** @typedef {{}} Cases_AddInputs */
/** @typedef {{}} Cases_Add_ActionInputs */
/** @typedef {{}} Cases_Add_Action_ButtonInputs */
/** @typedef {{}} Cases_Add_Step_Needs_TitleInputs */
/** @typedef {{}} Cases_Add_WaitingInputs */
/** @typedef {{}} Cases_Add_Waiting_ButtonInputs */
/** @typedef {{}} Cases_Agent_MemoInputs */
/** @typedef {{}} Cases_BodyInputs */
/** @typedef {{}} Cases_Body_PlaceholderInputs */
/** @typedef {{}} Cases_Body_Write_PlaceholderInputs */
/** @typedef {{}} Cases_Case_TitleInputs */
/** @typedef {{}} Cases_ChainInputs */
/** @typedef {{}} Cases_Chain_DoneInputs */
/** @typedef {{}} Cases_Chain_EmptyInputs */
/** @typedef {{}} Cases_Chain_GraphInputs */
/** @typedef {{}} Cases_Chain_LaterInputs */
/** @typedef {{}} Cases_Chain_NowInputs */
/** @typedef {{}} Cases_Change_DueInputs */
/** @typedef {{}} Cases_Change_PlanInputs */
/** @typedef {{}} Cases_Change_Wait_UntilInputs */
/** @typedef {{}} Cases_Closed_EmptyInputs */
/** @typedef {{}} Cases_Col_CaseInputs */
/** @typedef {{}} Cases_Col_DueInputs */
/** @typedef {{}} Cases_Col_NameInputs */
/** @typedef {{}} Cases_Col_PlanInputs */
/** @typedef {{}} Cases_Col_UpdatedInputs */
/** @typedef {{}} Cases_Col_WaitInputs */
/** @typedef {{}} Cases_ContextInputs */
/** @typedef {{}} Cases_Context_PlaceholderInputs */
/** @typedef {{}} Cases_CreateInputs */
/** @typedef {{}} Cases_Create_Failed_KeptInputs */
/** @typedef {{}} Cases_Delete_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Delete_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Delete_TitleInputs */
/** @typedef {{}} Cases_DoneInputs */
/** @typedef {{}} Cases_DropInputs */
/** @typedef {{}} Cases_DueInputs */
/** @typedef {{}} Cases_Due_ClearInputs */
/** @typedef {{}} Cases_EmptyInputs */
/** @typedef {{ n: NonNullable<unknown> }} Cases_File_BytesInputs */
/** @typedef {{ n: NonNullable<unknown> }} Cases_File_KbInputs */
/** @typedef {{ n: NonNullable<unknown> }} Cases_File_MbInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_File_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_File_Remove_FailedInputs */
/** @typedef {{}} Cases_FilesInputs */
/** @typedef {{}} Cases_GoInputs */
/** @typedef {{}} Cases_Graph_DelegatedInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Cases_Graph_ProgressInputs */
/** @typedef {{}} Cases_Kind_ActionInputs */
/** @typedef {{}} Cases_Kind_WaitingInputs */
/** @typedef {{}} Cases_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Label_ChangeInputs */
/** @typedef {{}} Cases_Label_FailedInputs */
/** @typedef {{}} Cases_Label_SetInputs */
/** @typedef {{}} Cases_ListInputs */
/** @typedef {{}} Cases_Load_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_MenuInputs */
/** @typedef {{}} Cases_NewInputs */
/** @typedef {{}} Cases_Not_FoundInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_OverdueInputs */
/** @typedef {{}} Cases_Panel_CloseInputs */
/** @typedef {{}} Cases_PlanInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Plan_CarriedInputs */
/** @typedef {{}} Cases_Plan_ClearInputs */
/** @typedef {{}} Cases_Plan_Pick_DateInputs */
/** @typedef {{}} Cases_Plan_SomedayInputs */
/** @typedef {{}} Cases_Plan_This_WeekInputs */
/** @typedef {{}} Cases_Plan_TodayInputs */
/** @typedef {{}} Cases_Plan_TomorrowInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Plan_Week_OfInputs */
/** @typedef {{}} Cases_RelatedInputs */
/** @typedef {{}} Cases_Related_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Related_Add_FailedInputs */
/** @typedef {{}} Cases_Related_CandidatesInputs */
/** @typedef {{}} Cases_Related_NoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Related_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Related_Remove_FailedInputs */
/** @typedef {{}} Cases_Related_SearchInputs */
/** @typedef {{}} Cases_Related_Search_PlaceholderInputs */
/** @typedef {{}} Cases_RenameInputs */
/** @typedef {{}} Cases_ReopenInputs */
/** @typedef {{}} Cases_ResultInputs */
/** @typedef {{}} Cases_Result_PlaceholderInputs */
/** @typedef {{ kind: NonNullable<unknown>, title: NonNullable<unknown> }} Cases_Source_Step_BodyInputs */
/** @typedef {{ kind: NonNullable<unknown>, title: NonNullable<unknown> }} Cases_Source_Step_ResultInputs */
/** @typedef {{ kind: NonNullable<unknown>, title: NonNullable<unknown> }} Cases_Source_Step_WaitInputs */
/** @typedef {{}} Cases_Status_DoneInputs */
/** @typedef {{}} Cases_Status_DroppedInputs */
/** @typedef {{}} Cases_Status_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Add_FailedInputs */
/** @typedef {{}} Cases_Step_Auto_ClosedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Close_FailedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Step_CreatedInputs */
/** @typedef {{}} Cases_Step_Delete_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Delete_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Delete_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_DoneInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Step_DueInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Due_FailedInputs */
/** @typedef {{}} Cases_Step_KindInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_MenuInputs */
/** @typedef {{ label: NonNullable<unknown> }} Cases_Step_PlanInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Plan_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Rename_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Reopen_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_ResolveInputs */
/** @typedef {{}} Cases_Step_TitleInputs */
/** @typedef {{}} Cases_Step_UnplacedInputs */
/** @typedef {{}} Cases_Step_Unplaced_HintInputs */
/** @typedef {{}} Cases_Step_Wait_Target_DroppedInputs */
/** @typedef {{}} Cases_Tab_ClosedInputs */
/** @typedef {{}} Cases_Tab_NextInputs */
/** @typedef {{}} Cases_Tab_ReadyInputs */
/** @typedef {{}} Cases_Tab_WaitingInputs */
/** @typedef {{}} Cases_TabsInputs */
/** @typedef {{}} Cases_TitleInputs */
/** @typedef {{}} Cases_Title_FailedInputs */
/** @typedef {{}} Cases_Title_PlaceholderInputs */
/** @typedef {{}} Cases_Wait_UntilInputs */
/** @typedef {{}} Cases_Waiting_TitleInputs */
/** @typedef {{}} Cases_Waiting_Title_PlaceholderInputs */
/** @typedef {{}} Common_CancelInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Days_AgoInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Days_LaterInputs */
/** @typedef {{}} Common_DeleteInputs */
/** @typedef {{ lead: NonNullable<unknown>, message: NonNullable<unknown> }} Common_Error_With_LeadInputs */
/** @typedef {{}} Common_ForbiddenInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Hours_AgoInputs */
/** @typedef {{}} Common_Just_NowInputs */
/** @typedef {{}} Common_Load_More_FailedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Minutes_AgoInputs */
/** @typedef {{}} Common_Picture_ApplyInputs */
/** @typedef {{}} Common_Picture_ChooseInputs */
/** @typedef {{}} Common_Picture_Crop_HintInputs */
/** @typedef {{}} Common_Picture_FailedInputs */
/** @typedef {{}} Common_Picture_RemoveInputs */
/** @typedef {{}} Common_Picture_StageInputs */
/** @typedef {{}} Common_Picture_UnreadableInputs */
/** @typedef {{}} Common_Picture_ZoomInputs */
/** @typedef {{}} Common_RetryInputs */
/** @typedef {{}} Common_SaveInputs */
/** @typedef {{}} Common_TodayInputs */
/** @typedef {{}} Common_TomorrowInputs */
/** @typedef {{}} Common_YesterdayInputs */
/** @typedef {{}} Datasets_Add_RowInputs */
/** @typedef {{}} Datasets_Col_FieldInputs */
/** @typedef {{}} Datasets_Col_FilledInputs */
/** @typedef {{}} Datasets_Date_ClearInputs */
/** @typedef {{}} Datasets_Date_PickInputs */
/** @typedef {{}} Datasets_Delete_RowInputs */
/** @typedef {{}} Datasets_Delete_Row_BodyInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_DistributionInputs */
/** @typedef {{}} Datasets_Distribution_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_Distribution_TopInputs */
/** @typedef {{}} Datasets_Edit_RowInputs */
/** @typedef {{}} Datasets_FieldsInputs */
/** @typedef {{}} Datasets_Fields_GuessedInputs */
/** @typedef {{}} Datasets_Fields_NoneInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_Json_InvalidInputs */
/** @typedef {{}} Datasets_KeyInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_Key_MissingInputs */
/** @typedef {{}} Datasets_LatestInputs */
/** @typedef {{ shown: NonNullable<unknown>, count: NonNullable<unknown> }} Datasets_Latest_NoteInputs */
/** @typedef {{}} Datasets_ListInputs */
/** @typedef {{}} Datasets_List_BackInputs */
/** @typedef {{}} Datasets_List_EmptyInputs */
/** @typedef {{}} Datasets_List_Load_FailedInputs */
/** @typedef {{}} Datasets_List_NewInputs */
/** @typedef {{}} Datasets_List_None_MatchInputs */
/** @typedef {{}} Datasets_Load_FailedInputs */
/** @typedef {{}} Datasets_New_CreateInputs */
/** @typedef {{}} Datasets_New_FailedInputs */
/** @typedef {{}} Datasets_New_NoteInputs */
/** @typedef {{}} Datasets_New_TitleInputs */
/** @typedef {{}} Datasets_No_RowsInputs */
/** @typedef {{}} Datasets_Not_FoundInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_Number_InvalidInputs */
/** @typedef {{ days: NonNullable<unknown> }} Datasets_RetentionInputs */
/** @typedef {{}} Datasets_Row_ActionsInputs */
/** @typedef {{}} Datasets_Row_JsonInputs */
/** @typedef {{}} Datasets_Row_Json_InvalidInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_RowsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_Stat_DistinctInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_MaxInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_MeanInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_MinInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_Stat_OnInputs */
/** @typedef {{ first: NonNullable<unknown>, last: NonNullable<unknown> }} Datasets_Stat_RangeInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_SumInputs */
/** @typedef {{}} Datasets_Token_CloseInputs */
/** @typedef {{ date: NonNullable<unknown> }} Datasets_Token_CreatedInputs */
/** @typedef {{}} Datasets_Token_EndpointInputs */
/** @typedef {{}} Datasets_Token_FailedInputs */
/** @typedef {{}} Datasets_Token_IssueInputs */
/** @typedef {{}} Datasets_Token_Issue_ActionInputs */
/** @typedef {{}} Datasets_Token_NameInputs */
/** @typedef {{}} Datasets_Token_Name_PlaceholderInputs */
/** @typedef {{}} Datasets_Token_RevokeInputs */
/** @typedef {{}} Datasets_Token_Revoke_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Datasets_Token_Revoke_LabelInputs */
/** @typedef {{}} Datasets_Token_Shown_OnceInputs */
/** @typedef {{}} Datasets_Token_UnusedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Datasets_Token_UsedInputs */
/** @typedef {{}} Datasets_TokensInputs */
/** @typedef {{}} Datasets_Tokens_FailedInputs */
/** @typedef {{}} Datasets_Tokens_LeftInputs */
/** @typedef {{}} Datasets_Tokens_Left_NextInputs */
/** @typedef {{}} Datasets_Tokens_NoneInputs */
/** @typedef {{}} Datasets_Tokens_NoteInputs */
/** @typedef {{}} Datasets_Tokens_VaultInputs */
/** @typedef {{}} Datasets_Type_BooleanInputs */
/** @typedef {{}} Datasets_Type_DateInputs */
/** @typedef {{}} Datasets_Type_DatetimeInputs */
/** @typedef {{}} Datasets_Type_JsonInputs */
/** @typedef {{}} Datasets_Type_NumberInputs */
/** @typedef {{}} Datasets_Type_StringInputs */
/** @typedef {{ time: NonNullable<unknown> }} Datasets_UpdatedInputs */
/** @typedef {{}} Datasets_Viewer_CloseInputs */
/** @typedef {{}} Datasets_Viewer_OpenInputs */
/** @typedef {{}} Datasets_Write_FailedInputs */
/** @typedef {{}} Datasets_Written_AtInputs */
/** @typedef {{}} Desktop_Action_StartInputs */
/** @typedef {{}} Desktop_Action_StopInputs */
/** @typedef {{ version: NonNullable<unknown> }} Desktop_Advanced_Agent_BundledInputs */
/** @typedef {{}} Desktop_App_Update_AvailableInputs */
/** @typedef {{ version: NonNullable<unknown> }} Desktop_App_Update_VersionInputs */
/** @typedef {{}} Desktop_Check_FlagsInputs */
/** @typedef {{}} Desktop_Check_Foreign_McpInputs */
/** @typedef {{}} Desktop_Check_LiveInputs */
/** @typedef {{ at: NonNullable<unknown>, version: NonNullable<unknown> }} Desktop_Check_Live_AtInputs */
/** @typedef {{ at: NonNullable<unknown>, version: NonNullable<unknown>, current: NonNullable<unknown> }} Desktop_Check_Live_At_StaleInputs */
/** @typedef {{}} Desktop_Check_Live_Not_RunInputs */
/** @typedef {{}} Desktop_Device_Add_HintInputs */
/** @typedef {{}} Desktop_Device_Needs_LoginInputs */
/** @typedef {{}} Desktop_Device_Not_RegisteredInputs */
/** @typedef {{}} Desktop_Device_RegisteredInputs */
/** @typedef {{}} Desktop_Device_Remove_HintInputs */
/** @typedef {{}} Desktop_Device_Removed_ElsewhereInputs */
/** @typedef {{}} Desktop_Find_CloseInputs */
/** @typedef {{}} Desktop_Find_NextInputs */
/** @typedef {{}} Desktop_Find_PlaceholderInputs */
/** @typedef {{}} Desktop_Find_PreviousInputs */
/** @typedef {{}} Desktop_Menubar_Agent_ToggleInputs */
/** @typedef {{ time: NonNullable<unknown> }} Desktop_Menubar_Block_NextInputs */
/** @typedef {{}} Desktop_Notifications_BlockedInputs */
/** @typedef {{}} Desktop_Notifications_Blocked_NoteInputs */
/** @typedef {{}} Desktop_Notifications_Need_Signed_BuildInputs */
/** @typedef {{}} Desktop_Notifications_Open_SettingsInputs */
/** @typedef {{}} Desktop_Open_MainInputs */
/** @typedef {{}} Desktop_QuitInputs */
/** @typedef {{}} Desktop_Status_ConnectedInputs */
/** @typedef {{}} Desktop_Status_ErrorInputs */
/** @typedef {{}} Desktop_Status_ReconnectingInputs */
/** @typedef {{}} Desktop_Status_StartingInputs */
/** @typedef {{}} Desktop_Status_StoppedInputs */
/** @typedef {{}} Desktop_Status_StoppingInputs */
/** @typedef {{}} Desktop_Token_UnavailableInputs */
/** @typedef {{}} Desktop_Usage_LoadingInputs */
/** @typedef {{}} Desktop_Usage_Not_InstalledInputs */
/** @typedef {{}} Desktop_Usage_OffInputs */
/** @typedef {{}} Desktop_Usage_RefreshInputs */
/** @typedef {{}} Desktop_Usage_SettingsInputs */
/** @typedef {{ error: NonNullable<unknown> }} Desktop_Usage_Stale_ErrorInputs */
/** @typedef {{}} Desktop_Usage_TitleInputs */
/** @typedef {{ time: NonNullable<unknown> }} Desktop_Usage_Updated_AtInputs */
/** @typedef {{ n: NonNullable<unknown> }} Desktop_Usage_Updated_Minutes_AgoInputs */
/** @typedef {{}} Documents_Agent_MemoInputs */
/** @typedef {{}} Documents_ArchiveInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Archive_FailedInputs */
/** @typedef {{}} Documents_Block_Bullet_ListInputs */
/** @typedef {{}} Documents_Block_CalloutInputs */
/** @typedef {{}} Documents_Block_CodeInputs */
/** @typedef {{}} Documents_Block_CopiedInputs */
/** @typedef {{}} Documents_Block_Copy_FailedInputs */
/** @typedef {{}} Documents_Block_Copy_MarkdownInputs */
/** @typedef {{}} Documents_Block_DeleteInputs */
/** @typedef {{}} Documents_Block_DividerInputs */
/** @typedef {{}} Documents_Block_DuplicateInputs */
/** @typedef {{}} Documents_Block_FileInputs */
/** @typedef {{}} Documents_Block_File_HintInputs */
/** @typedef {{}} Documents_Block_FootnoteInputs */
/** @typedef {{}} Documents_Block_Heading1Inputs */
/** @typedef {{}} Documents_Block_Heading2Inputs */
/** @typedef {{}} Documents_Block_Heading3Inputs */
/** @typedef {{}} Documents_Block_InsertInputs */
/** @typedef {{}} Documents_Block_Lift_OutInputs */
/** @typedef {{}} Documents_Block_MenuInputs */
/** @typedef {{}} Documents_Block_Menu_Section_BlockInputs */
/** @typedef {{}} Documents_Block_Menu_Section_TypeInputs */
/** @typedef {{}} Documents_Block_MermaidInputs */
/** @typedef {{}} Documents_Block_Numbered_ListInputs */
/** @typedef {{}} Documents_Block_ParagraphInputs */
/** @typedef {{}} Documents_Block_QuoteInputs */
/** @typedef {{}} Documents_Block_TableInputs */
/** @typedef {{}} Documents_Block_Task_ListInputs */
/** @typedef {{}} Documents_Block_ToggleInputs */
/** @typedef {{}} Documents_Block_Unwrap_ListInputs */
/** @typedef {{}} Documents_Block_Unwrap_QuoteInputs */
/** @typedef {{}} Documents_BodyInputs */
/** @typedef {{}} Documents_Body_PlaceholderInputs */
/** @typedef {{}} Documents_CloseInputs */
/** @typedef {{}} Documents_Col_CreatedInputs */
/** @typedef {{}} Documents_Col_NameInputs */
/** @typedef {{}} Documents_Col_UpdatedInputs */
/** @typedef {{}} Documents_Copied_To_OwnInputs */
/** @typedef {{}} Documents_CopyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Copy_FailedInputs */
/** @typedef {{}} Documents_Copy_To_OwnInputs */
/** @typedef {{}} Documents_CreateInputs */
/** @typedef {{}} Documents_Create_FailedInputs */
/** @typedef {{}} Documents_DeleteInputs */
/** @typedef {{}} Documents_Delete_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Delete_FailedInputs */
/** @typedef {{ names: NonNullable<unknown> }} Documents_Delete_Many_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_Delete_Many_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Delete_TitleInputs */
/** @typedef {{}} Documents_EmptyInputs */
/** @typedef {{}} Documents_Empty_ArchivedInputs */
/** @typedef {{}} Documents_HistoryInputs */
/** @typedef {{ name: NonNullable<unknown>, connection: NonNullable<unknown> }} Documents_History_Actor_ViaInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_History_Change_CountInputs */
/** @typedef {{}} Documents_History_ChangesInputs */
/** @typedef {{}} Documents_History_EmptyInputs */
/** @typedef {{}} Documents_History_FailedInputs */
/** @typedef {{}} Documents_History_Is_LatestInputs */
/** @typedef {{}} Documents_History_LatestInputs */
/** @typedef {{}} Documents_History_No_BodyInputs */
/** @typedef {{}} Documents_History_No_ChangesInputs */
/** @typedef {{}} Documents_History_RestoredInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_History_SavesInputs */
/** @typedef {{}} Documents_History_SystemInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_History_UnchangedInputs */
/** @typedef {{}} Documents_History_VersionsInputs */
/** @typedef {{}} Documents_Index_AddInputs */
/** @typedef {{}} Documents_Index_Add_ExistingInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Add_FailedInputs */
/** @typedef {{}} Documents_Index_Add_NewInputs */
/** @typedef {{}} Documents_Index_ArchivedInputs */
/** @typedef {{}} Documents_Index_ButtonInputs */
/** @typedef {{}} Documents_Index_Create_FailedInputs */
/** @typedef {{}} Documents_Index_Create_WithInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Default_TitleInputs */
/** @typedef {{}} Documents_Index_Delete_BodyInputs */
/** @typedef {{}} Documents_Index_DetachInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Detach_FailedInputs */
/** @typedef {{}} Documents_Index_EmptyInputs */
/** @typedef {{}} Documents_Index_Existing_UnderInputs */
/** @typedef {{}} Documents_Index_FoldInputs */
/** @typedef {{}} Documents_Index_InInputs */
/** @typedef {{}} Documents_Index_In_NoneInputs */
/** @typedef {{}} Documents_Index_IndentInputs */
/** @typedef {{}} Documents_Index_Load_FailedInputs */
/** @typedef {{}} Documents_Index_MenuInputs */
/** @typedef {{}} Documents_Index_Move_DownInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Move_FailedInputs */
/** @typedef {{}} Documents_Index_Move_UpInputs */
/** @typedef {{}} Documents_Index_New_HintInputs */
/** @typedef {{}} Documents_Index_New_UnderInputs */
/** @typedef {{}} Documents_Index_OpenInputs */
/** @typedef {{}} Documents_Index_OutdentInputs */
/** @typedef {{}} Documents_Index_PickInputs */
/** @typedef {{}} Documents_Index_Pick_NoneInputs */
/** @typedef {{}} Documents_Index_Pick_SearchInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Put_FailedInputs */
/** @typedef {{}} Documents_Index_Put_InInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Remove_FromInputs */
/** @typedef {{}} Documents_Index_TitleInputs */
/** @typedef {{}} Documents_Index_Title_PlaceholderInputs */
/** @typedef {{}} Documents_Index_UnfoldInputs */
/** @typedef {{}} Documents_Kind_HtmlInputs */
/** @typedef {{}} Documents_Kind_IndexInputs */
/** @typedef {{}} Documents_Kind_MarkdownInputs */
/** @typedef {{}} Documents_Kind_SlideInputs */
/** @typedef {{}} Documents_Link_SuggestInputs */
/** @typedef {{}} Documents_List_FailedInputs */
/** @typedef {{}} Documents_Load_FailedInputs */
/** @typedef {{}} Documents_MenuInputs */
/** @typedef {{}} Documents_Mermaid_Default_PayloadInputs */
/** @typedef {{}} Documents_MissingInputs */
/** @typedef {{}} Documents_MoreInputs */
/** @typedef {{}} Documents_NavInputs */
/** @typedef {{}} Documents_NewInputs */
/** @typedef {{}} Documents_New_DocumentInputs */
/** @typedef {{}} Documents_New_IndexInputs */
/** @typedef {{}} Documents_New_Index_ItemInputs */
/** @typedef {{}} Documents_New_MenuInputs */
/** @typedef {{}} Documents_OfflineInputs */
/** @typedef {{}} Documents_OutlineInputs */
/** @typedef {{}} Documents_Outline_HeadingsInputs */
/** @typedef {{}} Documents_Read_Only_ArchivedInputs */
/** @typedef {{}} Documents_Read_Only_NewerInputs */
/** @typedef {{}} Documents_Read_Only_Not_WritableInputs */
/** @typedef {{}} Documents_ReloadInputs */
/** @typedef {{}} Documents_Reload_NeededInputs */
/** @typedef {{}} Documents_Rename_FailedInputs */
/** @typedef {{}} Documents_RestoreInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Restore_BodyInputs */
/** @typedef {{}} Documents_Restore_FailedInputs */
/** @typedef {{ time: NonNullable<unknown> }} Documents_Restore_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Row_MenuInputs */
/** @typedef {{}} Documents_Save_PdfInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_BoldInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_CodeInputs */
/** @typedef {{}} Documents_Selection_Edit_LinkInputs */
/** @typedef {{}} Documents_Selection_FormatInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_ItalicInputs */
/** @typedef {{}} Documents_Selection_LinkInputs */
/** @typedef {{}} Documents_Selection_Link_UrlInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_Open_LinkInputs */
/** @typedef {{}} Documents_Selection_Paste_UrlInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_StrikeInputs */
/** @typedef {{}} Documents_Selection_UnlinkInputs */
/** @typedef {{}} Documents_ShowInputs */
/** @typedef {{}} Documents_Show_ActiveInputs */
/** @typedef {{}} Documents_Show_ArchivedInputs */
/** @typedef {{}} Documents_Slide_NextInputs */
/** @typedef {{}} Documents_Slide_PreviousInputs */
/** @typedef {{}} Documents_SourceInputs */
/** @typedef {{}} Documents_Source_CloseInputs */
/** @typedef {{}} Documents_Source_ConflictInputs */
/** @typedef {{}} Documents_Source_EditInputs */
/** @typedef {{}} Documents_Source_QueryInputs */
/** @typedef {{}} Documents_Source_Query_FailedInputs */
/** @typedef {{}} Documents_Source_SaveInputs */
/** @typedef {{}} Documents_Source_Save_FailedInputs */
/** @typedef {{}} Documents_Source_SavedInputs */
/** @typedef {{}} Documents_Suggest_EmptyInputs */
/** @typedef {{}} Documents_TitleInputs */
/** @typedef {{}} Documents_Title_PlaceholderInputs */
/** @typedef {{}} Documents_UnarchiveInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Unarchive_FailedInputs */
/** @typedef {{}} Documents_UntitledInputs */
/** @typedef {{ live: NonNullable<unknown>, candidate: NonNullable<unknown> }} Editor_Diff_Block_CountInputs */
/** @typedef {{}} Editor_Excerpt_CalloutInputs */
/** @typedef {{}} Editor_Excerpt_CodeInputs */
/** @typedef {{}} Editor_Excerpt_EmptyInputs */
/** @typedef {{}} Editor_Excerpt_HtmlInputs */
/** @typedef {{}} Editor_Excerpt_MermaidInputs */
/** @typedef {{}} Editor_Excerpt_RuleInputs */
/** @typedef {{}} Editor_Excerpt_TableInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Shape_Attr_DiffersInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Editor_Shape_Block_Count_DiffersInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Editor_Shape_Child_Count_DiffersInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Editor_Shape_Type_DiffersInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Table_Option_Fix_RangeInputs */
/** @typedef {{}} Editor_Table_Option_ShapeInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Table_Option_TwiceInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Table_Option_Unknown_KeyInputs */
/** @typedef {{}} Editor_Table_Option_WidthsInputs */
/** @typedef {{}} Editor_Toggle_Body_PlaceholderInputs */
/** @typedef {{}} Editor_Toggle_Summary_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Inbox_Answered_By_ParentInputs */
/** @typedef {{}} Inbox_CaseInputs */
/** @typedef {{}} Inbox_Case_AllInputs */
/** @typedef {{}} Inbox_ChatInputs */
/** @typedef {{}} Inbox_Chat_AllInputs */
/** @typedef {{}} Inbox_DoneInputs */
/** @typedef {{}} Inbox_Done_By_AgentInputs */
/** @typedef {{}} Inbox_Done_EmptyInputs */
/** @typedef {{}} Inbox_DotInputs */
/** @typedef {{ name: NonNullable<unknown> }} Inbox_FromInputs */
/** @typedef {{}} Inbox_GoInputs */
/** @typedef {{}} Inbox_Kind_DmInputs */
/** @typedef {{}} Inbox_Kind_MentionInputs */
/** @typedef {{}} Inbox_Kind_QuestionInputs */
/** @typedef {{}} Inbox_Kind_ReplyInputs */
/** @typedef {{}} Inbox_Load_FailedInputs */
/** @typedef {{}} Inbox_NarrowInputs */
/** @typedef {{}} Inbox_Narrow_PlaceholderInputs */
/** @typedef {{}} Inbox_NavInputs */
/** @typedef {{}} Inbox_No_MatchInputs */
/** @typedef {{}} Inbox_NowInputs */
/** @typedef {{}} Inbox_Now_EmptyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Inbox_UnreadInputs */
/** @typedef {{}} Inbox_WithdrawnInputs */
/** @typedef {{}} Inbox_Workspace_UnreachableInputs */
/** @typedef {{}} Inbox_Workspace_Unreachable_EmptyInputs */
/** @typedef {{}} Inbox_Workspace_Unreachable_WhyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Color_CustomInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Color_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Color_OfInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Create_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Create_NamedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_DeleteInputs */
/** @typedef {{}} Labels_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Delete_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Delete_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Move_DownInputs */
/** @typedef {{}} Labels_Move_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Move_UpInputs */
/** @typedef {{}} Labels_NameInputs */
/** @typedef {{}} Labels_NewInputs */
/** @typedef {{}} Labels_Pick_EmptyInputs */
/** @typedef {{}} Labels_Pick_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Rename_FailedInputs */
/** @typedef {{}} Labels_Settings_DescriptionInputs */
/** @typedef {{}} Labels_TitleInputs */
/** @typedef {{}} Local_Agent_DiagramInputs */
/** @typedef {{}} Local_Agent_Diagram_BrowserInputs */
/** @typedef {{}} Local_Agent_Diagram_CarrierInputs */
/** @typedef {{}} Local_Agent_Diagram_Carrier_NoteInputs */
/** @typedef {{}} Local_Agent_Diagram_DevicesInputs */
/** @typedef {{}} Local_Agent_Diagram_In_ListInputs */
/** @typedef {{}} Local_Agent_Diagram_RefusedInputs */
/** @typedef {{}} Local_Agent_Diagram_SignedInputs */
/** @typedef {{}} Local_Agent_Diagram_This_AppInputs */
/** @typedef {{}} Local_Agent_Help_BrowserInputs */
/** @typedef {{}} Local_Agent_Help_SignedInputs */
/** @typedef {{}} Local_Agent_Help_TitleInputs */
/** @typedef {{}} Local_Agent_OthersInputs */
/** @typedef {{}} Local_Agent_Others_NoteInputs */
/** @typedef {{}} Local_Agent_Others_Off_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Agent_Others_Vault_Off_NoteInputs */
/** @typedef {{}} Local_Agent_UseInputs */
/** @typedef {{}} Local_Agent_Use_NoteInputs */
/** @typedef {{}} Local_BackupInputs */
/** @typedef {{}} Local_Backup_ChooseInputs */
/** @typedef {{}} Local_Backup_DefaultInputs */
/** @typedef {{}} Local_Backup_DescriptionInputs */
/** @typedef {{}} Local_Backup_Error_FailedInputs */
/** @typedef {{}} Local_Backup_Error_Inside_DataInputs */
/** @typedef {{}} Local_Backup_Error_Not_AbsoluteInputs */
/** @typedef {{}} Local_Backup_Error_Not_WritableInputs */
/** @typedef {{}} Local_Backup_FailedInputs */
/** @typedef {{}} Local_Backup_FolderInputs */
/** @typedef {{}} Local_Backup_Folder_NoteInputs */
/** @typedef {{}} Local_Backup_LastInputs */
/** @typedef {{}} Local_Backup_MissingInputs */
/** @typedef {{}} Local_Backup_NoneInputs */
/** @typedef {{}} Local_Backup_Not_WritableInputs */
/** @typedef {{}} Local_Backup_PathInputs */
/** @typedef {{}} Local_Backup_ResetInputs */
/** @typedef {{}} Local_Backup_UseInputs */
/** @typedef {{}} Local_CloudInputs */
/** @typedef {{}} Local_Cloud_AccountInputs */
/** @typedef {{}} Local_Cloud_Account_SettingsInputs */
/** @typedef {{}} Local_Cloud_Account_Settings_DescriptionInputs */
/** @typedef {{}} Local_Cloud_Again_DoneInputs */
/** @typedef {{}} Local_Cloud_Agent_FailedInputs */
/** @typedef {{}} Local_Cloud_Agent_RemovedInputs */
/** @typedef {{}} Local_Cloud_Code_NoteInputs */
/** @typedef {{}} Local_Cloud_DeniedInputs */
/** @typedef {{}} Local_Cloud_DescriptionInputs */
/** @typedef {{}} Local_Cloud_DeviceInputs */
/** @typedef {{}} Local_Cloud_Device_DoneInputs */
/** @typedef {{}} Local_Cloud_Device_Hub_Not_TiedInputs */
/** @typedef {{}} Local_Cloud_Device_Hub_UnreachableInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_Device_InInputs */
/** @typedef {{ hub: NonNullable<unknown>, mine: NonNullable<unknown> }} Local_Cloud_Device_MismatchInputs */
/** @typedef {{}} Local_Cloud_Device_Needs_HubInputs */
/** @typedef {{}} Local_Cloud_Device_NoneInputs */
/** @typedef {{ account: NonNullable<unknown>, tied: NonNullable<unknown> }} Local_Cloud_Device_OtherInputs */
/** @typedef {{}} Local_Cloud_ExpiredInputs */
/** @typedef {{}} Local_Cloud_FrameInputs */
/** @typedef {{}} Local_Cloud_Frame_Signed_Out_BodyInputs */
/** @typedef {{ from: NonNullable<unknown> }} Local_Cloud_From_LoginInputs */
/** @typedef {{}} Local_Cloud_Hub_AwayInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Cloud_Hub_RowInputs */
/** @typedef {{}} Local_Cloud_Hub_TokenInputs */
/** @typedef {{}} Local_Cloud_LinkedInputs */
/** @typedef {{}} Local_Cloud_LoginInputs */
/** @typedef {{}} Local_Cloud_Login_AgainInputs */
/** @typedef {{}} Local_Cloud_LogoutInputs */
/** @typedef {{}} Local_Cloud_Logout_BodyInputs */
/** @typedef {{}} Local_Cloud_Logout_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_Logout_TitleInputs */
/** @typedef {{}} Local_Cloud_NoneInputs */
/** @typedef {{}} Local_Cloud_OpenInputs */
/** @typedef {{ account: NonNullable<unknown>, tied: NonNullable<unknown> }} Local_Cloud_OtherInputs */
/** @typedef {{}} Local_Cloud_RestartingInputs */
/** @typedef {{}} Local_Cloud_RetryInputs */
/** @typedef {{}} Local_Cloud_Signed_Out_BodyInputs */
/** @typedef {{}} Local_Cloud_Signed_Out_OpenInputs */
/** @typedef {{}} Local_Cloud_Signed_Out_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_TiedInputs */
/** @typedef {{}} Local_Cloud_UnlinkInputs */
/** @typedef {{}} Local_Cloud_Unlink_BodyInputs */
/** @typedef {{}} Local_Cloud_Unlink_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_Unlink_TitleInputs */
/** @typedef {{}} Local_Cloud_UnreachableInputs */
/** @typedef {{}} Local_Cloud_Unreached_BodyInputs */
/** @typedef {{}} Local_Cloud_Unreached_TitleInputs */
/** @typedef {{}} Local_Cloud_WaitingInputs */
/** @typedef {{}} Local_DmsInputs */
/** @typedef {{}} Local_Dms_UnreadInputs */
/** @typedef {{ dir: NonNullable<unknown> }} Local_Headless_Backup_DirInputs */
/** @typedef {{ dir: NonNullable<unknown>, reason: NonNullable<unknown> }} Local_Headless_Backup_Dir_RefusedInputs */
/** @typedef {{ addresses: NonNullable<unknown> }} Local_Headless_Connect_ToInputs */
/** @typedef {{ app: NonNullable<unknown>, error: NonNullable<unknown> }} Local_Headless_Could_Not_StartInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_LinkedInputs */
/** @typedef {{ account: NonNullable<unknown> }} Local_Headless_Login_AgainInputs */
/** @typedef {{ account: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Login_BoundInputs */
/** @typedef {{}} Local_Headless_Login_DeniedInputs */
/** @typedef {{}} Local_Headless_Login_ExpiredInputs */
/** @typedef {{ error: NonNullable<unknown> }} Local_Headless_Login_FailedInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Login_LinkedInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Login_Not_RunningInputs */
/** @typedef {{ url: NonNullable<unknown>, code: NonNullable<unknown>, minutes: NonNullable<unknown> }} Local_Headless_Login_OpenInputs */
/** @typedef {{ account: NonNullable<unknown>, tied: NonNullable<unknown> }} Local_Headless_Login_OtherInputs */
/** @typedef {{}} Local_Headless_Login_WaitingInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Others_Not_RunningInputs */
/** @typedef {{}} Local_Headless_Others_OffInputs */
/** @typedef {{}} Local_Headless_Others_OnInputs */
/** @typedef {{}} Local_Headless_Others_UsageInputs */
/** @typedef {{ error: NonNullable<unknown> }} Local_Headless_Pair_FailedInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Pair_No_PairingInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Pair_Not_RunningInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown>, port: NonNullable<unknown> }} Local_Headless_Pair_Port_In_UseInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Pair_Remote_OffInputs */
/** @typedef {{ minutes: NonNullable<unknown>, code: NonNullable<unknown> }} Local_Headless_Pairing_CodeInputs */
/** @typedef {{ port: NonNullable<unknown> }} Local_Headless_PortInputs */
/** @typedef {{ port: NonNullable<unknown>, error: NonNullable<unknown> }} Local_Headless_Port_In_UseInputs */
/** @typedef {{ time: NonNullable<unknown> }} Local_Headless_RestoredInputs */
/** @typedef {{ app: NonNullable<unknown>, dir: NonNullable<unknown> }} Local_Headless_RunningInputs */
/** @typedef {{ account: NonNullable<unknown> }} Local_Headless_Unlink_DoneInputs */
/** @typedef {{}} Local_Headless_Unlink_NoneInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Unlink_Not_RunningInputs */
/** @typedef {{}} Local_Link_ConnectedInputs */
/** @typedef {{}} Local_Link_Connected_CloudInputs */
/** @typedef {{ where: NonNullable<unknown> }} Local_Link_Connected_ViaInputs */
/** @typedef {{}} Local_Link_ConnectingInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Hub_DoorInputs */
/** @typedef {{}} Local_Link_Hub_Door_AwayInputs */
/** @typedef {{}} Local_Link_Hub_Door_Not_TiedInputs */
/** @typedef {{}} Local_Link_Hub_Door_NoteInputs */
/** @typedef {{}} Local_Link_Hub_Door_Via_CloudInputs */
/** @typedef {{}} Local_Link_Invalid_CodeInputs */
/** @typedef {{}} Local_Link_Is_HubInputs */
/** @typedef {{}} Local_Link_JoinInputs */
/** @typedef {{}} Local_Link_Join_ButtonInputs */
/** @typedef {{}} Local_Link_Join_NoteInputs */
/** @typedef {{}} Local_Link_LeaveInputs */
/** @typedef {{}} Local_Link_Leave_BodyInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Leave_TitleInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_MainInputs */
/** @typedef {{}} Local_Link_Network_SettingsInputs */
/** @typedef {{}} Local_Link_Open_SettingsInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_ReconnectingInputs */
/** @typedef {{}} Local_Link_Reconnecting_Not_ListeningInputs */
/** @typedef {{}} Local_Link_Reconnecting_Sign_InInputs */
/** @typedef {{}} Local_Link_RefusedInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_RemovedInputs */
/** @typedef {{}} Local_Link_Removed_ShortInputs */
/** @typedef {{}} Local_Link_RoutesInputs */
/** @typedef {{}} Local_Link_Routes_Cloud_HomeInputs */
/** @typedef {{}} Local_Link_Routes_No_Sign_InInputs */
/** @typedef {{}} Local_Link_Routes_NoteInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Screen_App_OutdatedInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Screen_Hub_OutdatedInputs */
/** @typedef {{}} Local_Link_UnreachableInputs */
/** @typedef {{}} Local_Link_Unreachable_MacInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Unreachable_NowInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Write_FailedInputs */
/** @typedef {{}} Local_McpInputs */
/** @typedef {{}} Local_Mcp_Claude_Code_NoteInputs */
/** @typedef {{}} Local_Mcp_Claude_Desktop_NoteInputs */
/** @typedef {{}} Local_Mcp_Codex_NoteInputs */
/** @typedef {{}} Local_Mcp_CopiedInputs */
/** @typedef {{}} Local_Mcp_CopyInputs */
/** @typedef {{}} Local_Mcp_Copy_FailedInputs */
/** @typedef {{}} Local_Mcp_DescriptionInputs */
/** @typedef {{}} Local_Mcp_Load_FailedInputs */
/** @typedef {{}} Local_Mcp_RetryInputs */
/** @typedef {{}} Local_Mcp_UnavailableInputs */
/** @typedef {{}} Local_Me_CancelInputs */
/** @typedef {{}} Local_Me_Cancel_BodyInputs */
/** @typedef {{}} Local_Me_Cancel_TitleInputs */
/** @typedef {{}} Local_Me_CancelledInputs */
/** @typedef {{}} Local_Me_ChangesInputs */
/** @typedef {{}} Local_Me_Check_Far_NoteInputs */
/** @typedef {{}} Local_Me_Check_Far_TitleInputs */
/** @typedef {{}} Local_Me_Check_Google_NoteInputs */
/** @typedef {{}} Local_Me_Check_Google_TitleInputs */
/** @typedef {{}} Local_Me_Check_Hub_Agents_NoteInputs */
/** @typedef {{}} Local_Me_Check_Hub_Agents_TitleInputs */
/** @typedef {{}} Local_Me_Check_Phone_NoteInputs */
/** @typedef {{}} Local_Me_Check_Phone_TitleInputs */
/** @typedef {{}} Local_Me_Check_Published_NoteInputs */
/** @typedef {{}} Local_Me_Check_Published_TitleInputs */
/** @typedef {{}} Local_Me_Check_Sandbox_NoteInputs */
/** @typedef {{}} Local_Me_Check_Sandbox_TitleInputs */
/** @typedef {{}} Local_Me_Check_Web_GetsInputs */
/** @typedef {{}} Local_Me_Check_Web_LosesInputs */
/** @typedef {{}} Local_Me_Check_Web_TitleInputs */
/** @typedef {{}} Local_Me_Elsewhere_BodyInputs */
/** @typedef {{}} Local_Me_Elsewhere_TitleInputs */
/** @typedef {{ length: NonNullable<unknown> }} Local_Me_EstimateInputs */
/** @typedef {{}} Local_Me_Estimate_LongInputs */
/** @typedef {{}} Local_Me_Estimate_MinuteInputs */
/** @typedef {{}} Local_Me_Estimate_MinutesInputs */
/** @typedef {{}} Local_Me_Estimate_SecondsInputs */
/** @typedef {{ message: NonNullable<unknown> }} Local_Me_FailedInputs */
/** @typedef {{}} Local_Me_Failed_ChangedInputs */
/** @typedef {{}} Local_Me_Failed_LimitInputs */
/** @typedef {{}} Local_Me_Failed_UnreachableInputs */
/** @typedef {{ time: NonNullable<unknown>, place: NonNullable<unknown> }} Local_Me_FinishedInputs */
/** @typedef {{ time: NonNullable<unknown>, what: NonNullable<unknown>, place: NonNullable<unknown> }} Local_Me_Finished_MergeInputs */
/** @typedef {{}} Local_Me_Finished_Place_CloudInputs */
/** @typedef {{}} Local_Me_Finished_Place_HubInputs */
/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Local_Me_Finished_WhatInputs */
/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Local_Me_Finished_What_MoreInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Me_Item_CreatedInputs */
/** @typedef {{}} Local_Me_MergeInputs */
/** @typedef {{}} Local_Me_Merge_BodyInputs */
/** @typedef {{}} Local_Me_Merge_From_CloudInputs */
/** @typedef {{}} Local_Me_Merge_From_HubInputs */
/** @typedef {{}} Local_Me_Merge_KeptInputs */
/** @typedef {{}} Local_Me_Merge_LabelsInputs */
/** @typedef {{}} Local_Me_Merge_NoneInputs */
/** @typedef {{}} Local_Me_Merge_PersonsInputs */
/** @typedef {{}} Local_Me_Merge_Persons_NoteInputs */
/** @typedef {{}} Local_Me_Merge_To_CloudInputs */
/** @typedef {{}} Local_Me_Merge_To_Cloud_TitleInputs */
/** @typedef {{}} Local_Me_Merge_To_HubInputs */
/** @typedef {{}} Local_Me_Merge_To_Hub_TitleInputs */
/** @typedef {{}} Local_Me_Move_BodyInputs */
/** @typedef {{}} Local_Me_MovesInputs */
/** @typedef {{}} Local_Me_Moving_DigestInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Local_Me_Moving_Digest_OfInputs */
/** @typedef {{}} Local_Me_Moving_FilesInputs */
/** @typedef {{}} Local_Me_Moving_MergeInputs */
/** @typedef {{}} Local_Me_Moving_NoteInputs */
/** @typedef {{}} Local_Me_Moving_SendInputs */
/** @typedef {{}} Local_Me_Moving_VerifyInputs */
/** @typedef {{}} Local_Me_PlaceInputs */
/** @typedef {{}} Local_Me_Place_Both_NowInputs */
/** @typedef {{}} Local_Me_Place_CloudInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Me_Place_Cloud_CopyInputs */
/** @typedef {{}} Local_Me_Place_Cloud_OnlyInputs */
/** @typedef {{}} Local_Me_Place_HubInputs */
/** @typedef {{}} Local_Me_Place_Other_HubInputs */
/** @typedef {{}} Local_Me_Place_UnreachableInputs */
/** @typedef {{}} Local_Me_Place_UpdateInputs */
/** @typedef {{}} Local_Me_Queue_CancelInputs */
/** @typedef {{ ahead: NonNullable<unknown>, minutes: NonNullable<unknown> }} Local_Me_QueuedInputs */
/** @typedef {{}} Local_Me_Queued_NoteInputs */
/** @typedef {{ ahead: NonNullable<unknown> }} Local_Me_Queued_SoonInputs */
/** @typedef {{}} Local_Me_RetryInputs */
/** @typedef {{}} Local_Me_Side_CloudInputs */
/** @typedef {{}} Local_Me_Side_HubInputs */
/** @typedef {{}} Local_Me_StoppedInputs */
/** @typedef {{ minutes: NonNullable<unknown>, seconds: NonNullable<unknown> }} Local_Me_Time_MinutesInputs */
/** @typedef {{ seconds: NonNullable<unknown> }} Local_Me_Time_SecondsInputs */
/** @typedef {{}} Local_Me_To_CloudInputs */
/** @typedef {{}} Local_Me_To_Cloud_TitleInputs */
/** @typedef {{}} Local_Me_To_HubInputs */
/** @typedef {{}} Local_Me_To_Hub_TitleInputs */
/** @typedef {{}} Local_Me_UntitledInputs */
/** @typedef {{}} Local_MenubarInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Menubar_AgentInputs */
/** @typedef {{}} Local_Menubar_Agent_Cloud_OffInputs */
/** @typedef {{}} Local_Menubar_Agent_Cloud_OnInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Agent_Hub_OnInputs */
/** @typedef {{}} Local_Menubar_Agent_UnusedInputs */
/** @typedef {{}} Local_Menubar_Cloud_Signed_InInputs */
/** @typedef {{}} Local_Menubar_DescriptionInputs */
/** @typedef {{ count: NonNullable<unknown> }} Local_Menubar_Hub_DevicesInputs */
/** @typedef {{}} Local_Menubar_Hub_ListeningInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Hub_OffInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Hub_OnInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Hub_On_CloudInputs */
/** @typedef {{ main: NonNullable<unknown>, where: NonNullable<unknown> }} Local_Menubar_Hub_On_WhereInputs */
/** @typedef {{}} Local_Menubar_Hub_Port_In_UseInputs */
/** @typedef {{}} Local_Menubar_IconInputs */
/** @typedef {{}} Local_Menubar_Icon_LogoInputs */
/** @typedef {{}} Local_Menubar_Icon_NoteInputs */
/** @typedef {{}} Local_Menubar_Icon_UsageInputs */
/** @typedef {{}} Local_Menubar_ProviderInputs */
/** @typedef {{}} Local_Menubar_Provider_NoteInputs */
/** @typedef {{}} Local_Menubar_Provider_Note_UnusedInputs */
/** @typedef {{}} Local_Menubar_ShowInputs */
/** @typedef {{}} Local_Menubar_Show_NoteInputs */
/** @typedef {{}} Local_Notice_Cloud_LoginInputs */
/** @typedef {{ from: NonNullable<unknown>, name: NonNullable<unknown> }} Local_Notice_Cloud_Login_BodyInputs */
/** @typedef {{ chat: NonNullable<unknown> }} Local_Notice_FailedInputs */
/** @typedef {{}} Local_Notice_Failed_BodyInputs */
/** @typedef {{ chat: NonNullable<unknown> }} Local_Notice_ReplyInputs */
/** @typedef {{ chat: NonNullable<unknown> }} Local_Notice_TurnInputs */
/** @typedef {{}} Local_Open_In_New_WindowInputs */
/** @typedef {{}} Local_RailInputs */
/** @typedef {{}} Local_Rail_NewInputs */
/** @typedef {{}} Local_ReleaseInputs */
/** @typedef {{}} Local_Release_ActionInputs */
/** @typedef {{}} Local_Release_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Local_Release_FailedInputs */
/** @typedef {{}} Local_Release_No_SpaceInputs */
/** @typedef {{}} Local_Release_NoneInputs */
/** @typedef {{}} Local_Release_SpaceInputs */
/** @typedef {{ title: NonNullable<unknown> }} Local_Release_TitleInputs */
/** @typedef {{}} Local_Release_UnavailableInputs */
/** @typedef {{}} Local_Release_WorkspaceInputs */
/** @typedef {{ title: NonNullable<unknown>, workspace: NonNullable<unknown> }} Local_ReleasedInputs */
/** @typedef {{}} Local_RemoteInputs */
/** @typedef {{}} Local_Remote_AddInputs */
/** @typedef {{}} Local_Remote_Add_NoteInputs */
/** @typedef {{}} Local_Remote_CloudInputs */
/** @typedef {{}} Local_Remote_Cloud_ConnectingInputs */
/** @typedef {{}} Local_Remote_Cloud_Needs_TieInputs */
/** @typedef {{}} Local_Remote_Cloud_NoteInputs */
/** @typedef {{}} Local_Remote_Cloud_OpenInputs */
/** @typedef {{}} Local_Remote_Cloud_RefusedInputs */
/** @typedef {{}} Local_Remote_CodeInputs */
/** @typedef {{}} Local_Remote_ConnectedInputs */
/** @typedef {{ where: NonNullable<unknown> }} Local_Remote_Connected_FromInputs */
/** @typedef {{}} Local_Remote_DescriptionInputs */
/** @typedef {{}} Local_Remote_DevicesInputs */
/** @typedef {{}} Local_Remote_Devices_NoneInputs */
/** @typedef {{}} Local_Remote_FailedInputs */
/** @typedef {{}} Local_Remote_LinkedInputs */
/** @typedef {{}} Local_Remote_ListenInputs */
/** @typedef {{}} Local_Remote_Listen_NoteInputs */
/** @typedef {{ port: NonNullable<unknown> }} Local_Remote_Port_In_UseInputs */
/** @typedef {{}} Local_Remote_RemoveInputs */
/** @typedef {{}} Local_Remote_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Remote_Remove_TitleInputs */
/** @typedef {{}} Local_Remote_RetryInputs */
/** @typedef {{}} Local_Route_AnywhereInputs */
/** @typedef {{}} Local_Route_Client_Cloud_HomeInputs */
/** @typedef {{}} Local_Route_Client_DiagramInputs */
/** @typedef {{}} Local_Route_Client_NeedsInputs */
/** @typedef {{}} Local_Route_Client_TitleInputs */
/** @typedef {{}} Local_Route_DevicesInputs */
/** @typedef {{}} Local_Route_DirectInputs */
/** @typedef {{}} Local_Route_Direct_FirstInputs */
/** @typedef {{}} Local_Route_HelpInputs */
/** @typedef {{}} Local_Route_Help_CloseInputs */
/** @typedef {{}} Local_Route_HubInputs */
/** @typedef {{}} Local_Route_Hub_Cloud_HomeInputs */
/** @typedef {{}} Local_Route_Hub_CopyInputs */
/** @typedef {{}} Local_Route_Hub_DiagramInputs */
/** @typedef {{}} Local_Route_Hub_First_DirectInputs */
/** @typedef {{}} Local_Route_Hub_Paired_OnlyInputs */
/** @typedef {{}} Local_Route_Hub_TitleInputs */
/** @typedef {{}} Local_Route_NetworkInputs */
/** @typedef {{}} Local_Route_Network_NoteInputs */
/** @typedef {{}} Local_Route_OffInputs */
/** @typedef {{}} Local_Route_OutsideInputs */
/** @typedef {{}} Local_Route_Personal_DataInputs */
/** @typedef {{}} Local_Route_RelayInputs */
/** @typedef {{}} Local_Route_Relay_NoteInputs */
/** @typedef {{}} Local_Route_SealedInputs */
/** @typedef {{}} Local_Route_This_AgentInputs */
/** @typedef {{}} Local_Route_This_HubInputs */
/** @typedef {{}} Local_Route_This_Hub_NoteInputs */
/** @typedef {{}} Local_Route_This_PcInputs */
/** @typedef {{}} Local_Setting_Change_FailedInputs */
/** @typedef {{}} Local_TrustInputs */
/** @typedef {{}} Local_Trust_AcceptInputs */
/** @typedef {{ name: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Accept_BodyInputs */
/** @typedef {{}} Local_Trust_Accept_ButtonInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Accept_FirstInputs */
/** @typedef {{}} Local_Trust_Accept_NoteInputs */
/** @typedef {{}} Local_Trust_Accept_TitleInputs */
/** @typedef {{}} Local_Trust_AddInputs */
/** @typedef {{}} Local_Trust_Add_AnotherInputs */
/** @typedef {{}} Local_Trust_Add_ButtonInputs */
/** @typedef {{}} Local_Trust_Add_NoteInputs */
/** @typedef {{}} Local_Trust_Agent_ProblemInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Agent_SettingsInputs */
/** @typedef {{}} Local_Trust_Already_MemberInputs */
/** @typedef {{}} Local_Trust_Approve_AddingInputs */
/** @typedef {{}} Local_Trust_Approve_ButtonInputs */
/** @typedef {{}} Local_Trust_Approve_CompareInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Approve_DoneInputs */
/** @typedef {{}} Local_Trust_Approve_FindingInputs */
/** @typedef {{}} Local_Trust_CandidatesInputs */
/** @typedef {{}} Local_Trust_Candidates_NoteInputs */
/** @typedef {{}} Local_Trust_Cli_AcceptedInputs */
/** @typedef {{}} Local_Trust_Cli_Agent_ProblemInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cli_Approve_DoneInputs */
/** @typedef {{}} Local_Trust_Cli_Approve_FindingInputs */
/** @typedef {{ name: NonNullable<unknown>, kind: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Cli_Approve_PeerInputs */
/** @typedef {{ list: NonNullable<unknown>, name: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Cli_AvailableInputs */
/** @typedef {{ fingerprint: NonNullable<unknown> }} Local_Trust_Cli_CompareInputs */
/** @typedef {{}} Local_Trust_Cli_CreatedInputs */
/** @typedef {{ error: NonNullable<unknown> }} Local_Trust_Cli_FailedInputs */
/** @typedef {{ fingerprint: NonNullable<unknown> }} Local_Trust_Cli_FingerprintInputs */
/** @typedef {{ minutes: NonNullable<unknown>, code: NonNullable<unknown> }} Local_Trust_Cli_InviteInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_ApprovedInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_DeclinedInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_ExpiredInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cli_Invite_ProvedInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_RefusedInputs */
/** @typedef {{}} Local_Trust_Cli_Keys_MadeInputs */
/** @typedef {{ n: NonNullable<unknown> }} Local_Trust_Cli_ListInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Trust_Cli_MadeInputs */
/** @typedef {{}} Local_Trust_Cli_No_ListInputs */
/** @typedef {{}} Local_Trust_Cli_No_ListsInputs */
/** @typedef {{ what: NonNullable<unknown> }} Local_Trust_Cli_Not_FoundInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Trust_Cli_Not_RunningInputs */
/** @typedef {{ app: NonNullable<unknown> }} Local_Trust_Cli_OthersInputs */
/** @typedef {{}} Local_Trust_Cli_Pair_NoteInputs */
/** @typedef {{}} Local_Trust_Cli_PassphraseInputs */
/** @typedef {{}} Local_Trust_Cli_Passphrase_AgainInputs */
/** @typedef {{}} Local_Trust_Cli_Passphrase_MismatchInputs */
/** @typedef {{ min: NonNullable<unknown> }} Local_Trust_Cli_Passphrase_NewInputs */
/** @typedef {{ place: NonNullable<unknown> }} Local_Trust_Cli_ProblemInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cli_Remove_DoneInputs */
/** @typedef {{}} Local_Trust_Cli_SwitchInputs */
/** @typedef {{}} Local_Trust_Cli_SwitchedInputs */
/** @typedef {{ app: NonNullable<unknown> }} Local_Trust_Cli_UsageInputs */
/** @typedef {{}} Local_Trust_Cli_WaitingInputs */
/** @typedef {{}} Local_Trust_Cli_Wrong_PassphraseInputs */
/** @typedef {{}} Local_Trust_CloudInputs */
/** @typedef {{}} Local_Trust_Cloud_AddInputs */
/** @typedef {{}} Local_Trust_Cloud_Add_When_ReadyInputs */
/** @typedef {{}} Local_Trust_Cloud_AddingInputs */
/** @typedef {{}} Local_Trust_Cloud_CreateInputs */
/** @typedef {{}} Local_Trust_Cloud_Create_LimitInputs */
/** @typedef {{}} Local_Trust_Cloud_DeleteInputs */
/** @typedef {{}} Local_Trust_Cloud_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cloud_Delete_TitleInputs */
/** @typedef {{}} Local_Trust_Cloud_FailedInputs */
/** @typedef {{}} Local_Trust_Cloud_Name_DevInputs */
/** @typedef {{}} Local_Trust_Cloud_Name_GeneralInputs */
/** @typedef {{}} Local_Trust_Cloud_NoneInputs */
/** @typedef {{}} Local_Trust_Cloud_NoteInputs */
/** @typedef {{}} Local_Trust_Cloud_Other_ListInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_AsleepInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_DeletingInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_ErrorInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_PreparingInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_QueuedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Local_Trust_Cloud_Phase_Queued_AtInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_RemakingInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_RunningInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_StartingInputs */
/** @typedef {{}} Local_Trust_Cloud_RemakeInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cloud_Remake_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cloud_Remake_TitleInputs */
/** @typedef {{}} Local_Trust_Cloud_UnlistedInputs */
/** @typedef {{}} Local_Trust_Cloud_Update_ClisInputs */
/** @typedef {{}} Local_Trust_Cloud_UpdatingInputs */
/** @typedef {{}} Local_Trust_Cloud_WakeInputs */
/** @typedef {{}} Local_Trust_Cloud_Wake_To_AddInputs */
/** @typedef {{}} Local_Trust_CodeInputs */
/** @typedef {{}} Local_Trust_Code_ExpiredInputs */
/** @typedef {{}} Local_Trust_CreateInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Create_Again_BodyInputs */
/** @typedef {{}} Local_Trust_Create_Again_NoteInputs */
/** @typedef {{}} Local_Trust_Create_Again_TitleInputs */
/** @typedef {{}} Local_Trust_Create_ButtonInputs */
/** @typedef {{}} Local_Trust_Create_NoteInputs */
/** @typedef {{}} Local_Trust_DeclineInputs */
/** @typedef {{}} Local_Trust_DescriptionInputs */
/** @typedef {{}} Local_Trust_Device_Not_FoundInputs */
/** @typedef {{}} Local_Trust_FailedInputs */
/** @typedef {{}} Local_Trust_GuideInputs */
/** @typedef {{}} Local_Trust_Guide_AddInputs */
/** @typedef {{}} Local_Trust_Guide_Add_ThisInputs */
/** @typedef {{}} Local_Trust_Guide_AgentInputs */
/** @typedef {{}} Local_Trust_Guide_Agent_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_By_VaultInputs */
/** @typedef {{}} Local_Trust_Guide_By_Vault_LinkedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_By_Vault_SelfInputs */
/** @typedef {{}} Local_Trust_Guide_Code_GoesInputs */
/** @typedef {{}} Local_Trust_Guide_Create_MadeInputs */
/** @typedef {{}} Local_Trust_Guide_Create_NextInputs */
/** @typedef {{}} Local_Trust_Guide_Create_OnceInputs */
/** @typedef {{}} Local_Trust_Guide_Create_PassphraseInputs */
/** @typedef {{}} Local_Trust_Guide_Create_PressInputs */
/** @typedef {{}} Local_Trust_Guide_Example_PcInputs */
/** @typedef {{}} Local_Trust_Guide_Example_PhoneInputs */
/** @typedef {{}} Local_Trust_Guide_Flow_CheckInputs */
/** @typedef {{}} Local_Trust_Guide_Flow_FromInputs */
/** @typedef {{}} Local_Trust_Guide_Flow_ResultInputs */
/** @typedef {{}} Local_Trust_Guide_FoundInputs */
/** @typedef {{}} Local_Trust_Guide_Found_TrustInputs */
/** @typedef {{}} Local_Trust_Guide_HereInputs */
/** @typedef {{}} Local_Trust_Guide_Here_NameInputs */
/** @typedef {{}} Local_Trust_Guide_In_ListInputs */
/** @typedef {{}} Local_Trust_Guide_Join_FirstInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_HeadlessInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_Headless_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_PcInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_Pc_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_PhoneInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_Phone_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_QuestionInputs */
/** @typedef {{}} Local_Trust_Guide_Member_ScreenInputs */
/** @typedef {{}} Local_Trust_Guide_More_AddInputs */
/** @typedef {{}} Local_Trust_Guide_More_Add_ThisInputs */
/** @typedef {{}} Local_Trust_Guide_More_StartInputs */
/** @typedef {{}} Local_Trust_Guide_New_PcInputs */
/** @typedef {{}} Local_Trust_Guide_New_PhoneInputs */
/** @typedef {{}} Local_Trust_Guide_OthersInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_CloudInputs */
/** @typedef {{}} Local_Trust_Guide_Reach_NoneInputs */
/** @typedef {{}} Local_Trust_Guide_Reach_OutsideInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_SelfInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_Self_CloudInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_VaultInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_Vault_CloudInputs */
/** @typedef {{}} Local_Trust_Guide_RefusedInputs */
/** @typedef {{}} Local_Trust_Guide_RunsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Screen_OfInputs */
/** @typedef {{}} Local_Trust_Guide_StartInputs */
/** @typedef {{}} Local_Trust_Guide_Start_CreateInputs */
/** @typedef {{}} Local_Trust_Guide_Start_Create_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Start_JoinInputs */
/** @typedef {{}} Local_Trust_Guide_Start_Join_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Start_NoneInputs */
/** @typedef {{}} Local_Trust_Guide_Start_QuestionInputs */
/** @typedef {{}} Local_Trust_Guide_Start_UnreachedInputs */
/** @typedef {{}} Local_Trust_Guide_Step_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Step_CompareInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Step_Compare_HeadlessInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Compare_MemberInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Step_EnterInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Enter_MemberInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_HeadlessInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_HereInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_PcInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_PhoneInputs */
/** @typedef {{ code: NonNullable<unknown> }} Local_Trust_Guide_Term_CodeInputs */
/** @typedef {{}} Local_Trust_Guide_WhatInputs */
/** @typedef {{}} Local_Trust_Guide_What_BodyInputs */
/** @typedef {{}} Local_Trust_Guide_WhereInputs */
/** @typedef {{}} Local_Trust_Invalid_CodeInputs */
/** @typedef {{}} Local_Trust_InviteInputs */
/** @typedef {{}} Local_Trust_Invite_ApprovedInputs */
/** @typedef {{}} Local_Trust_Invite_ButtonInputs */
/** @typedef {{}} Local_Trust_Invite_DeclinedInputs */
/** @typedef {{}} Local_Trust_Invite_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Invite_ProvedInputs */
/** @typedef {{}} Local_Trust_Invite_RefusedInputs */
/** @typedef {{}} Local_Trust_Invite_WaitingInputs */
/** @typedef {{}} Local_Trust_Kind_CloudInputs */
/** @typedef {{}} Local_Trust_Kind_PcInputs */
/** @typedef {{}} Local_Trust_Kind_PhoneInputs */
/** @typedef {{}} Local_Trust_Last_ApproverInputs */
/** @typedef {{}} Local_Trust_LeftInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Trust_List_MadeInputs */
/** @typedef {{}} Local_Trust_MembersInputs */
/** @typedef {{}} Local_Trust_Members_NoteInputs */
/** @typedef {{}} Local_Trust_Members_Note_OutsideInputs */
/** @typedef {{}} Local_Trust_Members_Note_ReceiverInputs */
/** @typedef {{}} Local_Trust_No_KeysInputs */
/** @typedef {{}} Local_Trust_No_PlaceInputs */
/** @typedef {{}} Local_Trust_No_Place_FailedInputs */
/** @typedef {{}} Local_Trust_OutsideInputs */
/** @typedef {{}} Local_Trust_Outside_Not_TakingInputs */
/** @typedef {{}} Local_Trust_Outside_NoteInputs */
/** @typedef {{}} Local_Trust_Outside_Page_NoteInputs */
/** @typedef {{}} Local_Trust_PassphraseInputs */
/** @typedef {{}} Local_Trust_Passphrase_AgainInputs */
/** @typedef {{}} Local_Trust_Passphrase_Ask_BodyInputs */
/** @typedef {{}} Local_Trust_Passphrase_Ask_ButtonInputs */
/** @typedef {{}} Local_Trust_Passphrase_Ask_TitleInputs */
/** @typedef {{}} Local_Trust_Passphrase_MismatchInputs */
/** @typedef {{}} Local_Trust_Passphrase_New_NoteInputs */
/** @typedef {{}} Local_Trust_Passphrase_Set_TitleInputs */
/** @typedef {{}} Local_Trust_Passphrase_ShortInputs */
/** @typedef {{}} Local_Trust_ProblemInputs */
/** @typedef {{}} Local_Trust_Receiver_MarkInputs */
/** @typedef {{}} Local_Trust_RemoveInputs */
/** @typedef {{}} Local_Trust_Remove_BodyInputs */
/** @typedef {{}} Local_Trust_Remove_Self_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Remove_TitleInputs */
/** @typedef {{}} Local_Trust_SwitchInputs */
/** @typedef {{ name: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Switch_BodyInputs */
/** @typedef {{}} Local_Trust_Switch_ButtonInputs */
/** @typedef {{}} Local_Trust_Switch_NoteInputs */
/** @typedef {{}} Local_Trust_Switch_TitleInputs */
/** @typedef {{}} Local_Trust_This_DeviceInputs */
/** @typedef {{}} Local_Trust_This_Device_MarkInputs */
/** @typedef {{}} Local_Trust_This_Device_NoteInputs */
/** @typedef {{}} Local_Trust_UnreachableInputs */
/** @typedef {{}} Local_Trust_Wrong_PassphraseInputs */
/** @typedef {{}} Local_Trust_Wrong_ProofInputs */
/** @typedef {{}} Local_Via_Cloud_RefusedInputs */
/** @typedef {{}} Local_Where_CloudInputs */
/** @typedef {{}} Media_CloseInputs */
/** @typedef {{}} Media_DownloadInputs */
/** @typedef {{}} Media_Image_ActionsInputs */
/** @typedef {{}} Media_Image_NextInputs */
/** @typedef {{ count: NonNullable<unknown>, n: NonNullable<unknown> }} Media_Image_PositionInputs */
/** @typedef {{}} Media_Image_PreviousInputs */
/** @typedef {{}} Media_More_ActionsInputs */
/** @typedef {{}} Media_Open_In_TabInputs */
/** @typedef {{}} Media_Video_Exit_FullscreenInputs */
/** @typedef {{}} Media_Video_FullscreenInputs */
/** @typedef {{ name: NonNullable<unknown> }} Media_Video_LabelInputs */
/** @typedef {{}} Media_Video_MuteInputs */
/** @typedef {{}} Media_Video_Native_FullscreenInputs */
/** @typedef {{}} Media_Video_PauseInputs */
/** @typedef {{}} Media_Video_PlayInputs */
/** @typedef {{ name: NonNullable<unknown> }} Media_Video_Play_NamedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Media_Video_SecondsInputs */
/** @typedef {{}} Media_Video_SeekInputs */
/** @typedef {{}} Media_Video_SpeedInputs */
/** @typedef {{}} Media_Video_Speed_NormalInputs */
/** @typedef {{}} Media_Video_UnmuteInputs */
/** @typedef {{}} Media_Video_UnplayableInputs */
/** @typedef {{}} Media_Video_VolumeInputs */
/** @typedef {{}} Media_Zoom_InInputs */
/** @typedef {{}} Media_Zoom_OutInputs */
/** @typedef {{}} Memos_CloseInputs */
/** @typedef {{}} Memos_HandoverInputs */
/** @typedef {{}} Memos_Handover_PlaceholderInputs */
/** @typedef {{}} Memos_Load_FailedInputs */
/** @typedef {{}} Memos_LogInputs */
/** @typedef {{}} Memos_Log_DeleteInputs */
/** @typedef {{}} Memos_Log_Delete_FailedInputs */
/** @typedef {{}} Memos_Log_EmptyInputs */
/** @typedef {{}} Memos_Log_MoreInputs */
/** @typedef {{}} Memos_Save_FailedInputs */
/** @typedef {{}} Memos_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Notices_Agent_TitleInputs */
/** @typedef {{ device: NonNullable<unknown> }} Notices_App_DeniedInputs */
/** @typedef {{}} Notices_App_DestinationsInputs */
/** @typedef {{}} Notices_App_FailedInputs */
/** @typedef {{ device: NonNullable<unknown> }} Notices_App_LabelInputs */
/** @typedef {{}} Notices_App_Open_SettingsInputs */
/** @typedef {{}} Notices_App_ReceiveInputs */
/** @typedef {{}} Notices_App_This_DeviceInputs */
/** @typedef {{}} Notices_App_UntiedInputs */
/** @typedef {{}} Notices_File_OnlyInputs */
/** @typedef {{}} Notices_Settings_DeniedInputs */
/** @typedef {{}} Notices_Settings_DescriptionInputs */
/** @typedef {{}} Notices_Settings_OsInputs */
/** @typedef {{}} Notices_Settings_Os_BlockedInputs */
/** @typedef {{}} Notices_Settings_Os_DescriptionInputs */
/** @typedef {{}} Notices_Settings_Os_Open_SettingsInputs */
/** @typedef {{}} Notices_Settings_Os_UnsignedInputs */
/** @typedef {{}} Notices_Settings_TitleInputs */
/** @typedef {{}} Notices_Settings_UnsupportedInputs */
/** @typedef {{}} Notices_Test_BodyInputs */
/** @typedef {{}} Notices_Test_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Notices_Trust_Added_BodyInputs */
/** @typedef {{}} Notices_Trust_Added_TitleInputs */
/** @typedef {{}} Notices_Turn_Edited_PrefixInputs */
/** @typedef {{}} Notices_Turn_Proposal_PrefixInputs */
/** @typedef {{}} Persons_Agent_MemoInputs */
/** @typedef {{}} Persons_Alias_AddInputs */
/** @typedef {{ alias: NonNullable<unknown> }} Persons_Alias_Add_FailedInputs */
/** @typedef {{}} Persons_Alias_PlaceholderInputs */
/** @typedef {{ alias: NonNullable<unknown> }} Persons_Alias_RemoveInputs */
/** @typedef {{ alias: NonNullable<unknown> }} Persons_Alias_Remove_FailedInputs */
/** @typedef {{}} Persons_AliasesInputs */
/** @typedef {{}} Persons_Aliases_IdsInputs */
/** @typedef {{}} Persons_ContextInputs */
/** @typedef {{}} Persons_Context_PlaceholderInputs */
/** @typedef {{}} Persons_CreateInputs */
/** @typedef {{}} Persons_Create_FailedInputs */
/** @typedef {{}} Persons_Create_Failed_KeptInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Create_NamedInputs */
/** @typedef {{}} Persons_CreatingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Delete_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Delete_TitleInputs */
/** @typedef {{}} Persons_EmptyInputs */
/** @typedef {{}} Persons_External_IdsInputs */
/** @typedef {{}} Persons_GoInputs */
/** @typedef {{}} Persons_HistoryInputs */
/** @typedef {{}} Persons_Id_AddInputs */
/** @typedef {{ value: NonNullable<unknown> }} Persons_Id_Add_FailedInputs */
/** @typedef {{}} Persons_Id_KindInputs */
/** @typedef {{ value: NonNullable<unknown> }} Persons_Id_RemoveInputs */
/** @typedef {{ value: NonNullable<unknown> }} Persons_Id_Remove_FailedInputs */
/** @typedef {{}} Persons_Id_ValueInputs */
/** @typedef {{}} Persons_Id_Value_PlaceholderInputs */
/** @typedef {{}} Persons_Kind_EmailInputs */
/** @typedef {{}} Persons_Kind_GithubInputs */
/** @typedef {{}} Persons_Kind_PhoneInputs */
/** @typedef {{}} Persons_Kind_SlackInputs */
/** @typedef {{}} Persons_Kind_UrlInputs */
/** @typedef {{}} Persons_Link_EmptyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Link_FailedInputs */
/** @typedef {{}} Persons_Link_LabelInputs */
/** @typedef {{}} Persons_Link_MenuInputs */
/** @typedef {{}} Persons_Link_SearchInputs */
/** @typedef {{}} Persons_Link_Search_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Link_TitleInputs */
/** @typedef {{}} Persons_Linked_FormerInputs */
/** @typedef {{}} Persons_ListInputs */
/** @typedef {{}} Persons_Load_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_MenuInputs */
/** @typedef {{}} Persons_Merge_ActionInputs */
/** @typedef {{ keep: NonNullable<unknown>, from: NonNullable<unknown> }} Persons_Merge_BodyInputs */
/** @typedef {{ from: NonNullable<unknown>, keep: NonNullable<unknown> }} Persons_Merge_FailedInputs */
/** @typedef {{}} Persons_Merge_LabelInputs */
/** @typedef {{}} Persons_Merge_MenuInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Merge_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Merge_Pick_TitleInputs */
/** @typedef {{}} Persons_Merge_SearchInputs */
/** @typedef {{ from: NonNullable<unknown>, keep: NonNullable<unknown> }} Persons_Merge_TitleInputs */
/** @typedef {{}} Persons_NameInputs */
/** @typedef {{}} Persons_Name_FailedInputs */
/** @typedef {{}} Persons_NarrowInputs */
/** @typedef {{}} Persons_Narrow_PlaceholderInputs */
/** @typedef {{}} Persons_NewInputs */
/** @typedef {{}} Persons_No_MatchInputs */
/** @typedef {{}} Persons_Not_FoundInputs */
/** @typedef {{}} Persons_NowInputs */
/** @typedef {{}} Persons_Now_EmptyInputs */
/** @typedef {{}} Persons_Open_EmailInputs */
/** @typedef {{}} Persons_Open_GithubInputs */
/** @typedef {{}} Persons_Open_PhoneInputs */
/** @typedef {{}} Persons_Open_SlackInputs */
/** @typedef {{}} Persons_Open_UrlInputs */
/** @typedef {{}} Persons_Pick_ActionInputs */
/** @typedef {{}} Persons_Pick_CandidatesInputs */
/** @typedef {{}} Persons_Pick_ClearInputs */
/** @typedef {{}} Persons_Pick_NoneInputs */
/** @typedef {{}} Persons_Pick_PlaceholderInputs */
/** @typedef {{}} Persons_Pick_SearchInputs */
/** @typedef {{}} Persons_Pick_Search_Or_CreateInputs */
/** @typedef {{}} Persons_Pick_Search_PlaceholderInputs */
/** @typedef {{}} Persons_Slack_WorkspaceInputs */
/** @typedef {{}} Persons_Slack_Workspace_PlaceholderInputs */
/** @typedef {{}} Persons_SummaryInputs */
/** @typedef {{}} Persons_Summary_FailedInputs */
/** @typedef {{}} Persons_Summary_PlaceholderInputs */
/** @typedef {{}} Persons_TitleInputs */
/** @typedef {{}} Persons_UnlinkInputs */
/** @typedef {{}} Persons_Unlink_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Persons_Waiting_CountInputs */
/** @typedef {{}} Phone_Doc_RedoInputs */
/** @typedef {{}} Phone_Doc_UndoInputs */
/** @typedef {{}} Phone_Dock_SettingsInputs */
/** @typedef {{}} Phone_Dock_Settings_CutoffInputs */
/** @typedef {{}} Phone_Dock_Settings_DescriptionInputs */
/** @typedef {{}} Phone_Dock_Settings_MeInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_Dock_Settings_MoveInputs */
/** @typedef {{}} Phone_Dock_Settings_No_PlaceInputs */
/** @typedef {{}} Phone_Dock_Settings_NoteInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_Dock_Settings_ShowInputs */
/** @typedef {{}} Phone_MenuInputs */
/** @typedef {{}} Phone_Menu_AllInputs */
/** @typedef {{}} Phone_Menu_ArrangeInputs */
/** @typedef {{}} Phone_Menu_OpenInputs */
/** @typedef {{}} Phone_MoreInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_More_CurrentInputs */
/** @typedef {{ name: NonNullable<unknown> }} Phone_Place_MenuInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_Unread_NamedInputs */
/** @typedef {{}} Publishing_ActionInputs */
/** @typedef {{}} Publishing_BuildingInputs */
/** @typedef {{}} Publishing_CloseInputs */
/** @typedef {{}} Publishing_CopiedInputs */
/** @typedef {{}} Publishing_CopyInputs */
/** @typedef {{}} Publishing_Copy_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Dataset_More_FieldsInputs */
/** @typedef {{}} Publishing_Dataset_Not_AllowedInputs */
/** @typedef {{}} Publishing_Dataset_Not_WritableInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Dataset_RowsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Datasets_BlockedInputs */
/** @typedef {{}} Publishing_Datasets_Confirm_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Datasets_Confirm_TitleInputs */
/** @typedef {{}} Publishing_Datasets_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Datasets_HiddenInputs */
/** @typedef {{}} Publishing_Datasets_IntroInputs */
/** @typedef {{}} Publishing_Datasets_PendingInputs */
/** @typedef {{}} Publishing_Datasets_PublishInputs */
/** @typedef {{}} Publishing_Datasets_PublishedInputs */
/** @typedef {{}} Publishing_Datasets_TitleInputs */
/** @typedef {{}} Publishing_FailedInputs */
/** @typedef {{}} Publishing_FailingInputs */
/** @typedef {{}} Publishing_Html_ScriptsInputs */
/** @typedef {{}} Publishing_IntroInputs */
/** @typedef {{}} Publishing_MenuInputs */
/** @typedef {{}} Publishing_OpenInputs */
/** @typedef {{}} Publishing_PreviewInputs */
/** @typedef {{}} Publishing_Preview_FailedInputs */
/** @typedef {{}} Publishing_PublishedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Publishing_Published_AtInputs */
/** @typedef {{}} Publishing_Published_PendingInputs */
/** @typedef {{}} Publishing_StopInputs */
/** @typedef {{}} Publishing_Stop_BodyInputs */
/** @typedef {{}} Publishing_Stop_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Publishing_Stop_TitleInputs */
/** @typedef {{}} Publishing_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Unpublished_LinksInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Unpublished_RefsInputs */
/** @typedef {{}} Publishing_UrlInputs */
/** @typedef {{}} Refs_Cannot_Open_HereInputs */
/** @typedef {{}} Refs_In_CloudInputs */
/** @typedef {{ label: NonNullable<unknown>, why: NonNullable<unknown> }} Refs_Missing_LabelInputs */
/** @typedef {{}} Refs_Not_FoundInputs */
/** @typedef {{}} Refs_Note_ConflictInputs */
/** @typedef {{}} Refs_Note_Conflict_DropInputs */
/** @typedef {{}} Refs_Note_Conflict_Use_MineInputs */
/** @typedef {{}} Refs_Note_Conflict_YoursInputs */
/** @typedef {{}} Refs_Save_Failed_KeptInputs */
/** @typedef {{}} Refs_UnreachableInputs */
/** @typedef {{}} Settings_App_OpenInputs */
/** @typedef {{}} Settings_App_Open_DescriptionInputs */
/** @typedef {{}} Settings_App_Open_Description_DeviceInputs */
/** @typedef {{}} Settings_App_Window_DescriptionInputs */
/** @typedef {{}} Settings_AppearanceInputs */
/** @typedef {{}} Settings_Appearance_DescriptionInputs */
/** @typedef {{}} Settings_Back_To_IndexInputs */
/** @typedef {{}} Settings_GeneralInputs */
/** @typedef {{}} Settings_General_DescriptionInputs */
/** @typedef {{}} Settings_General_Description_AccountInputs */
/** @typedef {{}} Settings_Group_AppInputs */
/** @typedef {{}} Settings_InputInputs */
/** @typedef {{}} Settings_Input_DescriptionInputs */
/** @typedef {{}} Settings_LanguageInputs */
/** @typedef {{}} Settings_Language_BrowserInputs */
/** @typedef {{}} Settings_Language_NoteInputs */
/** @typedef {{}} Settings_NameInputs */
/** @typedef {{}} Settings_PictureInputs */
/** @typedef {{}} Settings_Save_FailedInputs */
/** @typedef {{}} Settings_Send_KeyInputs */
/** @typedef {{}} Settings_Send_Key_EnterInputs */
/** @typedef {{}} Settings_Send_Key_ModInputs */
/** @typedef {{}} Settings_Send_Key_NoteInputs */
/** @typedef {{}} Settings_ThemeInputs */
/** @typedef {{}} Settings_Theme_AutoInputs */
/** @typedef {{}} Settings_Theme_DarkInputs */
/** @typedef {{}} Settings_Theme_LightInputs */
/** @typedef {{}} Settings_Theme_NoteInputs */
/** @typedef {{}} Settings_Time_ZoneInputs */
/** @typedef {{ zone: NonNullable<unknown> }} Settings_Time_Zone_BrowserInputs */
/** @typedef {{}} Settings_Time_Zone_NoteInputs */
/** @typedef {{}} Shell_Account_MenuInputs */
/** @typedef {{}} Shell_BackInputs */
/** @typedef {{}} Shell_Back_To_ListInputs */
/** @typedef {{}} Shell_Clear_PicksInputs */
/** @typedef {{}} Shell_CopiedInputs */
/** @typedef {{}} Shell_Copy_FailedInputs */
/** @typedef {{}} Shell_Copy_LinkInputs */
/** @typedef {{}} Shell_Error_BodyInputs */
/** @typedef {{}} Shell_Error_ReloadInputs */
/** @typedef {{}} Shell_Error_TitleInputs */
/** @typedef {{}} Shell_FavoritesInputs */
/** @typedef {{}} Shell_Favorites_AddInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Favorites_Add_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Create_Folder_FailedInputs */
/** @typedef {{}} Shell_Favorites_Delete_FolderInputs */
/** @typedef {{}} Shell_Favorites_Delete_Folder_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Delete_Folder_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Delete_Folder_TitleInputs */
/** @typedef {{}} Shell_Favorites_EmptyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Folder_MenuInputs */
/** @typedef {{}} Shell_Favorites_Folder_NameInputs */
/** @typedef {{}} Shell_Favorites_Move_FailedInputs */
/** @typedef {{}} Shell_Favorites_New_FolderInputs */
/** @typedef {{}} Shell_Favorites_RemoveInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Favorites_Remove_FailedInputs */
/** @typedef {{}} Shell_Favorites_RenameInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Rename_FailedInputs */
/** @typedef {{}} Shell_Fold_SidebarInputs */
/** @typedef {{}} Shell_Hub_AwayInputs */
/** @typedef {{}} Shell_Keep_Sidebar_OpenInputs */
/** @typedef {{}} Shell_Language_AutoInputs */
/** @typedef {{}} Shell_List_FoldInputs */
/** @typedef {{ count: NonNullable<unknown> }} Shell_List_Fold_RestInputs */
/** @typedef {{}} Shell_List_NarrowInputs */
/** @typedef {{}} Shell_List_Narrow_TitleInputs */
/** @typedef {{}} Shell_List_No_MatchInputs */
/** @typedef {{}} Shell_MeInputs */
/** @typedef {{}} Shell_Me_Away_SettingsInputs */
/** @typedef {{}} Shell_Me_EmptyInputs */
/** @typedef {{}} Shell_Me_Moving_AlmostInputs */
/** @typedef {{ percent: NonNullable<unknown>, left: NonNullable<unknown> }} Shell_Me_Moving_DoneInputs */
/** @typedef {{}} Shell_Me_Moving_MeasuringInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Shell_Me_Moving_MinutesInputs */
/** @typedef {{}} Shell_Me_Moving_ProgressInputs */
/** @typedef {{}} Shell_Me_Moving_Under_MinuteInputs */
/** @typedef {{}} Shell_Not_Found_BodyInputs */
/** @typedef {{}} Shell_Not_Found_TitleInputs */
/** @typedef {{}} Shell_Open_SidebarInputs */
/** @typedef {{}} Shell_Personal_Data_Not_WorkspaceInputs */
/** @typedef {{}} Shell_Personal_DocumentsInputs */
/** @typedef {{}} Shell_Personal_In_CloudInputs */
/** @typedef {{}} Shell_Personal_In_VaultInputs */
/** @typedef {{}} Shell_Personal_OnlyInputs */
/** @typedef {{}} Shell_Pick_ActionsInputs */
/** @typedef {{ base: NonNullable<unknown>, n: NonNullable<unknown> }} Shell_Pick_Count_LabelInputs */
/** @typedef {{}} Shell_Pick_Names_JoinInputs */
/** @typedef {{ head: NonNullable<unknown>, rest: NonNullable<unknown> }} Shell_Pick_Names_MoreInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Pick_QuotedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Pick_RowInputs */
/** @typedef {{}} Shell_Picked_ActionsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Shell_Picked_CountInputs */
/** @typedef {{}} Shell_Rail_PersonalInputs */
/** @typedef {{}} Shell_Resize_SidebarInputs */
/** @typedef {{}} Shell_Route_PendingInputs */
/** @typedef {{}} Shell_SettingsInputs */
/** @typedef {{}} Shell_Settings_BackInputs */
/** @typedef {{}} Shell_Settings_DescriptionInputs */
/** @typedef {{}} Shell_Settings_No_MatchInputs */
/** @typedef {{}} Shell_Settings_SearchInputs */
/** @typedef {{}} Shell_ShortcutsInputs */
/** @typedef {{}} Shell_Shortcuts_Group_CreateInputs */
/** @typedef {{}} Shell_Shortcuts_Group_GeneralInputs */
/** @typedef {{}} Shell_Shortcuts_Group_NavigateInputs */
/** @typedef {{}} Shell_Shortcuts_Group_ViewInputs */
/** @typedef {{}} Shell_Side_CloseInputs */
/** @typedef {{}} Shell_Side_Open_FullInputs */
/** @typedef {{}} Shell_Toggle_SidebarInputs */
/** @typedef {{}} Shell_Unreachable_Cannot_OpenInputs */
/** @typedef {{}} Shell_WideInputs */
/** @typedef {{}} Shell_Wide_OffInputs */
/** @typedef {{}} Shell_Wide_ToggleInputs */
/** @typedef {{}} Shell_Window_CloseInputs */
/** @typedef {{}} Shell_Window_MaximizeInputs */
/** @typedef {{}} Shell_Window_MinimizeInputs */
/** @typedef {{}} Shell_Window_RestoreInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Workspace_ChangeInputs */
/** @typedef {{ names: NonNullable<unknown> }} Shell_Workspace_Change_ManyInputs */
/** @typedef {{}} Shell_Workspace_ColInputs */
/** @typedef {{}} Shell_Workspace_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Workspace_LeftInputs */
/** @typedef {{}} Shell_Workspace_OfflineInputs */
/** @typedef {{}} Shell_Workspace_RemoveInputs */
/** @typedef {{}} Shell_Workspace_SetInputs */
/** @typedef {{}} Timeblocker_AccountsInputs */
/** @typedef {{}} Timeblocker_Activity_Agent_RunInputs */
/** @typedef {{}} Timeblocker_Activity_Case_ClosedInputs */
/** @typedef {{}} Timeblocker_Activity_Step_ClosedInputs */
/** @typedef {{}} Timeblocker_Add_BlockInputs */
/** @typedef {{}} Timeblocker_Add_LaneInputs */
/** @typedef {{}} Timeblocker_All_DayInputs */
/** @typedef {{}} Timeblocker_Block_EndedInputs */
/** @typedef {{ title: NonNullable<unknown>, start: NonNullable<unknown>, end: NonNullable<unknown> }} Timeblocker_Block_LabelInputs */
/** @typedef {{}} Timeblocker_Block_RemoveInputs */
/** @typedef {{}} Timeblocker_CalendarInputs */
/** @typedef {{ name: NonNullable<unknown> }} Timeblocker_Calendar_ErrorInputs */
/** @typedef {{}} Timeblocker_Calendar_SettingsInputs */
/** @typedef {{}} Timeblocker_CalendarsInputs */
/** @typedef {{}} Timeblocker_CancelInputs */
/** @typedef {{}} Timeblocker_Case_Add_WholeInputs */
/** @typedef {{}} Timeblocker_Case_WholeInputs */
/** @typedef {{}} Timeblocker_CasesInputs */
/** @typedef {{}} Timeblocker_Change_DeferredInputs */
/** @typedef {{}} Timeblocker_Change_MovedInputs */
/** @typedef {{}} Timeblocker_CloseInputs */
/** @typedef {{}} Timeblocker_ColorInputs */
/** @typedef {{ name: NonNullable<unknown> }} Timeblocker_Color_OfInputs */
/** @typedef {{}} Timeblocker_Connect_DescriptionInputs */
/** @typedef {{}} Timeblocker_Connect_FailedInputs */
/** @typedef {{}} Timeblocker_Connect_GoogleInputs */
/** @typedef {{}} Timeblocker_Connect_MoreInputs */
/** @typedef {{}} Timeblocker_Create_EventInputs */
/** @typedef {{}} Timeblocker_DateInputs */
/** @typedef {{}} Timeblocker_Delete_EventInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Delete_Event_ConfirmInputs */
/** @typedef {{}} Timeblocker_Delete_LaneInputs */
/** @typedef {{}} Timeblocker_DetailInputs */
/** @typedef {{}} Timeblocker_Did_ActivityInputs */
/** @typedef {{}} Timeblocker_Did_NoneInputs */
/** @typedef {{}} Timeblocker_Did_StartedInputs */
/** @typedef {{}} Timeblocker_Did_UpcomingInputs */
/** @typedef {{}} Timeblocker_DisconnectInputs */
/** @typedef {{}} Timeblocker_Disconnect_BodyInputs */
/** @typedef {{ email: NonNullable<unknown> }} Timeblocker_Disconnect_FailedInputs */
/** @typedef {{ email: NonNullable<unknown> }} Timeblocker_Disconnect_TitleInputs */
/** @typedef {{}} Timeblocker_DoneInputs */
/** @typedef {{}} Timeblocker_Empty_DoneInputs */
/** @typedef {{}} Timeblocker_Empty_TodoInputs */
/** @typedef {{}} Timeblocker_EndInputs */
/** @typedef {{}} Timeblocker_End_BlockInputs */
/** @typedef {{}} Timeblocker_End_DateInputs */
/** @typedef {{}} Timeblocker_Event_Bad_DatesInputs */
/** @typedef {{}} Timeblocker_Event_ConflictInputs */
/** @typedef {{}} Timeblocker_Event_DetailInputs */
/** @typedef {{}} Timeblocker_Event_TitleInputs */
/** @typedef {{}} Timeblocker_Event_Too_ShortInputs */
/** @typedef {{}} Timeblocker_GoInputs */
/** @typedef {{}} Timeblocker_Go_TodayInputs */
/** @typedef {{}} Timeblocker_Google_ConnectedInputs */
/** @typedef {{}} Timeblocker_Google_DeniedInputs */
/** @typedef {{}} Timeblocker_Google_FailedInputs */
/** @typedef {{}} Timeblocker_Google_Not_GrantedInputs */
/** @typedef {{}} Timeblocker_Google_UnavailableInputs */
/** @typedef {{}} Timeblocker_Google_Wrong_AccountInputs */
/** @typedef {{ date: NonNullable<unknown> }} Timeblocker_Group_AfterInputs */
/** @typedef {{}} Timeblocker_Group_After_TodayInputs */
/** @typedef {{ date: NonNullable<unknown> }} Timeblocker_Group_BeforeInputs */
/** @typedef {{}} Timeblocker_Group_Before_TodayInputs */
/** @typedef {{}} Timeblocker_Group_TodayInputs */
/** @typedef {{}} Timeblocker_Group_UndatedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Item_StartInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Item_StopInputs */
/** @typedef {{}} Timeblocker_Item_WorkingInputs */
/** @typedef {{}} Timeblocker_Join_HereInputs */
/** @typedef {{}} Timeblocker_Join_MeetingInputs */
/** @typedef {{}} Timeblocker_Kind_ActionInputs */
/** @typedef {{}} Timeblocker_Kind_CaseInputs */
/** @typedef {{}} Timeblocker_Lane_MeInputs */
/** @typedef {{}} Timeblocker_Lane_NameInputs */
/** @typedef {{}} Timeblocker_Lane_NoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Timeblocker_Lane_OfInputs */
/** @typedef {{}} Timeblocker_LanesInputs */
/** @typedef {{}} Timeblocker_Lanes_NoteInputs */
/** @typedef {{}} Timeblocker_Link_EmptyInputs */
/** @typedef {{}} Timeblocker_Link_SearchInputs */
/** @typedef {{}} Timeblocker_ListsInputs */
/** @typedef {{}} Timeblocker_Load_FailedInputs */
/** @typedef {{}} Timeblocker_Mark_DoneInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Mark_Done_OfInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_MoreInputs */
/** @typedef {{}} Timeblocker_New_EventInputs */
/** @typedef {{}} Timeblocker_Next_DayInputs */
/** @typedef {{}} Timeblocker_Next_WeekInputs */
/** @typedef {{}} Timeblocker_No_AccountsInputs */
/** @typedef {{}} Timeblocker_No_ActionsInputs */
/** @typedef {{}} Timeblocker_No_WritableInputs */
/** @typedef {{}} Timeblocker_Open_CaseInputs */
/** @typedef {{}} Timeblocker_Open_GoogleInputs */
/** @typedef {{}} Timeblocker_Pick_ActionInputs */
/** @typedef {{}} Timeblocker_Pick_DateInputs */
/** @typedef {{}} Timeblocker_PlanInputs */
/** @typedef {{}} Timeblocker_Prev_DayInputs */
/** @typedef {{}} Timeblocker_Prev_WeekInputs */
/** @typedef {{}} Timeblocker_Read_OnlyInputs */
/** @typedef {{}} Timeblocker_Recurring_OneInputs */
/** @typedef {{}} Timeblocker_RedoInputs */
/** @typedef {{}} Timeblocker_Redo_FailedInputs */
/** @typedef {{}} Timeblocker_ReopenInputs */
/** @typedef {{}} Timeblocker_Reset_ColorInputs */
/** @typedef {{}} Timeblocker_Resume_BlockInputs */
/** @typedef {{}} Timeblocker_ResyncInputs */
/** @typedef {{}} Timeblocker_ReviewInputs */
/** @typedef {{}} Timeblocker_Review_ActualInputs */
/** @typedef {{}} Timeblocker_Review_ChangesInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_Changes_DeferredInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_Changes_MovedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_Changes_ShortenedInputs */
/** @typedef {{ day: NonNullable<unknown>, time: NonNullable<unknown> }} Timeblocker_Review_Deferred_FromInputs */
/** @typedef {{ day: NonNullable<unknown>, time: NonNullable<unknown> }} Timeblocker_Review_Deferred_ToInputs */
/** @typedef {{}} Timeblocker_Review_DoneInputs */
/** @typedef {{}} Timeblocker_Review_Done_OfInputs */
/** @typedef {{}} Timeblocker_Review_EmptyInputs */
/** @typedef {{}} Timeblocker_Review_LinkInputs */
/** @typedef {{}} Timeblocker_Review_LinkedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_MovedInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timeblocker_Review_Moved_ToInputs */
/** @typedef {{ range: NonNullable<unknown> }} Timeblocker_Review_OfInputs */
/** @typedef {{}} Timeblocker_Review_PlannedInputs */
/** @typedef {{}} Timeblocker_Review_Planned_CommittedInputs */
/** @typedef {{}} Timeblocker_Review_Planned_OfInputs */
/** @typedef {{}} Timeblocker_Review_RateInputs */
/** @typedef {{ did: NonNullable<unknown>, all: NonNullable<unknown> }} Timeblocker_Review_Rate_OfInputs */
/** @typedef {{}} Timeblocker_Review_RatioInputs */
/** @typedef {{ planned: NonNullable<unknown> }} Timeblocker_Review_Ratio_OfInputs */
/** @typedef {{}} Timeblocker_Review_Unlinked_BlockInputs */
/** @typedef {{}} Timeblocker_Review_Untitled_ChatInputs */
/** @typedef {{}} Timeblocker_Save_FailedInputs */
/** @typedef {{}} Timeblocker_Settings_DescriptionInputs */
/** @typedef {{}} Timeblocker_Settings_TitleInputs */
/** @typedef {{}} Timeblocker_Show_ActionsInputs */
/** @typedef {{}} Timeblocker_StartInputs */
/** @typedef {{}} Timeblocker_Start_BlockInputs */
/** @typedef {{}} Timeblocker_Start_DateInputs */
/** @typedef {{}} Timeblocker_TabsInputs */
/** @typedef {{}} Timeblocker_This_WeekInputs */
/** @typedef {{}} Timeblocker_TimeInputs */
/** @typedef {{ date: NonNullable<unknown> }} Timeblocker_TimelineInputs */
/** @typedef {{}} Timeblocker_TitleInputs */
/** @typedef {{}} Timeblocker_Title_LabelInputs */
/** @typedef {{}} Timeblocker_TodoInputs */
/** @typedef {{}} Timeblocker_Undated_DropInputs */
/** @typedef {{}} Timeblocker_UndoInputs */
/** @typedef {{}} Timeblocker_Undo_FailedInputs */
/** @typedef {{}} Timeblocker_UnlinkInputs */
/** @typedef {{}} Timeblocker_UntitledInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Timeblocker_Week_RangeInputs */
/** @typedef {{}} Timeblocker_Work_LabelInputs */
/** @typedef {{}} Timeblocker_Work_LogInputs */
/** @typedef {{}} Timeblocker_Work_Log_DeleteInputs */
/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Timeblocker_Work_Log_LabelInputs */
/** @typedef {{}} Timeblocker_Work_Log_NowInputs */
/** @typedef {{ elapsed: NonNullable<unknown> }} Timeblocker_Work_RunningInputs */
/** @typedef {{ title: NonNullable<unknown>, elapsed: NonNullable<unknown> }} Timeblocker_Work_Running_OfInputs */
/** @typedef {{}} Timeblocker_Work_StartInputs */
/** @typedef {{}} Timeblocker_Work_Start_ShortInputs */
/** @typedef {{}} Timeblocker_Work_StopInputs */
/** @typedef {{}} Timeblocker_Work_Stop_ShortInputs */
/** @typedef {{ total: NonNullable<unknown> }} Timeblocker_Work_TotalInputs */
/** @typedef {{}} Uifence_AnswerInputs */
/** @typedef {{}} Uifence_Answer_DetailInputs */
/** @typedef {{}} Uifence_Answer_TitleInputs */
/** @typedef {{}} Uifence_BuildingInputs */
/** @typedef {{}} Uifence_Calendar_Next_MonthInputs */
/** @typedef {{}} Uifence_Calendar_PickInputs */
/** @typedef {{}} Uifence_Calendar_Prev_MonthInputs */
/** @typedef {{}} Uifence_Calendar_TodayInputs */
/** @typedef {{ count: NonNullable<unknown> }} Uifence_Chart_OthersInputs */
/** @typedef {{}} Uifence_ChooseInputs */
/** @typedef {{}} Uifence_Copy_SourceInputs */
/** @typedef {{ count: NonNullable<unknown> }} Uifence_Count_LeftInputs */
/** @typedef {{ count: NonNullable<unknown> }} Uifence_Count_RightInputs */
/** @typedef {{}} Uifence_Data_All_RowsInputs */
/** @typedef {{}} Uifence_Data_ButtonInputs */
/** @typedef {{}} Uifence_Data_Not_FoundInputs */
/** @typedef {{}} Uifence_Data_Not_Found_DetailInputs */
/** @typedef {{}} Uifence_Data_QueryInputs */
/** @typedef {{}} Uifence_DateInputs */
/** @typedef {{}} Uifence_EndInputs */
/** @typedef {{}} Uifence_FailedInputs */
/** @typedef {{}} Uifence_Funnel_From_FirstInputs */
/** @typedef {{}} Uifence_Funnel_From_PreviousInputs */
/** @typedef {{}} Uifence_HeatmapInputs */
/** @typedef {{}} Uifence_Hide_SourceInputs */
/** @typedef {{}} Uifence_InsertInputs */
/** @typedef {{}} Uifence_LabelInputs */
/** @typedef {{}} Uifence_More_LeftInputs */
/** @typedef {{}} Uifence_More_RightInputs */
/** @typedef {{}} Uifence_Next_ImageInputs */
/** @typedef {{}} Uifence_NoInputs */
/** @typedef {{}} Uifence_No_DataInputs */
/** @typedef {{}} Uifence_No_EventsInputs */
/** @typedef {{}} Uifence_Open_LinkInputs */
/** @typedef {{}} Uifence_Open_Link_DetailInputs */
/** @typedef {{}} Uifence_Open_Link_TitleInputs */
/** @typedef {{}} Uifence_Picker_ClearInputs */
/** @typedef {{}} Uifence_Prev_ImageInputs */
/** @typedef {{}} Uifence_Quiz_CorrectInputs */
/** @typedef {{}} Uifence_Quiz_HintInputs */
/** @typedef {{}} Uifence_Quiz_Hint_ExplainedInputs */
/** @typedef {{}} Uifence_Quiz_Picked_WrongInputs */
/** @typedef {{}} Uifence_Quiz_WrongInputs */
/** @typedef {{}} Uifence_Range_Next_DayInputs */
/** @typedef {{}} Uifence_Range_ReversedInputs */
/** @typedef {{}} Uifence_Range_SameInputs */
/** @typedef {{}} Uifence_Range_SepInputs */
/** @typedef {{}} Uifence_SendInputs */
/** @typedef {{}} Uifence_Send_DetailInputs */
/** @typedef {{}} Uifence_Send_TitleInputs */
/** @typedef {{}} Uifence_Show_SourceInputs */
/** @typedef {{}} Uifence_SourceInputs */
/** @typedef {{ first: NonNullable<unknown>, last: NonNullable<unknown>, min: NonNullable<unknown>, max: NonNullable<unknown> }} Uifence_Spark_RangeInputs */
/** @typedef {{}} Uifence_StaleInputs */
/** @typedef {{}} Uifence_StartInputs */
/** @typedef {{}} Uifence_TimeInputs */
/** @typedef {{}} Uifence_Time_HourInputs */
/** @typedef {{}} Uifence_Time_MinuteInputs */
/** @typedef {{}} Uifence_Time_NowInputs */
/** @typedef {{}} Uifence_Time_PickInputs */
/** @typedef {{}} Uifence_TotalInputs */
/** @typedef {{}} Uifence_Waterfall_DownInputs */
/** @typedef {{}} Uifence_Waterfall_RunningInputs */
/** @typedef {{}} Uifence_Waterfall_UpInputs */
/** @typedef {{}} Uifence_YesInputs */


export const agents_agent_label = /** @type {(inputs: Agents_Agent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エージェント`)
};

export const agents_answer_by_parent = /** @type {(inputs: Agents_Answer_By_ParentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」が答えた: ${i?.title}`)
};

export const agents_answer_raised_from = /** @type {(inputs: Agents_Answer_Raised_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`子の会話の件:`)
};

export const agents_archive = /** @type {(inputs: Agents_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブする`)
};

export const agents_archived_empty = /** @type {(inputs: Agents_Archived_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブした会話はありません`)
};

export const agents_attach = /** @type {(inputs: Agents_AttachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルを添付`)
};

export const agents_attachment_failed = /** @type {(inputs: Agents_Attachment_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を上げられませんでした: ${i?.reason}`)
};

export const agents_attachment_remove = /** @type {(inputs: Agents_Attachment_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を外す`)
};

export const agents_attachments = /** @type {(inputs: Agents_AttachmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添付するファイル`)
};

export const agents_bookmark_add = /** @type {(inputs: Agents_Bookmark_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブックマークする`)
};

export const agents_bookmark_remove = /** @type {(inputs: Agents_Bookmark_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブックマークを外す`)
};

export const agents_browser_read_only = /** @type {(inputs: Agents_Browser_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザでは見るだけです。Agent への指示は trameria アプリから送れます。`)
};

export const agents_cancel = /** @type {(inputs: Agents_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やめる`)
};

export const agents_case_chat = /** @type {(inputs: Agents_Case_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Case の会話`)
};

export const agents_case_chat_failed = /** @type {(inputs: Agents_Case_Chat_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Case の会話を開けませんでした`)
};

export const agents_change_action = /** @type {(inputs: Agents_Change_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変える`)
};

export const agents_change_agent_body = /** @type {(inputs: Agents_Change_Agent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これまでの会話は新しいエージェントに渡します`)
};

export const agents_change_agent_title = /** @type {(inputs: Agents_Change_Agent_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エージェントを ${i?.agent} に変えますか?`)
};

export const agents_change_completed = /** @type {(inputs: Agents_Change_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

export const agents_change_created = /** @type {(inputs: Agents_Change_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

export const agents_change_delegated = /** @type {(inputs: Agents_Change_DelegatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`委任`)
};

export const agents_change_deleted = /** @type {(inputs: Agents_Change_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const agents_change_dropped = /** @type {(inputs: Agents_Change_DroppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中止`)
};

export const agents_change_next_reply = /** @type {(inputs: Agents_Change_Next_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いま書いている返事には効きません。次の返事から変わります`)
};

export const agents_change_obj_action = /** @type {(inputs: Agents_Change_Obj_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

export const agents_change_obj_case = /** @type {(inputs: Agents_Change_Obj_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const agents_change_obj_chat = /** @type {(inputs: Agents_Change_Obj_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話`)
};

export const agents_change_obj_other = /** @type {(inputs: Agents_Change_Obj_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`項目`)
};

export const agents_change_obj_page = /** @type {(inputs: Agents_Change_Obj_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書`)
};

export const agents_change_obj_person = /** @type {(inputs: Agents_Change_Obj_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人`)
};

export const agents_change_obj_waiting = /** @type {(inputs: Agents_Change_Obj_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting`)
};

export const agents_change_posted = /** @type {(inputs: Agents_Change_PostedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投稿`)
};

export const agents_change_reopened = /** @type {(inputs: Agents_Change_ReopenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再開`)
};

export const agents_change_updated = /** @type {(inputs: Agents_Change_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

export const agents_changes = /** @type {(inputs: Agents_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この返事で変えたもの`)
};

export const agents_child_queued = /** @type {(inputs: Agents_Child_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順番待ち`)
};

export const agents_child_running = /** @type {(inputs: Agents_Child_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業中`)
};

export const agents_child_waiting = /** @type {(inputs: Agents_Child_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`判断待ち`)
};

export const agents_children = /** @type {(inputs: Agents_ChildrenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動いている子の会話`)
};

export const agents_col_agent = /** @type {(inputs: Agents_Col_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

export const agents_col_case = /** @type {(inputs: Agents_Col_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const agents_col_cost = /** @type {(inputs: Agents_Col_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コスト`)
};

export const agents_col_created = /** @type {(inputs: Agents_Col_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

export const agents_col_name = /** @type {(inputs: Agents_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const agents_col_updated = /** @type {(inputs: Agents_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新`)
};

export const agents_composer_shrink = /** @type {(inputs: Agents_Composer_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`縮める`)
};

export const agents_conditions_close = /** @type {(inputs: Agents_Conditions_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const agents_conditions_drawer = /** @type {(inputs: Agents_Conditions_DrawerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 設定`)
};

export const agents_conditions_open = /** @type {(inputs: Agents_Conditions_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 設定を開く`)
};

export const agents_conditions_open_device = /** @type {(inputs: Agents_Conditions_Open_DeviceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agent 設定を開く(デバイス: ${i?.device})`)
};

export const agents_conditions_open_device_warning = /** @type {(inputs: Agents_Conditions_Open_Device_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agent 設定を開く(デバイス: ${i?.device}、注意あり)`)
};

export const agents_conditions_open_warning = /** @type {(inputs: Agents_Conditions_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 設定を開く(注意あり)`)
};

export const agents_copied = /** @type {(inputs: Agents_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーしました`)
};

export const agents_copy = /** @type {(inputs: Agents_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

export const agents_cwd_label = /** @type {(inputs: Agents_Cwd_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業ディレクトリ`)
};

export const agents_cwd_missing = /** @type {(inputs: Agents_Cwd_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}(見つかりません)`)
};

export const agents_cwd_missing_note = /** @type {(inputs: Agents_Cwd_Missing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスにこの場所がありません。選び直してください`)
};

export const agents_cwd_none = /** @type {(inputs: Agents_Cwd_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業ディレクトリなし`)
};

export const agents_cwd_none_note = /** @type {(inputs: Agents_Cwd_None_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルには触れません`)
};

export const agents_cwd_other = /** @type {(inputs: Agents_Cwd_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのディレクトリ…`)
};

export const agents_cwd_outside = /** @type {(inputs: Agents_Cwd_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可したディレクトリの下のパスを入れてください`)
};

export const agents_delegate_step = /** @type {(inputs: Agents_Delegate_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent に任せる`)
};

export const agents_delegate_step_failed = /** @type {(inputs: Agents_Delegate_Step_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を Agent に任せられませんでした`)
};

export const agents_delegate_step_open = /** @type {(inputs: Agents_Delegate_Step_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任せた会話を開く`)
};

export const agents_delete = /** @type {(inputs: Agents_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const agents_delete_body = /** @type {(inputs: Agents_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話の発言・実行の記録・あなたの番の件も消えます。元に戻せません`)
};

export const agents_delete_many_body = /** @type {(inputs: Agents_Delete_Many_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.names}の発言・実行の記録・あなたの番の件も消えます。元に戻せません`)
};

export const agents_delete_many_title = /** @type {(inputs: Agents_Delete_Many_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件の会話を削除しますか?`)
};

export const agents_delete_title = /** @type {(inputs: Agents_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を削除しますか?`)
};

export const agents_device_away = /** @type {(inputs: Agents_Device_AwayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} の agent はいま繋がっていません。送った発言には、繋がり直したときに答えます`)
};

export const agents_device_away_short = /** @type {(inputs: Agents_Device_Away_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いまは繋がっていません`)
};

export const agents_device_coming = /** @type {(inputs: Agents_Device_ComingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} を用意しています。送った発言は用意ができたら届きます`)
};

export const agents_device_label = /** @type {(inputs: Agents_Device_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイス`)
};

export const agents_device_offline = /** @type {(inputs: Agents_Device_OfflineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} はまだ trameria に繋がっていないので、送っても答える Agent がいません。${i?.device} で trameria のアプリか agent を起動してください`)
};

export const agents_device_offline_pick = /** @type {(inputs: Agents_Device_Offline_PickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} はまだ trameria に繋がっていないので、送っても答える Agent がいません。欄の下で繋がっているデバイスを選ぶか、${i?.device} で trameria のアプリか agent を起動してください`)
};

export const agents_device_ready = /** @type {(inputs: Agents_Device_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繋がっていて、答えられます`)
};

export const agents_device_unreachable_line = /** @type {(inputs: Agents_Device_Unreachable_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.self} から ${i?.device} には指示を送信できません。${i?.device} のデバイスリストに ${i?.self} を追加してください。`)
};

export const agents_devices_add = /** @type {(inputs: Agents_Devices_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスを足す`)
};

export const agents_devices_never_seen = /** @type {(inputs: Agents_Devices_Never_SeenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ繋がっていません`)
};

export const agents_draft_ask_in_chat = /** @type {(inputs: Agents_Draft_Ask_In_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送る側に反映するには、チャットで頼んでください`)
};

export const agents_draft_copy_original = /** @type {(inputs: Agents_Draft_Copy_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原文をコピー`)
};

export const agents_draft_copy_subject = /** @type {(inputs: Agents_Draft_Copy_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`件名をコピー`)
};

export const agents_draft_open = /** @type {(inputs: Agents_Draft_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く`)
};

export const agents_draft_open_original = /** @type {(inputs: Agents_Draft_Open_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元のメッセージを開く`)
};

export const agents_draft_original = /** @type {(inputs: Agents_Draft_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原文`)
};

export const agents_draft_reason_placeholder = /** @type {(inputs: Agents_Draft_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送らないときの理由(なくてもよい)`)
};

export const agents_draft_reply_to = /** @type {(inputs: Agents_Draft_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返信先の原文`)
};

export const agents_draft_save_failed = /** @type {(inputs: Agents_Draft_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文面を保存できませんでした`)
};

export const agents_draft_side = /** @type {(inputs: Agents_Draft_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示する文面`)
};

export const agents_draft_side_source = /** @type {(inputs: Agents_Draft_Side_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語(確認用)`)
};

export const agents_draft_side_text = /** @type {(inputs: Agents_Draft_Side_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lang}(送る)`)
};

export const agents_draft_slack = /** @type {(inputs: Agents_Draft_SlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下書き`)
};

export const agents_draft_slack_again = /** @type {(inputs: Agents_Draft_Slack_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`置き直す`)
};

export const agents_draft_slack_failed = /** @type {(inputs: Agents_Draft_Slack_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`置けませんでした: ${i?.error}`)
};

export const agents_draft_slack_placed = /** @type {(inputs: Agents_Draft_Slack_PlacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下書きに置いた`)
};

export const agents_draft_slack_placing = /** @type {(inputs: Agents_Draft_Slack_PlacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下書きに置いています`)
};

export const agents_draft_slack_request_failed = /** @type {(inputs: Agents_Draft_Slack_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下書きに置くよう頼めませんでした`)
};

export const agents_draft_slack_stale = /** @type {(inputs: Agents_Draft_Slack_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`置いた後に文面が変わりました`)
};

export const agents_draft_stale = /** @type {(inputs: Agents_Draft_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前の内容`)
};

export const agents_draft_subject = /** @type {(inputs: Agents_Draft_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`件名`)
};

export const agents_draft_text = /** @type {(inputs: Agents_Draft_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送る文面`)
};

export const agents_draft_thread = /** @type {(inputs: Agents_Draft_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/スレッド`)
};

export const agents_draft_to_unknown = /** @type {(inputs: Agents_Draft_To_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送り先未定`)
};

export const agents_draft_translation = /** @type {(inputs: Agents_Draft_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語訳`)
};

export const agents_effort_label = /** @type {(inputs: Agents_Effort_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`考える深さ`)
};

export const agents_empty = /** @type {(inputs: Agents_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話はまだありません`)
};

export const agents_empty_active = /** @type {(inputs: Agents_Empty_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動きのある会話はありません`)
};

export const agents_filter = /** @type {(inputs: Agents_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話の絞り込み`)
};

export const agents_filter_active = /** @type {(inputs: Agents_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動きあり`)
};

export const agents_filter_all = /** @type {(inputs: Agents_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

export const agents_filter_archived = /** @type {(inputs: Agents_Filter_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ`)
};

export const agents_from_parent = /** @type {(inputs: Agents_From_ParentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`親の会話「${i?.name}」からの指示`)
};

export const agents_go = /** @type {(inputs: Agents_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents へ`)
};

export const agents_hours_minutes = /** @type {(inputs: Agents_Hours_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.h}時間${i?.m}分`)
};

export const agents_image_n = /** @type {(inputs: Agents_Image_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`画像${i?.n}`)
};

export const agents_limit_days = /** @type {(inputs: Agents_Limit_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 日`)
};

export const agents_limit_error = /** @type {(inputs: Agents_Limit_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.error}(値は ${i?.at} 時点)`)
};

export const agents_limit_hours = /** @type {(inputs: Agents_Limit_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 時間`)
};

export const agents_limit_model = /** @type {(inputs: Agents_Limit_ModelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`週 · ${i?.model}`)
};

export const agents_limit_none = /** @type {(inputs: Agents_Limit_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ取れていません`)
};

export const agents_limit_off = /** @type {(inputs: Agents_Limit_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用上限の取得は切っています`)
};

export const agents_limit_resets = /** @type {(inputs: Agents_Limit_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} にリセット`)
};

export const agents_limit_title = /** @type {(inputs: Agents_Limit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用上限`)
};

export const agents_limit_week = /** @type {(inputs: Agents_Limit_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`週`)
};

export const agents_list = /** @type {(inputs: Agents_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話の一覧`)
};

export const agents_load_failed = /** @type {(inputs: Agents_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした`)
};

export const agents_loading_older = /** @type {(inputs: Agents_Loading_OlderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み中`)
};

export const agents_mark_compacted = /** @type {(inputs: Agents_Mark_CompactedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここまでの会話を圧縮しました`)
};

export const agents_mark_read = /** @type {(inputs: Agents_Mark_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既読にする`)
};

export const agents_mark_rewound = /** @type {(inputs: Agents_Mark_RewoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここで巻き戻しました`)
};

export const agents_mark_stopped = /** @type {(inputs: Agents_Mark_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`止めました`)
};

export const agents_mark_withdrawn = /** @type {(inputs: Agents_Mark_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消しました`)
};

export const agents_menu = /** @type {(inputs: Agents_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話のメニュー`)
};

export const agents_message_edited = /** @type {(inputs: Agents_Message_EditedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(編集済み)`)
};

export const agents_message_removed = /** @type {(inputs: Agents_Message_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この発言は削除されました`)
};

export const agents_minutes_seconds = /** @type {(inputs: Agents_Minutes_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.m}分${i?.s}秒`)
};

export const agents_model_cli_default = /** @type {(inputs: Agents_Model_Cli_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI 任せ`)
};

export const agents_model_label = /** @type {(inputs: Agents_Model_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モデル`)
};

export const agents_more_conditions = /** @type {(inputs: Agents_More_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業ディレクトリと他の MCP`)
};

export const agents_nav = /** @type {(inputs: Agents_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents`)
};

export const agents_new = /** @type {(inputs: Agents_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい会話`)
};

export const agents_new_hint = /** @type {(inputs: Agents_New_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下の欄に書いて送ると、${i?.device}のエージェントが答えます。モデルと作業ディレクトリは欄の下で選べます`)
};

export const agents_no_agent_yet = /** @type {(inputs: Agents_No_Agent_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC で使える Claude Code / Codex をまだ確かめています。少し待ってから送ってください`)
};

export const agents_no_device = /** @type {(inputs: Agents_No_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC のエージェントがまだ登録されていません`)
};

export const agents_not_found = /** @type {(inputs: Agents_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この会話は見つかりませんでした`)
};

export const agents_notice_answered = /** @type {(inputs: Agents_Notice_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`の件に答えた`)
};

export const agents_notice_asked = /** @type {(inputs: Agents_Notice_AskedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`が聞いている: ${i?.title}`)
};

export const agents_notice_ended = /** @type {(inputs: Agents_Notice_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`が終わった`)
};

export const agents_notice_failed = /** @type {(inputs: Agents_Notice_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`が失敗した: ${i?.error}`)
};

export const agents_notice_instructed = /** @type {(inputs: Agents_Notice_InstructedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`に指示した`)
};

export const agents_notice_other = /** @type {(inputs: Agents_Notice_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`で動きがあった`)
};

export const agents_notice_raised = /** @type {(inputs: Agents_Notice_RaisedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`の件をあなたに上げた: ${i?.title}`)
};

export const agents_notice_read = /** @type {(inputs: Agents_Notice_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`の様子を読んだ`)
};

export const agents_notice_retried = /** @type {(inputs: Agents_Notice_RetriedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`をやり直した`)
};

export const agents_notice_started = /** @type {(inputs: Agents_Notice_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`を始めた`)
};

export const agents_notice_step_closed = /** @type {(inputs: Agents_Notice_Step_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`の Action「${i?.title}」を閉じた`)
};

export const agents_notice_stopped = /** @type {(inputs: Agents_Notice_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`を止めた`)
};

export const agents_notice_turn_added = /** @type {(inputs: Agents_Notice_Turn_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`が件を積んだ: ${i?.title}`)
};

export const agents_notices_count = /** @type {(inputs: Agents_Notices_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`裏のやり取り ${i?.n} 件`)
};

export const agents_open_settings = /** @type {(inputs: Agents_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を開く`)
};

export const agents_other_mcp = /** @type {(inputs: Agents_Other_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他の MCP`)
};

export const agents_other_mcp_short = /** @type {(inputs: Agents_Other_Mcp_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他`)
};

export const agents_other_mcp_warning = /** @type {(inputs: Agents_Other_Mcp_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他の MCP を使うと、作業ディレクトリが無くてもその MCP の届く範囲に触れます`)
};

export const agents_outline = /** @type {(inputs: Agents_OutlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話の目盛り`)
};

export const agents_outline_side = /** @type {(inputs: Agents_Outline_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドチャットを開く`)
};

export const agents_parent_chat = /** @type {(inputs: Agents_Parent_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`親の会話`)
};

export const agents_pc_agents = /** @type {(inputs: Agents_Pc_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見つかったエージェント`)
};

export const agents_pc_auth_ok = /** @type {(inputs: Agents_Pc_Auth_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインイン中`)
};

export const agents_pc_auth_ok_account = /** @type {(inputs: Agents_Pc_Auth_Ok_AccountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サインイン中(${i?.account})`)
};

export const agents_pc_auth_out = /** @type {(inputs: Agents_Pc_Auth_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインしていません`)
};

export const agents_pc_auth_unknown = /** @type {(inputs: Agents_Pc_Auth_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインしているか確かめられません`)
};

export const agents_pc_compact = /** @type {(inputs: Agents_Pc_CompactInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自動圧縮(%)· ${i?.agent}`)
};

export const agents_pc_compact_note = /** @type {(inputs: Agents_Pc_Compact_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文脈がこの割合に届いたら返事の後に圧縮します。100 で圧縮しません`)
};

export const agents_pc_concurrency = /** @type {(inputs: Agents_Pc_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話を同時に動かす`)
};

export const agents_pc_concurrency_note = /** @type {(inputs: Agents_Pc_Concurrency_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業ディレクトリのある会話を同時に動かすか、1 つずつにするか`)
};

export const agents_pc_default_agent = /** @type {(inputs: Agents_Pc_Default_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エージェント`)
};

export const agents_pc_default_cwd = /** @type {(inputs: Agents_Pc_Default_CwdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業ディレクトリ`)
};

export const agents_pc_default_cwd_note = /** @type {(inputs: Agents_Pc_Default_Cwd_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話ごとに投稿欄の下で変えられます`)
};

export const agents_pc_default_model = /** @type {(inputs: Agents_Pc_Default_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モデル`)
};

export const agents_pc_defaults = /** @type {(inputs: Agents_Pc_DefaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい会話の既定`)
};

export const agents_pc_description = /** @type {(inputs: Agents_Pc_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC で動く Claude Code / Codex のサインイン・利用上限・作業ディレクトリと、新しい会話の既定`)
};

export const agents_pc_login = /** @type {(inputs: Agents_Pc_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインイン`)
};

export const agents_pc_login_again = /** @type {(inputs: Agents_Pc_Login_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインし直す`)
};

export const agents_pc_login_code = /** @type {(inputs: Agents_Pc_Login_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインのコード`)
};

export const agents_pc_login_code_hint = /** @type {(inputs: Agents_Pc_Login_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開いたページでこのコードを入れてください。済むと自動で終わります`)
};

export const agents_pc_login_error = /** @type {(inputs: Agents_Pc_Login_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サインインできませんでした: ${i?.error}`)
};

export const agents_pc_login_failed = /** @type {(inputs: Agents_Pc_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインを始められませんでした`)
};

export const agents_pc_login_open = /** @type {(inputs: Agents_Pc_Login_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインページを開く`)
};

export const agents_pc_login_open_copy = /** @type {(inputs: Agents_Pc_Login_Open_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードをコピーしてサインインページを開く`)
};

export const agents_pc_login_paste_hint = /** @type {(inputs: Agents_Pc_Login_Paste_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開いたページでサインインし、出てきたコードをここに貼ってください`)
};

export const agents_pc_login_preparing = /** @type {(inputs: Agents_Pc_Login_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC で準備しています…`)
};

export const agents_pc_login_sent = /** @type {(inputs: Agents_Pc_Login_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送りました。確かめています…`)
};

export const agents_pc_login_verifying = /** @type {(inputs: Agents_Pc_Login_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確かめています…`)
};

export const agents_pc_name = /** @type {(inputs: Agents_Pc_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const agents_pc_other_mcp = /** @type {(inputs: Agents_Pc_Other_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかの MCP`)
};

export const agents_pc_other_mcp_all = /** @type {(inputs: Agents_Pc_Other_Mcp_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使う`)
};

export const agents_pc_other_mcp_none = /** @type {(inputs: Agents_Pc_Other_Mcp_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使わない`)
};

export const agents_pc_other_mcp_note = /** @type {(inputs: Agents_Pc_Other_Mcp_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC に登録したほかの MCP サーバーを会話で使うか`)
};

export const agents_pc_other_mcp_read = /** @type {(inputs: Agents_Pc_Other_Mcp_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読むだけ`)
};

export const agents_pc_parallel = /** @type {(inputs: Agents_Pc_ParallelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同時に`)
};

export const agents_pc_quiet = /** @type {(inputs: Agents_Pc_QuietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返事までの間(秒)`)
};

export const agents_pc_quiet_note = /** @type {(inputs: Agents_Pc_Quiet_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続けて送った発言をまとめて読むまで待つ時間`)
};

export const agents_pc_serial = /** @type {(inputs: Agents_Pc_SerialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 つずつ`)
};

export const agents_pc_title = /** @type {(inputs: Agents_Pc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC のエージェント`)
};

export const agents_pc_usage_limits = /** @type {(inputs: Agents_Pc_Usage_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用上限を取得する`)
};

export const agents_pc_usage_limits_note = /** @type {(inputs: Agents_Pc_Usage_Limits_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claude Code のサインインで Anthropic に、Codex には Codex 自身に、利用枠の残りを聞きます。切ると何も取りに行かず、使用量は出ません`)
};

export const agents_pc_workdirs = /** @type {(inputs: Agents_Pc_WorkdirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業ディレクトリ`)
};

export const agents_pc_workdirs_none = /** @type {(inputs: Agents_Pc_Workdirs_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだありません`)
};

export const agents_pc_workdirs_note = /** @type {(inputs: Agents_Pc_Workdirs_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC のエージェントが使ってよいと報告した場所です。ここからは足せません`)
};

export const agents_pending_after = /** @type {(inputs: Agents_Pending_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この返事の後で読みます`)
};

export const agents_pending_next = /** @type {(inputs: Agents_Pending_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の区切りで読みます`)
};

export const agents_pending_reading_now = /** @type {(inputs: Agents_Pending_Reading_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ読ませています…`)
};

export const agents_pending_withdrawing = /** @type {(inputs: Agents_Pending_WithdrawingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消しています…`)
};

export const agents_post_label = /** @type {(inputs: Agents_Post_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エージェントへの発言`)
};

export const agents_post_placeholder = /** @type {(inputs: Agents_Post_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージ`)
};

export const agents_post_placeholder_running = /** @type {(inputs: Agents_Post_Placeholder_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続けて指示を送れます`)
};

export const agents_reach_no_signer = /** @type {(inputs: Agents_Reach_No_SignerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザからは指示を送信できません。trameria アプリから送信してください。`)
};

export const agents_reach_not_trusted = /** @type {(inputs: Agents_Reach_Not_TrustedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} に指示を送信するには、${i?.device} のデバイスリストに ${i?.self} を追加してください。`)
};

export const agents_reach_not_trusted_unnamed = /** @type {(inputs: Agents_Reach_Not_Trusted_UnnamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} に指示を送信するには、${i?.device} のデバイスリストに、使っているデバイスを追加してください。`)
};

export const agents_reach_own_only = /** @type {(inputs: Agents_Reach_Own_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.self} からは、${i?.self} の Agent にだけ指示を送信できます。${i?.device} に送信するには、スマートフォンか mac の trameria アプリを使ってください。`)
};

export const agents_reach_self_only = /** @type {(inputs: Agents_Reach_Self_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} は、${i?.device} のアプリからだけ利用できる設定です。${i?.device} のアプリの設定で変更できます。`)
};

export const agents_read_now = /** @type {(inputs: Agents_Read_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ`)
};

export const agents_related_changed = /** @type {(inputs: Agents_Related_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`関連オブジェクト`)
};

export const agents_rename = /** @type {(inputs: Agents_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を変える`)
};

export const agents_rename_action = /** @type {(inputs: Agents_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変える`)
};

export const agents_request_failed = /** @type {(inputs: Agents_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`できませんでした`)
};

export const agents_retry = /** @type {(inputs: Agents_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やり直す`)
};

export const agents_rewind_action = /** @type {(inputs: Agents_Rewind_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻す`)
};

export const agents_rewind_checking = /** @type {(inputs: Agents_Rewind_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確かめています…`)
};

export const agents_rewind_conversation = /** @type {(inputs: Agents_Rewind_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話`)
};

export const agents_rewind_conversation_n = /** @type {(inputs: Agents_Rewind_Conversation_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この発言とその後の ${i?.n} 件を消し、この発言を投稿欄に戻します`)
};

export const agents_rewind_conversation_one = /** @type {(inputs: Agents_Rewind_Conversation_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この発言を消し、投稿欄に戻します`)
};

export const agents_rewind_failed = /** @type {(inputs: Agents_Rewind_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻せませんでした`)
};

export const agents_rewind_files = /** @type {(inputs: Agents_Rewind_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC のファイル`)
};

export const agents_rewind_files_bash = /** @type {(inputs: Agents_Rewind_Files_BashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bash などで書き換えたファイルは戻りません`)
};

export const agents_rewind_files_codex = /** @type {(inputs: Agents_Rewind_Files_CodexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codex の会話ではファイルは戻せません`)
};

export const agents_rewind_files_n = /** @type {(inputs: Agents_Rewind_Files_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} ファイルを変える前に戻します`)
};

export const agents_rewind_files_none = /** @type {(inputs: Agents_Rewind_Files_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻すファイルはありません`)
};

export const agents_rewind_files_off = /** @type {(inputs: Agents_Rewind_Files_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルの控えが無いので戻せません`)
};

export const agents_rewind_here = /** @type {(inputs: Agents_Rewind_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここまで戻す`)
};

export const agents_rewind_more = /** @type {(inputs: Agents_Rewind_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ほか ${i?.n} 件`)
};

export const agents_rewind_title = /** @type {(inputs: Agents_Rewind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この発言の前まで戻す`)
};

export const agents_rewind_trameria = /** @type {(inputs: Agents_Rewind_TrameriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria`)
};

export const agents_rewind_trameria_n = /** @type {(inputs: Agents_Rewind_Trameria_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この発言より後に Agent が加えた変更(${i?.n} 件)を戻します`)
};

export const agents_rewind_trameria_none = /** @type {(inputs: Agents_Rewind_Trameria_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻す変更はありません`)
};

export const agents_row_asking = /** @type {(inputs: Agents_Row_AskingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`質問あり`)
};

export const agents_row_delegating = /** @type {(inputs: Agents_Row_DelegatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`子に任せている`)
};

export const agents_row_queued = /** @type {(inputs: Agents_Row_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順番待ち`)
};

export const agents_row_unread = /** @type {(inputs: Agents_Row_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未読`)
};

export const agents_row_working = /** @type {(inputs: Agents_Row_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業中`)
};

export const agents_save_failed = /** @type {(inputs: Agents_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存できませんでした`)
};

export const agents_seconds = /** @type {(inputs: Agents_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}秒`)
};

export const agents_send = /** @type {(inputs: Agents_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送る`)
};

export const agents_send_failed = /** @type {(inputs: Agents_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送れませんでした(入力は戻しました)`)
};

export const agents_send_hint_enter = /** @type {(inputs: Agents_Send_Hint_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信(Enter)。Shift+Enter で改行`)
};

export const agents_send_hint_mod = /** @type {(inputs: Agents_Send_Hint_ModInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`送信(${i?.mod}+Enter)。Enter で改行`)
};

export const agents_sending = /** @type {(inputs: Agents_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信中…`)
};

export const agents_side_close = /** @type {(inputs: Agents_Side_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const agents_side_composer_placeholder = /** @type {(inputs: Agents_Side_Composer_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドチャットに書く…`)
};

export const agents_side_from = /** @type {(inputs: Agents_Side_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本線の発言から分かれた`)
};

export const agents_side_label = /** @type {(inputs: Agents_Side_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドチャット`)
};

export const agents_side_new = /** @type {(inputs: Agents_Side_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この返事から分かれて話します`)
};

export const agents_side_open = /** @type {(inputs: Agents_Side_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`サイドチャット「${i?.title}」を開く`)
};

export const agents_side_open_page = /** @type {(inputs: Agents_Side_Open_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常の画面で開く`)
};

export const agents_side_placeholder = /** @type {(inputs: Agents_Side_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本線とは別のことを頼む…`)
};

export const agents_side_reply_gone = /** @type {(inputs: Agents_Side_Reply_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本線の返事は読み込まれていません`)
};

export const agents_side_start = /** @type {(inputs: Agents_Side_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドチャットを開く`)
};

export const agents_signal_slack_draft = /** @type {(inputs: Agents_Signal_Slack_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slack の下書きに置くよう頼みました`)
};

export const agents_signal_step_ready = /** @type {(inputs: Agents_Signal_Step_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.caseTitle}」の ${i?.steps} が今の番になりました`)
};

export const agents_signal_turn_awaiting = /** @type {(inputs: Agents_Signal_Turn_AwaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`子の会話の件が未対応のままなので、もう一度知らせました`)
};

export const agents_signal_turn_declined = /** @type {(inputs: Agents_Signal_Turn_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの番の件が断られました`)
};

export const agents_signal_turn_withdrawn = /** @type {(inputs: Agents_Signal_Turn_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`親の会話があなたの番の件を取り下げました`)
};

export const agents_signal_wait_target = /** @type {(inputs: Agents_Signal_Wait_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.caseTitle}」で待っていた「${i?.title}」が変わりました`)
};

export const agents_someone = /** @type {(inputs: Agents_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(退出したユーザー)`)
};

export const agents_start = /** @type {(inputs: Agents_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`話しはじめる`)
};

export const agents_status_compacting = /** @type {(inputs: Agents_Status_CompactingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これまでの会話を圧縮しています`)
};

export const agents_status_starting = /** @type {(inputs: Agents_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読まれるのを待っています`)
};

export const agents_status_stopping = /** @type {(inputs: Agents_Status_StoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`止めています…`)
};

export const agents_status_thinking = /** @type {(inputs: Agents_Status_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`考え中`)
};

export const agents_status_waiting = /** @type {(inputs: Agents_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順番待ち(ほかの会話が書き込み中)`)
};

export const agents_status_writing = /** @type {(inputs: Agents_Status_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続きを書いています`)
};

export const agents_stop = /** @type {(inputs: Agents_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`止める`)
};

export const agents_stop_failed = /** @type {(inputs: Agents_Stop_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`止められませんでした`)
};

export const agents_suggest_loading = /** @type {(inputs: Agents_Suggest_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探しています…`)
};

export const agents_tap_to_withdraw = /** @type {(inputs: Agents_Tap_To_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`押すと取り消して入力欄に戻します`)
};

export const agents_this_pc_name = /** @type {(inputs: Agents_This_Pc_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC`)
};

export const agents_time_range = /** @type {(inputs: Agents_Time_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}〜${i?.to}`)
};

export const agents_title = /** @type {(inputs: Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents`)
};

export const agents_title_label = /** @type {(inputs: Agents_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話の名前`)
};

export const agents_title_placeholder = /** @type {(inputs: Agents_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を入力`)
};

export const agents_to_end = /** @type {(inputs: Agents_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新へ`)
};

export const agents_turn_after = /** @type {(inputs: Agents_Turn_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の件`)
};

export const agents_turn_answer = /** @type {(inputs: Agents_Turn_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`答える`)
};

export const agents_turn_answer_failed = /** @type {(inputs: Agents_Turn_Answer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送れませんでした`)
};

export const agents_turn_before = /** @type {(inputs: Agents_Turn_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前の件`)
};

export const agents_turn_browser_read_only = /** @type {(inputs: Agents_Turn_Browser_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザでは答えられません。trameria アプリで答えてください。`)
};

export const agents_turn_cause_approved = /** @type {(inputs: Agents_Turn_Cause_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可した`)
};

export const agents_turn_cause_conversation = /** @type {(inputs: Agents_Turn_Cause_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`話した結果`)
};

export const agents_turn_cause_human = /** @type {(inputs: Agents_Turn_Cause_HumanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたが直した`)
};

export const agents_turn_changed = /** @type {(inputs: Agents_Turn_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容が変わりました。新しい内容を見てから答えてください`)
};

export const agents_turn_check_placeholder = /** @type {(inputs: Agents_Turn_Check_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント(NG のときは直してほしい点。画像も貼れます)`)
};

export const agents_turn_choice_placeholder = /** @type {(inputs: Agents_Turn_Choice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント・ほかの答え(画像も貼れます)`)
};

export const agents_turn_chosen = /** @type {(inputs: Agents_Turn_ChosenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選んだ`)
};

export const agents_turn_close = /** @type {(inputs: Agents_Turn_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const agents_turn_closed_already = /** @type {(inputs: Agents_Turn_Closed_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう済んだ件でした`)
};

export const agents_turn_comment = /** @type {(inputs: Agents_Turn_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント`)
};

export const agents_turn_comment_placeholder = /** @type {(inputs: Agents_Turn_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント(なくてもよい。画像も貼れます)`)
};

export const agents_turn_count = /** @type {(inputs: Agents_Turn_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`あなたの番 ${i?.count} 件`)
};

export const agents_turn_current_above = /** @type {(inputs: Agents_Turn_Current_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いまの内容(上)`)
};

export const agents_turn_date_clear = /** @type {(inputs: Agents_Turn_Date_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外す`)
};

export const agents_turn_date_pick = /** @type {(inputs: Agents_Turn_Date_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を選ぶ`)
};

export const agents_turn_edited_by_you = /** @type {(inputs: Agents_Turn_Edited_By_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたが直した`)
};

export const agents_turn_fold = /** @type {(inputs: Agents_Turn_FoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`畳む`)
};

export const agents_turn_form_placeholder = /** @type {(inputs: Agents_Turn_Form_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント・項目にないこと(画像も貼れます)`)
};

export const agents_turn_from = /** @type {(inputs: Agents_Turn_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」から`)
};

export const agents_turn_hand_over = /** @type {(inputs: Agents_Turn_Hand_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渡す`)
};

export const agents_turn_held_by = /** @type {(inputs: Agents_Turn_Held_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」が預かっている`)
};

export const agents_turn_history = /** @type {(inputs: Agents_Turn_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書き換えの履歴(古い順)`)
};

export const agents_turn_kind_check = /** @type {(inputs: Agents_Turn_Kind_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認依頼`)
};

export const agents_turn_kind_draft_email = /** @type {(inputs: Agents_Turn_Kind_Draft_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールで送る文面`)
};

export const agents_turn_kind_draft_slack = /** @type {(inputs: Agents_Turn_Kind_Draft_SlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slack に送る文面`)
};

export const agents_turn_kind_operate = /** @type {(inputs: Agents_Turn_Kind_OperateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作依頼`)
};

export const agents_turn_kind_provide = /** @type {(inputs: Agents_Turn_Kind_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提出依頼`)
};

export const agents_turn_label = /** @type {(inputs: Agents_Turn_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの番`)
};

export const agents_turn_line_done = /** @type {(inputs: Agents_Turn_Line_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`済んだ: ${i?.title}`)
};

export const agents_turn_line_withdrawn = /** @type {(inputs: Agents_Turn_Line_WithdrawnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`取り下げた: ${i?.title}`)
};

export const agents_turn_links = /** @type {(inputs: Agents_Turn_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見てほしい場所`)
};

export const agents_turn_multi = /** @type {(inputs: Agents_Turn_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数選択可`)
};

export const agents_turn_need_fix = /** @type {(inputs: Agents_Turn_Need_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直してほしい点を書いてください`)
};

export const agents_turn_need_reason = /** @type {(inputs: Agents_Turn_Need_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`できなかった理由を書いてください`)
};

export const agents_turn_no = /** @type {(inputs: Agents_Turn_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

export const agents_turn_operate_placeholder = /** @type {(inputs: Agents_Turn_Operate_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント(問題ありのときはその中身。画像も貼れます)`)
};

export const agents_turn_place = /** @type {(inputs: Agents_Turn_PlaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.at}/${i?.count}`)
};

export const agents_turn_proposal = /** @type {(inputs: Agents_Turn_ProposalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容を変えたい`)
};

export const agents_turn_proposal_accept = /** @type {(inputs: Agents_Turn_Proposal_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変えてよい`)
};

export const agents_turn_proposal_current = /** @type {(inputs: Agents_Turn_Proposal_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いまの内容を見る`)
};

export const agents_turn_proposal_keep = /** @type {(inputs: Agents_Turn_Proposal_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いまのままにする`)
};

export const agents_turn_provide_placeholder = /** @type {(inputs: Agents_Turn_Provide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渡す文章を書く(ファイルも貼れます)`)
};

export const agents_turn_recommended = /** @type {(inputs: Agents_Turn_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推奨`)
};

export const agents_turn_result_done = /** @type {(inputs: Agents_Turn_Result_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

export const agents_turn_result_failed = /** @type {(inputs: Agents_Turn_Result_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題あり`)
};

export const agents_turn_result_fix = /** @type {(inputs: Agents_Turn_Result_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NG`)
};

export const agents_turn_result_ok = /** @type {(inputs: Agents_Turn_Result_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

export const agents_turn_result_sent = /** @type {(inputs: Agents_Turn_Result_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送った`)
};

export const agents_turn_result_unsent = /** @type {(inputs: Agents_Turn_Result_UnsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送らない`)
};

export const agents_turn_rewritten = /** @type {(inputs: Agents_Turn_RewrittenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書き換えた`)
};

export const agents_turn_text_placeholder = /** @type {(inputs: Agents_Turn_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`答えを書く`)
};

export const agents_turn_ui_confirm = /** @type {(inputs: Agents_Turn_Ui_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この内容で答えますか?`)
};

export const agents_turn_ui_placeholder = /** @type {(inputs: Agents_Turn_Ui_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント(UI の答えと一緒に送ります)`)
};

export const agents_turn_view_draft = /** @type {(inputs: Agents_Turn_View_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文面を見る`)
};

export const agents_turn_view_question = /** @type {(inputs: Agents_Turn_View_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`質問を見る`)
};

export const agents_turn_view_request = /** @type {(inputs: Agents_Turn_View_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依頼を見る`)
};

export const agents_turn_yes = /** @type {(inputs: Agents_Turn_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

export const agents_unarchive = /** @type {(inputs: Agents_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブから戻す`)
};

export const agents_undo = /** @type {(inputs: Agents_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消す`)
};

export const agents_undo_all = /** @type {(inputs: Agents_Undo_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まとめて取り消す`)
};

export const agents_undo_all_title = /** @type {(inputs: Agents_Undo_All_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この返事で変えた ${i?.n} 件をまとめて取り消しますか?`)
};

export const agents_undo_conflict = /** @type {(inputs: Agents_Undo_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あとで変わっているものは取り消しませんでした`)
};

export const agents_undo_created = /** @type {(inputs: Agents_Undo_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

export const agents_undo_done = /** @type {(inputs: Agents_Undo_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消し済み`)
};

export const agents_undo_failed = /** @type {(inputs: Agents_Undo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消せませんでした。もう一度押してください`)
};

export const agents_undo_title = /** @type {(inputs: Agents_Undo_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」の${i?.op}を取り消しますか?`)
};

export const agents_undo_updated = /** @type {(inputs: Agents_Undo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更`)
};

export const agents_undo_working = /** @type {(inputs: Agents_Undo_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消し中…`)
};

export const agents_unread_from_here = /** @type {(inputs: Agents_Unread_From_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここから未読`)
};

export const agents_untitled = /** @type {(inputs: Agents_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい会話`)
};

export const agents_usage_cache_read = /** @type {(inputs: Agents_Usage_Cache_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャッシュ読み`)
};

export const agents_usage_cache_write = /** @type {(inputs: Agents_Usage_Cache_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャッシュ書き`)
};

export const agents_usage_compact = /** @type {(inputs: Agents_Usage_CompactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮`)
};

export const agents_usage_compact_failed = /** @type {(inputs: Agents_Usage_Compact_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮できませんでした`)
};

export const agents_usage_context = /** @type {(inputs: Agents_Usage_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文脈`)
};

export const agents_usage_cost = /** @type {(inputs: Agents_Usage_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コスト`)
};

export const agents_usage_empty = /** @type {(inputs: Agents_Usage_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実行が始まると、使った量がここに出ます`)
};

export const agents_usage_input = /** @type {(inputs: Agents_Usage_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力`)
};

export const agents_usage_label = /** @type {(inputs: Agents_Usage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このセッションの使用量`)
};

export const agents_usage_output = /** @type {(inputs: Agents_Usage_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力`)
};

export const agents_usage_session = /** @type {(inputs: Agents_Usage_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このセッション`)
};

export const agents_value_missing = /** @type {(inputs: Agents_Value_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value}(この PC にはありません)`)
};

export const agents_via = /** @type {(inputs: Agents_ViaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} から`)
};

export const agents_view_label = /** @type {(inputs: Agents_View_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドビュー`)
};

export const agents_wait_turn_closed = /** @type {(inputs: Agents_Wait_Turn_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話の欄`)
};

export const agents_wait_turn_open = /** @type {(inputs: Agents_Wait_Turn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話の欄で答える`)
};

export const agents_withdraw = /** @type {(inputs: Agents_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消す`)
};

export const agents_withdraw_failed = /** @type {(inputs: Agents_Withdraw_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消せませんでした。デバイスから返事がありません`)
};

export const agents_withdraw_too_late = /** @type {(inputs: Agents_Withdraw_Too_LateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう読まれていたので取り消せませんでした`)
};

export const blocks_callout_blue = /** @type {(inputs: Blocks_Callout_BlueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`青`)
};

export const blocks_callout_change_color = /** @type {(inputs: Blocks_Callout_Change_ColorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`色を変える(いま: ${i?.color})`)
};

export const blocks_callout_color = /** @type {(inputs: Blocks_Callout_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色`)
};

export const blocks_callout_green = /** @type {(inputs: Blocks_Callout_GreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`緑`)
};

export const blocks_callout_purple = /** @type {(inputs: Blocks_Callout_PurpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`紫`)
};

export const blocks_callout_red = /** @type {(inputs: Blocks_Callout_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赤`)
};

export const blocks_callout_title_placeholder = /** @type {(inputs: Blocks_Callout_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見出し`)
};

export const blocks_callout_yellow = /** @type {(inputs: Blocks_Callout_YellowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黄`)
};

export const blocks_close = /** @type {(inputs: Blocks_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const blocks_code_copy = /** @type {(inputs: Blocks_Code_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードをコピー`)
};

export const blocks_copied = /** @type {(inputs: Blocks_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーしました`)
};

export const blocks_copy_failed = /** @type {(inputs: Blocks_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーできませんでした`)
};

export const blocks_fence_cancel = /** @type {(inputs: Blocks_Fence_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

export const blocks_fence_edit_source = /** @type {(inputs: Blocks_Fence_Edit_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースを編集`)
};

export const blocks_fence_save = /** @type {(inputs: Blocks_Fence_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

export const blocks_fence_source = /** @type {(inputs: Blocks_Fence_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`図のソース`)
};

export const blocks_file_actions = /** @type {(inputs: Blocks_File_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルの操作`)
};

export const blocks_file_copy_link = /** @type {(inputs: Blocks_File_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクをコピー`)
};

export const blocks_file_delete = /** @type {(inputs: Blocks_File_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const blocks_file_download = /** @type {(inputs: Blocks_File_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロード`)
};

export const blocks_file_enlarge = /** @type {(inputs: Blocks_File_EnlargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きく表示`)
};

export const blocks_file_enlarge_named = /** @type {(inputs: Blocks_File_Enlarge_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を大きく表示`)
};

export const blocks_file_reset_width = /** @type {(inputs: Blocks_File_Reset_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`幅を戻す`)
};

export const blocks_file_resize = /** @type {(inputs: Blocks_File_ResizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像の幅を変える`)
};

export const blocks_footnote_body = /** @type {(inputs: Blocks_Footnote_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`脚注 ${i?.heading} の本文`)
};

export const blocks_footnote_create = /** @type {(inputs: Blocks_Footnote_CreateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`脚注 ${i?.label} を作る`)
};

export const blocks_footnote_gone = /** @type {(inputs: Blocks_Footnote_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この脚注は本文から消えています。書き戻しません。`)
};

export const blocks_footnote_heading = /** @type {(inputs: Blocks_Footnote_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`脚注 ${i?.heading}`)
};

export const blocks_footnote_named = /** @type {(inputs: Blocks_Footnote_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`脚注 ${i?.n}`)
};

export const blocks_footnote_to_def = /** @type {(inputs: Blocks_Footnote_To_DefInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`脚注 ${i?.n} の定義へ`)
};

export const blocks_footnote_to_ref = /** @type {(inputs: Blocks_Footnote_To_RefInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`脚注 ${i?.name} の参照へ`)
};

export const blocks_footnote_unreferenced = /** @type {(inputs: Blocks_Footnote_UnreferencedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`脚注 ${i?.name}(参照なし)`)
};

export const blocks_mermaid_failed = /** @type {(inputs: Blocks_Mermaid_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`図を描けませんでした: ${i?.error}`)
};

export const blocks_table_add_above = /** @type {(inputs: Blocks_Table_Add_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上に追加`)
};

export const blocks_table_add_below = /** @type {(inputs: Blocks_Table_Add_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下に追加`)
};

export const blocks_table_add_col = /** @type {(inputs: Blocks_Table_Add_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`列を追加`)
};

export const blocks_table_add_left = /** @type {(inputs: Blocks_Table_Add_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左に追加`)
};

export const blocks_table_add_right = /** @type {(inputs: Blocks_Table_Add_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右に追加`)
};

export const blocks_table_add_row = /** @type {(inputs: Blocks_Table_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行を追加`)
};

export const blocks_table_col_actions = /** @type {(inputs: Blocks_Table_Col_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 列目の操作`)
};

export const blocks_table_col_resize = /** @type {(inputs: Blocks_Table_Col_ResizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 列目の幅を変える`)
};

export const blocks_table_delete_col = /** @type {(inputs: Blocks_Table_Delete_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この列を削除`)
};

export const blocks_table_delete_row = /** @type {(inputs: Blocks_Table_Delete_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この行を削除`)
};

export const blocks_table_freeze_here = /** @type {(inputs: Blocks_Table_Freeze_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここまで固定`)
};

export const blocks_table_row_actions = /** @type {(inputs: Blocks_Table_Row_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 行目の操作`)
};

export const blocks_table_unfreeze = /** @type {(inputs: Blocks_Table_UnfreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`固定を外す`)
};

export const blocks_toggle_close = /** @type {(inputs: Blocks_Toggle_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トグルを閉じる`)
};

export const blocks_toggle_open = /** @type {(inputs: Blocks_Toggle_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トグルを開く`)
};

export const blocks_upload_aborted = /** @type {(inputs: Blocks_Upload_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロードを中止しました`)
};

export const blocks_upload_cancel = /** @type {(inputs: Blocks_Upload_CancelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} のアップロードを取り消す`)
};

export const blocks_upload_failed = /** @type {(inputs: Blocks_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロードできませんでした`)
};

export const blocks_upload_failed_network = /** @type {(inputs: Blocks_Upload_Failed_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロードできませんでした(通信エラー)`)
};

export const blocks_upload_failed_status = /** @type {(inputs: Blocks_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アップロードできませんでした(${i?.status})`)
};

export const blocks_upload_too_large = /** @type {(inputs: Blocks_Upload_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロードできる大きさを超えています`)
};

export const blocks_uploads = /** @type {(inputs: Blocks_UploadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロード中のファイル`)
};

export const cases_action_title = /** @type {(inputs: Cases_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action の題名`)
};

export const cases_action_title_placeholder = /** @type {(inputs: Cases_Action_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の Action`)
};

export const cases_add = /** @type {(inputs: Cases_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

export const cases_add_action = /** @type {(inputs: Cases_Add_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action を追加`)
};

export const cases_add_action_button = /** @type {(inputs: Cases_Add_Action_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`＋ Action を追加`)
};

export const cases_add_step_needs_title = /** @type {(inputs: Cases_Add_Step_Needs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先に Case の題名を書いてください`)
};

export const cases_add_waiting = /** @type {(inputs: Cases_Add_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting を追加`)
};

export const cases_add_waiting_button = /** @type {(inputs: Cases_Add_Waiting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`＋ Waiting を追加`)
};

export const cases_agent_memo = /** @type {(inputs: Cases_Agent_MemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI メモ`)
};

export const cases_body = /** @type {(inputs: Cases_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容`)
};

export const cases_body_placeholder = /** @type {(inputs: Cases_Body_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細`)
};

export const cases_body_write_placeholder = /** @type {(inputs: Cases_Body_Write_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細を書く…`)
};

export const cases_case_title = /** @type {(inputs: Cases_Case_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case の題名`)
};

export const cases_chain = /** @type {(inputs: Cases_ChainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chain`)
};

export const cases_chain_done = /** @type {(inputs: Cases_Chain_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

export const cases_chain_empty = /** @type {(inputs: Cases_Chain_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ Action も Waiting もありません`)
};

export const cases_chain_graph = /** @type {(inputs: Cases_Chain_GraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chain の図`)
};

export const cases_chain_later = /** @type {(inputs: Cases_Chain_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

export const cases_chain_now = /** @type {(inputs: Cases_Chain_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now`)
};

export const cases_change_due = /** @type {(inputs: Cases_Change_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期日を変える`)
};

export const cases_change_plan = /** @type {(inputs: Cases_Change_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やる日を変える`)
};

export const cases_change_wait_until = /** @type {(inputs: Cases_Change_Wait_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつまで待つかを変える`)
};

export const cases_closed_empty = /** @type {(inputs: Cases_Closed_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じた Case はありません`)
};

export const cases_col_case = /** @type {(inputs: Cases_Col_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const cases_col_due = /** @type {(inputs: Cases_Col_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期日`)
};

export const cases_col_name = /** @type {(inputs: Cases_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const cases_col_plan = /** @type {(inputs: Cases_Col_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やる日`)
};

export const cases_col_updated = /** @type {(inputs: Cases_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

export const cases_col_wait = /** @type {(inputs: Cases_Col_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待ち先`)
};

export const cases_context = /** @type {(inputs: Cases_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Context`)
};

export const cases_context_placeholder = /** @type {(inputs: Cases_Context_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここまでの経緯`)
};

export const cases_create = /** @type {(inputs: Cases_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case を作る`)
};

export const cases_create_failed_kept = /** @type {(inputs: Cases_Create_Failed_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作れませんでした(入力は残っています)`)
};

export const cases_delete_body = /** @type {(inputs: Cases_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action / Waiting と関連・添付・AI メモも一緒に消えます。元には戻せません。終えるだけなら「完了」か「中止する」にしてください。`)
};

export const cases_delete_failed = /** @type {(inputs: Cases_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を削除できませんでした`)
};

export const cases_delete_title = /** @type {(inputs: Cases_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を削除します`)
};

export const cases_done = /** @type {(inputs: Cases_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

export const cases_drop = /** @type {(inputs: Cases_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中止する`)
};

export const cases_due = /** @type {(inputs: Cases_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期日`)
};

export const cases_due_clear = /** @type {(inputs: Cases_Due_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期日を外す`)
};

export const cases_empty = /** @type {(inputs: Cases_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case はありません`)
};

export const cases_file_bytes = /** @type {(inputs: Cases_File_BytesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} B`)
};

export const cases_file_kb = /** @type {(inputs: Cases_File_KbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} KB`)
};

export const cases_file_mb = /** @type {(inputs: Cases_File_MbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} MB`)
};

export const cases_file_remove = /** @type {(inputs: Cases_File_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を外す`)
};

export const cases_file_remove_failed = /** @type {(inputs: Cases_File_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を外せませんでした`)
};

export const cases_files = /** @type {(inputs: Cases_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添付`)
};

export const cases_go = /** @type {(inputs: Cases_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases へ`)
};

export const cases_graph_delegated = /** @type {(inputs: Cases_Graph_DelegatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent に任せた`)
};

export const cases_graph_progress = /** @type {(inputs: Cases_Graph_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} / ${i?.total}`)
};

export const cases_kind_action = /** @type {(inputs: Cases_Kind_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

export const cases_kind_waiting = /** @type {(inputs: Cases_Kind_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting`)
};

export const cases_label = /** @type {(inputs: Cases_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベル`)
};

export const cases_label_change = /** @type {(inputs: Cases_Label_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ラベル「${i?.name}」を変える`)
};

export const cases_label_failed = /** @type {(inputs: Cases_Label_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベルを変えられませんでした`)
};

export const cases_label_set = /** @type {(inputs: Cases_Label_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベルを付ける`)
};

export const cases_list = /** @type {(inputs: Cases_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case の一覧`)
};

export const cases_load_failed = /** @type {(inputs: Cases_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした`)
};

export const cases_menu = /** @type {(inputs: Cases_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」の操作`)
};

export const cases_new = /** @type {(inputs: Cases_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい Case`)
};

export const cases_not_found = /** @type {(inputs: Cases_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Case は見つかりませんでした`)
};

export const cases_overdue = /** @type {(inputs: Cases_OverdueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`期日を過ぎた(${i?.date})`)
};

export const cases_panel_close = /** @type {(inputs: Cases_Panel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const cases_plan = /** @type {(inputs: Cases_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やる日`)
};

export const cases_plan_carried = /** @type {(inputs: Cases_Plan_CarriedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`持ち越し(${i?.date}から)`)
};

export const cases_plan_clear = /** @type {(inputs: Cases_Plan_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やる日を外す`)
};

export const cases_plan_pick_date = /** @type {(inputs: Cases_Plan_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を選ぶ…`)
};

export const cases_plan_someday = /** @type {(inputs: Cases_Plan_SomedayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あとで`)
};

export const cases_plan_this_week = /** @type {(inputs: Cases_Plan_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今週`)
};

export const cases_plan_today = /** @type {(inputs: Cases_Plan_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日`)
};

export const cases_plan_tomorrow = /** @type {(inputs: Cases_Plan_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明日`)
};

export const cases_plan_week_of = /** @type {(inputs: Cases_Plan_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}の週`)
};

export const cases_related = /** @type {(inputs: Cases_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related`)
};

export const cases_related_add = /** @type {(inputs: Cases_Related_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`関連を追加`)
};

export const cases_related_add_failed = /** @type {(inputs: Cases_Related_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を追加できませんでした`)
};

export const cases_related_candidates = /** @type {(inputs: Cases_Related_CandidatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`候補`)
};

export const cases_related_none = /** @type {(inputs: Cases_Related_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見つかりません`)
};

export const cases_related_remove = /** @type {(inputs: Cases_Related_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を外す`)
};

export const cases_related_remove_failed = /** @type {(inputs: Cases_Related_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を外せませんでした`)
};

export const cases_related_search = /** @type {(inputs: Cases_Related_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`関連を探す`)
};

export const cases_related_search_placeholder = /** @type {(inputs: Cases_Related_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case・Person を探す / URL を貼る`)
};

export const cases_rename = /** @type {(inputs: Cases_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を変える`)
};

export const cases_reopen = /** @type {(inputs: Cases_ReopenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再開`)
};

export const cases_result = /** @type {(inputs: Cases_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果`)
};

export const cases_result_placeholder = /** @type {(inputs: Cases_Result_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果があれば記載`)
};

export const cases_source_step_body = /** @type {(inputs: Cases_Source_Step_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.kind}「${i?.title}」の内容`)
};

export const cases_source_step_result = /** @type {(inputs: Cases_Source_Step_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.kind}「${i?.title}」の結果`)
};

export const cases_source_step_wait = /** @type {(inputs: Cases_Source_Step_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.kind}「${i?.title}」の待ち先`)
};

export const cases_status_done = /** @type {(inputs: Cases_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了した`)
};

export const cases_status_dropped = /** @type {(inputs: Cases_Status_DroppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中止`)
};

export const cases_status_failed = /** @type {(inputs: Cases_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態を変えられませんでした`)
};

export const cases_step_add_failed = /** @type {(inputs: Cases_Step_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を追加できませんでした`)
};

export const cases_step_auto_closed = /** @type {(inputs: Cases_Step_Auto_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動で閉じた`)
};

export const cases_step_close_failed = /** @type {(inputs: Cases_Step_Close_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を閉じられませんでした`)
};

export const cases_step_created = /** @type {(inputs: Cases_Step_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`作成 ${i?.date}`)
};

export const cases_step_delete_body = /** @type {(inputs: Cases_Step_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容・結果と、この step に付けた関連と添付も一緒に消えます。元には戻せません。`)
};

export const cases_step_delete_failed = /** @type {(inputs: Cases_Step_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を削除できませんでした`)
};

export const cases_step_delete_title = /** @type {(inputs: Cases_Step_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を削除します`)
};

export const cases_step_done = /** @type {(inputs: Cases_Step_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を完了`)
};

export const cases_step_due = /** @type {(inputs: Cases_Step_DueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`期日 ${i?.date}`)
};

export const cases_step_due_failed = /** @type {(inputs: Cases_Step_Due_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」の期日を変えられませんでした`)
};

export const cases_step_kind = /** @type {(inputs: Cases_Step_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種類`)
};

export const cases_step_menu = /** @type {(inputs: Cases_Step_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」の操作`)
};

export const cases_step_plan = /** @type {(inputs: Cases_Step_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`やる日 ${i?.label}`)
};

export const cases_step_plan_failed = /** @type {(inputs: Cases_Step_Plan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」のやる日を変えられませんでした`)
};

export const cases_step_rename_failed = /** @type {(inputs: Cases_Step_Rename_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」の名前を変えられませんでした`)
};

export const cases_step_reopen_failed = /** @type {(inputs: Cases_Step_Reopen_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を開け直せませんでした`)
};

export const cases_step_resolve = /** @type {(inputs: Cases_Step_ResolveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を解消`)
};

export const cases_step_title = /** @type {(inputs: Cases_Step_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action / Waiting の題名`)
};

export const cases_step_unplaced = /** @type {(inputs: Cases_Step_UnplacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置は仮`)
};

export const cases_step_unplaced_hint = /** @type {(inputs: Cases_Step_Unplaced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面から足した step です。AI が Chain の中の位置を決め直します`)
};

export const cases_step_wait_target_dropped = /** @type {(inputs: Cases_Step_Wait_Target_DroppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待ち先が中止された`)
};

export const cases_tab_closed = /** @type {(inputs: Cases_Tab_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

export const cases_tab_next = /** @type {(inputs: Cases_Tab_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

export const cases_tab_ready = /** @type {(inputs: Cases_Tab_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

export const cases_tab_waiting = /** @type {(inputs: Cases_Tab_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting`)
};

export const cases_tabs = /** @type {(inputs: Cases_TabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示する Case`)
};

export const cases_title = /** @type {(inputs: Cases_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases`)
};

export const cases_title_failed = /** @type {(inputs: Cases_Title_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名を変えられませんでした`)
};

export const cases_title_placeholder = /** @type {(inputs: Cases_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトル`)
};

export const cases_wait_until = /** @type {(inputs: Cases_Wait_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつまで待つか`)
};

export const cases_waiting_title = /** @type {(inputs: Cases_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting の題名`)
};

export const cases_waiting_title_placeholder = /** @type {(inputs: Cases_Waiting_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何を待つか`)
};

export const common_cancel = /** @type {(inputs: Common_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やめる`)
};

export const common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 日前`)
};

export const common_days_later = /** @type {(inputs: Common_Days_LaterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 日後`)
};

export const common_delete = /** @type {(inputs: Common_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const common_error_with_lead = /** @type {(inputs: Common_Error_With_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lead}。${i?.message}`)
};

export const common_forbidden = /** @type {(inputs: Common_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`権限がありません。必要なロールを持っている人に頼むこと。`)
};

export const common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 時間前`)
};

export const common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`たった今`)
};

export const common_load_more_failed = /** @type {(inputs: Common_Load_More_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続きを読めませんでした`)
};

export const common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 分前`)
};

export const common_picture_apply = /** @type {(inputs: Common_Picture_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`決定`)
};

export const common_picture_choose = /** @type {(inputs: Common_Picture_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像を選ぶ`)
};

export const common_picture_crop_hint = /** @type {(inputs: Common_Picture_Crop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドラッグで位置を、スライダー・ホイール・ピンチで大きさを変えます。`)
};

export const common_picture_failed = /** @type {(inputs: Common_Picture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像を保存できませんでした`)
};

export const common_picture_remove = /** @type {(inputs: Common_Picture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外す`)
};

export const common_picture_stage = /** @type {(inputs: Common_Picture_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切り抜く位置(矢印キーで動かし、+ と - で大きさを変える)`)
};

export const common_picture_unreadable = /** @type {(inputs: Common_Picture_UnreadableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この画像は読めませんでした。PNG・JPEG・GIF・WebP を選んでください。`)
};

export const common_picture_zoom = /** @type {(inputs: Common_Picture_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きさ`)
};

export const common_retry = /** @type {(inputs: Common_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試行`)
};

export const common_save = /** @type {(inputs: Common_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

export const common_today = /** @type {(inputs: Common_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日`)
};

export const common_tomorrow = /** @type {(inputs: Common_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明日`)
};

export const common_yesterday = /** @type {(inputs: Common_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`昨日`)
};

export const datasets_add_row = /** @type {(inputs: Datasets_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行を追加`)
};

export const datasets_col_field = /** @type {(inputs: Datasets_Col_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`項目`)
};

export const datasets_col_filled = /** @type {(inputs: Datasets_Col_FilledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値のある行`)
};

export const datasets_date_clear = /** @type {(inputs: Datasets_Date_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を消去`)
};

export const datasets_date_pick = /** @type {(inputs: Datasets_Date_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を選択`)
};

export const datasets_delete_row = /** @type {(inputs: Datasets_Delete_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行を削除`)
};

export const datasets_delete_row_body = /** @type {(inputs: Datasets_Delete_Row_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この行を Dataset から削除します。元に戻せません。`)
};

export const datasets_distribution = /** @type {(inputs: Datasets_DistributionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} の分布`)
};

export const datasets_distribution_title = /** @type {(inputs: Datasets_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値の分布`)
};

export const datasets_distribution_top = /** @type {(inputs: Datasets_Distribution_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最多 ${i?.count} 行`)
};

export const datasets_edit_row = /** @type {(inputs: Datasets_Edit_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行を編集`)
};

export const datasets_fields = /** @type {(inputs: Datasets_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`項目`)
};

export const datasets_fields_guessed = /** @type {(inputs: Datasets_Fields_GuessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`項目はまだ決まっていません。届いた行から推定して表示しています。`)
};

export const datasets_fields_none = /** @type {(inputs: Datasets_Fields_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ項目はありません。`)
};

export const datasets_json_invalid = /** @type {(inputs: Datasets_Json_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.field}」には JSON を入力してください`)
};

export const datasets_key = /** @type {(inputs: Datasets_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キー`)
};

export const datasets_key_missing = /** @type {(inputs: Datasets_Key_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`キーの項目「${i?.field}」を入力してください`)
};

export const datasets_latest = /** @type {(inputs: Datasets_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行`)
};

export const datasets_latest_note = /** @type {(inputs: Datasets_Latest_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`書き込みの新しい順 · ${i?.shown} / ${i?.count} 行`)
};

export const datasets_list = /** @type {(inputs: Datasets_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset`)
};

export const datasets_list_back = /** @type {(inputs: Datasets_List_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents に戻る`)
};

export const datasets_list_empty = /** @type {(inputs: Datasets_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ Dataset はありません。`)
};

export const datasets_list_load_failed = /** @type {(inputs: Datasets_List_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset を読み込めませんでした`)
};

export const datasets_list_new = /** @type {(inputs: Datasets_List_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい Dataset`)
};

export const datasets_list_none_match = /** @type {(inputs: Datasets_List_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる Dataset はありません。`)
};

export const datasets_load_failed = /** @type {(inputs: Datasets_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset を読み込めませんでした`)
};

export const datasets_new_create = /** @type {(inputs: Datasets_New_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

export const datasets_new_failed = /** @type {(inputs: Datasets_New_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset を作成できませんでした`)
};

export const datasets_new_note = /** @type {(inputs: Datasets_New_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スクリプトや Agent が送る JSON の行を貯めます。この Dataset は自分だけが見られ、個人の文書の ui から読めます。項目は届いた行から推定されます。項目や保持期間を決めておくときは Agent に頼んでください。`)
};

export const datasets_new_title = /** @type {(inputs: Datasets_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名`)
};

export const datasets_no_rows = /** @type {(inputs: Datasets_No_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ行はありません。`)
};

export const datasets_not_found = /** @type {(inputs: Datasets_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Dataset は見つかりません。`)
};

export const datasets_number_invalid = /** @type {(inputs: Datasets_Number_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.field}」には数値を入力してください`)
};

export const datasets_retention = /** @type {(inputs: Datasets_RetentionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} 日より古い行は削除`)
};

export const datasets_row_actions = /** @type {(inputs: Datasets_Row_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行の操作`)
};

export const datasets_row_json = /** @type {(inputs: Datasets_Row_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行(JSON)`)
};

export const datasets_row_json_invalid = /** @type {(inputs: Datasets_Row_Json_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON のオブジェクトを入力してください`)
};

export const datasets_rows = /** @type {(inputs: Datasets_RowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 行`)
};

export const datasets_stat_distinct = /** @type {(inputs: Datasets_Stat_DistinctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 種類`)
};

export const datasets_stat_max = /** @type {(inputs: Datasets_Stat_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最大 ${i?.value}`)
};

export const datasets_stat_mean = /** @type {(inputs: Datasets_Stat_MeanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`平均 ${i?.value}`)
};

export const datasets_stat_min = /** @type {(inputs: Datasets_Stat_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最小 ${i?.value}`)
};

export const datasets_stat_on = /** @type {(inputs: Datasets_Stat_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`チェックあり ${i?.count} 行`)
};

export const datasets_stat_range = /** @type {(inputs: Datasets_Stat_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first} 〜 ${i?.last}`)
};

export const datasets_stat_sum = /** @type {(inputs: Datasets_Stat_SumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`合計 ${i?.value}`)
};

export const datasets_token_close = /** @type {(inputs: Datasets_Token_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const datasets_token_created = /** @type {(inputs: Datasets_Token_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} に発行`)
};

export const datasets_token_endpoint = /** @type {(inputs: Datasets_Token_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送り先`)
};

export const datasets_token_failed = /** @type {(inputs: Datasets_Token_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トークンを発行できませんでした`)
};

export const datasets_token_issue = /** @type {(inputs: Datasets_Token_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トークンを発行`)
};

export const datasets_token_issue_action = /** @type {(inputs: Datasets_Token_Issue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発行`)
};

export const datasets_token_name = /** @type {(inputs: Datasets_Token_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const datasets_token_name_placeholder = /** @type {(inputs: Datasets_Token_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: 毎朝の CI`)
};

export const datasets_token_revoke = /** @type {(inputs: Datasets_Token_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消す`)
};

export const datasets_token_revoke_body = /** @type {(inputs: Datasets_Token_Revoke_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このトークンを使っているスクリプトは、この Dataset に書き込めなくなります。元に戻せません。`)
};

export const datasets_token_revoke_label = /** @type {(inputs: Datasets_Token_Revoke_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を取り消す`)
};

export const datasets_token_shown_once = /** @type {(inputs: Datasets_Token_Shown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このトークンは今だけ表示されます。コピーしてスクリプトに設定してください。`)
};

export const datasets_token_unused = /** @type {(inputs: Datasets_Token_UnusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未使用`)
};

export const datasets_token_used = /** @type {(inputs: Datasets_Token_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最終使用 ${i?.date}`)
};

export const datasets_tokens = /** @type {(inputs: Datasets_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書き込み用トークン`)
};

export const datasets_tokens_failed = /** @type {(inputs: Datasets_Tokens_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トークンを読み込めませんでした`)
};

export const datasets_tokens_left = /** @type {(inputs: Datasets_Tokens_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移したため、移す前に発行したトークンは使えなくなりました。`)
};

export const datasets_tokens_left_next = /** @type {(inputs: Datasets_Tokens_Left_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スクリプトから行を送り続けるには、新しいトークンを発行し、スクリプトに設定してあるトークンと置き換えてください。`)
};

export const datasets_tokens_none = /** @type {(inputs: Datasets_Tokens_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トークンはまだありません。`)
};

export const datasets_tokens_note = /** @type {(inputs: Datasets_Tokens_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スクリプトから行を送るときに使います。トークンで書き込めるのはこの Dataset の行だけです。`)
};

export const datasets_tokens_vault = /** @type {(inputs: Datasets_Tokens_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データが Vault にある間は、書き込み用トークンを使えません。行は「行を追加」か Agent から入れてください。`)
};

export const datasets_type_boolean = /** @type {(inputs: Datasets_Type_BooleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チェックボックス`)
};

export const datasets_type_date = /** @type {(inputs: Datasets_Type_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付`)
};

export const datasets_type_datetime = /** @type {(inputs: Datasets_Type_DatetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日時`)
};

export const datasets_type_json = /** @type {(inputs: Datasets_Type_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON`)
};

export const datasets_type_number = /** @type {(inputs: Datasets_Type_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値`)
};

export const datasets_type_string = /** @type {(inputs: Datasets_Type_StringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト`)
};

export const datasets_updated = /** @type {(inputs: Datasets_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最終更新 ${i?.time}`)
};

export const datasets_viewer_close = /** @type {(inputs: Datasets_Viewer_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const datasets_viewer_open = /** @type {(inputs: Datasets_Viewer_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset を開く`)
};

export const datasets_write_failed = /** @type {(inputs: Datasets_Write_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行を保存できませんでした`)
};

export const datasets_written_at = /** @type {(inputs: Datasets_Written_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書き込み日時`)
};

export const desktop_action_start = /** @type {(inputs: Desktop_Action_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始`)
};

export const desktop_action_stop = /** @type {(inputs: Desktop_Action_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停止`)
};

export const desktop_advanced_agent_bundled = /** @type {(inputs: Desktop_Advanced_Agent_BundledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version}(アプリに同梱)`)
};

export const desktop_app_update_available = /** @type {(inputs: Desktop_App_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリの更新があります`)
};

export const desktop_app_update_version = /** @type {(inputs: Desktop_App_Update_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`バージョン ${i?.version}`)
};

export const desktop_check_flags = /** @type {(inputs: Desktop_Check_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フラグ`)
};

export const desktop_check_foreign_mcp = /** @type {(inputs: Desktop_Check_Foreign_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他の MCP`)
};

export const desktop_check_live = /** @type {(inputs: Desktop_Check_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`疎通確認`)
};

export const desktop_check_live_at = /** @type {(inputs: Desktop_Check_Live_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.at} 時点(${i?.version})`)
};

export const desktop_check_live_at_stale = /** @type {(inputs: Desktop_Check_Live_At_StaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.at} 時点(${i?.version}。今は ${i?.current} — 古い結果)`)
};

export const desktop_check_live_not_run = /** @type {(inputs: Desktop_Check_Live_Not_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`疎通確認: 未実施`)
};

export const desktop_device_add_hint = /** @type {(inputs: Desktop_Device_Add_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria にこの Mac をデバイスとして登録し、Agent を起こします`)
};

export const desktop_device_needs_login = /** @type {(inputs: Desktop_Device_Needs_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先に trameria の窓でサインインしてください`)
};

export const desktop_device_not_registered = /** @type {(inputs: Desktop_Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria のデバイスになっていません`)
};

export const desktop_device_registered = /** @type {(inputs: Desktop_Device_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria のデバイスとして登録しています`)
};

export const desktop_device_remove_hint = /** @type {(inputs: Desktop_Device_Remove_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent を止め、trameria のデバイスの一覧から外します`)
};

export const desktop_device_removed_elsewhere = /** @type {(inputs: Desktop_Device_Removed_ElsewhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Mac はデバイスから外されました。もう一度使うなら「この Mac をデバイスにする」`)
};

export const desktop_find_close = /** @type {(inputs: Desktop_Find_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const desktop_find_next = /** @type {(inputs: Desktop_Find_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次へ`)
};

export const desktop_find_placeholder = /** @type {(inputs: Desktop_Find_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページ内を検索`)
};

export const desktop_find_previous = /** @type {(inputs: Desktop_Find_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前へ`)
};

export const desktop_menubar_agent_toggle = /** @type {(inputs: Desktop_Menubar_Agent_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent の開始と停止`)
};

export const desktop_menubar_block_next = /** @type {(inputs: Desktop_Menubar_Block_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`次 · ${i?.time}`)
};

export const desktop_notifications_blocked = /** @type {(inputs: Desktop_Notifications_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mac の通知が許可されていません`)
};

export const desktop_notifications_blocked_note = /** @type {(inputs: Desktop_Notifications_Blocked_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mac の通知が許可されていません。システム設定の通知でこのアプリを許可すると、メンションなどが mac の通知で届きます`)
};

export const desktop_notifications_need_signed_build = /** @type {(inputs: Desktop_Notifications_Need_Signed_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知を出すには、署名したビルドが要ります。このビルドでは mac の通知が出ません`)
};

export const desktop_notifications_open_settings = /** @type {(inputs: Desktop_Notifications_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`システム設定を開く`)
};

export const desktop_open_main = /** @type {(inputs: Desktop_Open_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria を開く`)
};

export const desktop_quit = /** @type {(inputs: Desktop_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了`)
};

export const desktop_status_connected = /** @type {(inputs: Desktop_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続中`)
};

export const desktop_status_error = /** @type {(inputs: Desktop_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

export const desktop_status_reconnecting = /** @type {(inputs: Desktop_Status_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繋ぎ直しています`)
};

export const desktop_status_starting = /** @type {(inputs: Desktop_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始中`)
};

export const desktop_status_stopped = /** @type {(inputs: Desktop_Status_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停止`)
};

export const desktop_status_stopping = /** @type {(inputs: Desktop_Status_StoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`止めています`)
};

export const desktop_token_unavailable = /** @type {(inputs: Desktop_Token_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この環境ではサインインを保存できません`)
};

export const desktop_usage_loading = /** @type {(inputs: Desktop_Usage_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用量を読み込んでいます…`)
};

export const desktop_usage_not_installed = /** @type {(inputs: Desktop_Usage_Not_InstalledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Mac に見つかりません`)
};

export const desktop_usage_off = /** @type {(inputs: Desktop_Usage_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用上限の取得は設定で切っています`)
};

export const desktop_usage_refresh = /** @type {(inputs: Desktop_Usage_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

export const desktop_usage_settings = /** @type {(inputs: Desktop_Usage_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

export const desktop_usage_stale_error = /** @type {(inputs: Desktop_Usage_Stale_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`取り直せていません: ${i?.error}`)
};

export const desktop_usage_title = /** @type {(inputs: Desktop_Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria の使用量`)
};

export const desktop_usage_updated_at = /** @type {(inputs: Desktop_Usage_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} 時点の数字`)
};

export const desktop_usage_updated_minutes_ago = /** @type {(inputs: Desktop_Usage_Updated_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 分前の数字`)
};

export const documents_agent_memo = /** @type {(inputs: Documents_Agent_MemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI メモ`)
};

export const documents_archive = /** @type {(inputs: Documents_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ`)
};

export const documents_archive_failed = /** @type {(inputs: Documents_Archive_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」をアーカイブできませんでした`)
};

export const documents_block_bullet_list = /** @type {(inputs: Documents_Block_Bullet_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`箇条書き`)
};

export const documents_block_callout = /** @type {(inputs: Documents_Block_CalloutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コールアウト`)
};

export const documents_block_code = /** @type {(inputs: Documents_Block_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コード`)
};

export const documents_block_copied = /** @type {(inputs: Documents_Block_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーしました`)
};

export const documents_block_copy_failed = /** @type {(inputs: Documents_Block_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーできませんでした`)
};

export const documents_block_copy_markdown = /** @type {(inputs: Documents_Block_Copy_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown でコピー`)
};

export const documents_block_delete = /** @type {(inputs: Documents_Block_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const documents_block_divider = /** @type {(inputs: Documents_Block_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`区切り線`)
};

export const documents_block_duplicate = /** @type {(inputs: Documents_Block_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複製`)
};

export const documents_block_file = /** @type {(inputs: Documents_Block_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル`)
};

export const documents_block_file_hint = /** @type {(inputs: Documents_Block_File_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像・添付`)
};

export const documents_block_footnote = /** @type {(inputs: Documents_Block_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`脚注`)
};

export const documents_block_heading1 = /** @type {(inputs: Documents_Block_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見出し1`)
};

export const documents_block_heading2 = /** @type {(inputs: Documents_Block_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見出し2`)
};

export const documents_block_heading3 = /** @type {(inputs: Documents_Block_Heading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見出し3`)
};

export const documents_block_insert = /** @type {(inputs: Documents_Block_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブロックの挿入`)
};

export const documents_block_lift_out = /** @type {(inputs: Documents_Block_Lift_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用から出す`)
};

export const documents_block_menu = /** @type {(inputs: Documents_Block_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブロックの操作`)
};

export const documents_block_menu_section_block = /** @type {(inputs: Documents_Block_Menu_Section_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブロック`)
};

export const documents_block_menu_section_type = /** @type {(inputs: Documents_Block_Menu_Section_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種類を変える`)
};

export const documents_block_mermaid = /** @type {(inputs: Documents_Block_MermaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`図(mermaid)`)
};

export const documents_block_numbered_list = /** @type {(inputs: Documents_Block_Numbered_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`番号リスト`)
};

export const documents_block_paragraph = /** @type {(inputs: Documents_Block_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`段落`)
};

export const documents_block_quote = /** @type {(inputs: Documents_Block_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用`)
};

export const documents_block_table = /** @type {(inputs: Documents_Block_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表`)
};

export const documents_block_task_list = /** @type {(inputs: Documents_Block_Task_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タスクリスト`)
};

export const documents_block_toggle = /** @type {(inputs: Documents_Block_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トグル`)
};

export const documents_block_unwrap_list = /** @type {(inputs: Documents_Block_Unwrap_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストをやめる`)
};

export const documents_block_unwrap_quote = /** @type {(inputs: Documents_Block_Unwrap_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用をやめる`)
};

export const documents_body = /** @type {(inputs: Documents_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本文`)
};

export const documents_body_placeholder = /** @type {(inputs: Documents_Body_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書き始めるか、「/」でブロックを挿入`)
};

export const documents_close = /** @type {(inputs: Documents_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const documents_col_created = /** @type {(inputs: Documents_Col_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

export const documents_col_name = /** @type {(inputs: Documents_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const documents_col_updated = /** @type {(inputs: Documents_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

export const documents_copied_to_own = /** @type {(inputs: Documents_Copied_To_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人の文書にコピーしました`)
};

export const documents_copy = /** @type {(inputs: Documents_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーを作る`)
};

export const documents_copy_failed = /** @type {(inputs: Documents_Copy_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」のコピーを作れませんでした`)
};

export const documents_copy_to_own = /** @type {(inputs: Documents_Copy_To_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人の文書にコピー`)
};

export const documents_create = /** @type {(inputs: Documents_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書を作る`)
};

export const documents_create_failed = /** @type {(inputs: Documents_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書を作れませんでした`)
};

export const documents_delete = /** @type {(inputs: Documents_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const documents_delete_body = /** @type {(inputs: Documents_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本文と履歴も見られなくなります。削除は戻せません。`)
};

export const documents_delete_failed = /** @type {(inputs: Documents_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を削除できませんでした`)
};

export const documents_delete_many_body = /** @type {(inputs: Documents_Delete_Many_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.names}の本文と履歴も見られなくなります。削除は戻せません。`)
};

export const documents_delete_many_title = /** @type {(inputs: Documents_Delete_Many_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件の文書を削除します`)
};

export const documents_delete_title = /** @type {(inputs: Documents_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を削除します`)
};

export const documents_empty = /** @type {(inputs: Documents_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ文書がありません。`)
};

export const documents_empty_archived = /** @type {(inputs: Documents_Empty_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブした文書はありません。`)
};

export const documents_history = /** @type {(inputs: Documents_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`履歴`)
};

export const documents_history_actor_via = /** @type {(inputs: Documents_History_Actor_ViaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}(${i?.connection})`)
};

export const documents_history_change_count = /** @type {(inputs: Documents_History_Change_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} か所の変更`)
};

export const documents_history_changes = /** @type {(inputs: Documents_History_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更`)
};

export const documents_history_empty = /** @type {(inputs: Documents_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ履歴がありません。`)
};

export const documents_history_failed = /** @type {(inputs: Documents_History_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`履歴を読めませんでした`)
};

export const documents_history_is_latest = /** @type {(inputs: Documents_History_Is_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新のバージョンです`)
};

export const documents_history_latest = /** @type {(inputs: Documents_History_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新`)
};

export const documents_history_no_body = /** @type {(inputs: Documents_History_No_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本文がありません`)
};

export const documents_history_no_changes = /** @type {(inputs: Documents_History_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のバージョンとの違いはありません`)
};

export const documents_history_restored = /** @type {(inputs: Documents_History_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻した`)
};

export const documents_history_saves = /** @type {(inputs: Documents_History_SavesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 回の保存`)
};

export const documents_history_system = /** @type {(inputs: Documents_History_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動で記録`)
};

export const documents_history_unchanged = /** @type {(inputs: Documents_History_UnchangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`変更のない ${i?.count} 行`)
};

export const documents_history_versions = /** @type {(inputs: Documents_History_VersionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バージョン`)
};

export const documents_index_add = /** @type {(inputs: Documents_Index_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書を入れる`)
};

export const documents_index_add_existing = /** @type {(inputs: Documents_Index_Add_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作った文書を入れる…`)
};

export const documents_index_add_failed = /** @type {(inputs: Documents_Index_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を入れられませんでした`)
};

export const documents_index_add_new = /** @type {(inputs: Documents_Index_Add_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい文書`)
};

export const documents_index_archived = /** @type {(inputs: Documents_Index_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブした Index です。読むことはできますが、並べ替えはできません。`)
};

export const documents_index_button = /** @type {(inputs: Documents_Index_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index`)
};

export const documents_index_create_failed = /** @type {(inputs: Documents_Index_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index を作れませんでした`)
};

export const documents_index_create_with = /** @type {(inputs: Documents_Index_Create_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい Index を作って入れる`)
};

export const documents_index_default_title = /** @type {(inputs: Documents_Index_Default_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} の Index`)
};

export const documents_index_delete_body = /** @type {(inputs: Documents_Index_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書の並びも一緒に消えます。入っている文書は消えません。削除は戻せません。`)
};

export const documents_index_detach = /** @type {(inputs: Documents_Index_DetachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Index から外す`)
};

export const documents_index_detach_failed = /** @type {(inputs: Documents_Index_Detach_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を外せませんでした`)
};

export const documents_index_empty = /** @type {(inputs: Documents_Index_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ文書が入っていません`)
};

export const documents_index_existing_under = /** @type {(inputs: Documents_Index_Existing_UnderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下に作った文書を入れる…`)
};

export const documents_index_fold = /** @type {(inputs: Documents_Index_FoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下の文書を畳む`)
};

export const documents_index_in = /** @type {(inputs: Documents_Index_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入っている Index`)
};

export const documents_index_in_none = /** @type {(inputs: Documents_Index_In_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだどの Index にも入っていません`)
};

export const documents_index_indent = /** @type {(inputs: Documents_Index_IndentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 つ下の階層へ(前の文書の下)`)
};

export const documents_index_load_failed = /** @type {(inputs: Documents_Index_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index を読み込めませんでした`)
};

export const documents_index_menu = /** @type {(inputs: Documents_Index_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index の操作`)
};

export const documents_index_move_down = /** @type {(inputs: Documents_Index_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下へ`)
};

export const documents_index_move_failed = /** @type {(inputs: Documents_Index_Move_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を動かせませんでした`)
};

export const documents_index_move_up = /** @type {(inputs: Documents_Index_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上へ`)
};

export const documents_index_new_hint = /** @type {(inputs: Documents_Index_New_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を書いて Enter で作ります。文書は作った後に入れます。`)
};

export const documents_index_new_under = /** @type {(inputs: Documents_Index_New_UnderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下に新しい文書`)
};

export const documents_index_open = /** @type {(inputs: Documents_Index_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く`)
};

export const documents_index_outdent = /** @type {(inputs: Documents_Index_OutdentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 つ上の階層へ`)
};

export const documents_index_pick = /** @type {(inputs: Documents_Index_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作った文書を入れる`)
};

export const documents_index_pick_none = /** @type {(inputs: Documents_Index_Pick_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入れられる文書がありません`)
};

export const documents_index_pick_search = /** @type {(inputs: Documents_Index_Pick_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名か本文で探す`)
};

export const documents_index_put_failed = /** @type {(inputs: Documents_Index_Put_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」に入れられませんでした`)
};

export const documents_index_put_in = /** @type {(inputs: Documents_Index_Put_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index に入れる`)
};

export const documents_index_remove_from = /** @type {(inputs: Documents_Index_Remove_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」から外す`)
};

export const documents_index_title = /** @type {(inputs: Documents_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index の名前`)
};

export const documents_index_title_placeholder = /** @type {(inputs: Documents_Index_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const documents_index_unfold = /** @type {(inputs: Documents_Index_UnfoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下の文書を開く`)
};

export const documents_kind_html = /** @type {(inputs: Documents_Kind_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML の文書`)
};

export const documents_kind_index = /** @type {(inputs: Documents_Kind_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index`)
};

export const documents_kind_markdown = /** @type {(inputs: Documents_Kind_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown の文書`)
};

export const documents_kind_slide = /** @type {(inputs: Documents_Kind_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スライド`)
};

export const documents_link_suggest = /** @type {(inputs: Documents_Link_SuggestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクする文書`)
};

export const documents_list_failed = /** @type {(inputs: Documents_List_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書の一覧を読めませんでした`)
};

export const documents_load_failed = /** @type {(inputs: Documents_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書を読めませんでした`)
};

export const documents_menu = /** @type {(inputs: Documents_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書のメニュー`)
};

export const documents_mermaid_default_payload = /** @type {(inputs: Documents_Mermaid_Default_PayloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`flowchart TD
  A[開始] --> B[終了]`)
};

export const documents_missing = /** @type {(inputs: Documents_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この文書は見つかりません。削除されたか、URL が違います。`)
};

export const documents_more = /** @type {(inputs: Documents_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さらに表示`)
};

export const documents_nav = /** @type {(inputs: Documents_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

export const documents_new = /** @type {(inputs: Documents_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい文書`)
};

export const documents_new_document = /** @type {(inputs: Documents_New_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書`)
};

export const documents_new_index = /** @type {(inputs: Documents_New_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい Index`)
};

export const documents_new_index_item = /** @type {(inputs: Documents_New_Index_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index`)
};

export const documents_new_menu = /** @type {(inputs: Documents_New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しく作る`)
};

export const documents_offline = /** @type {(inputs: Documents_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続が切れています。つながり直すと、書いた分が送られます。`)
};

export const documents_outline = /** @type {(inputs: Documents_OutlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目次`)
};

export const documents_outline_headings = /** @type {(inputs: Documents_Outline_HeadingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見出しの一覧`)
};

export const documents_read_only_archived = /** @type {(inputs: Documents_Read_Only_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブした文書です。書くにはアーカイブを戻してください。`)
};

export const documents_read_only_newer = /** @type {(inputs: Documents_Read_Only_NewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいバージョンのアプリで書かれた文書なので、読むだけです。書くにはアプリを更新してください。`)
};

export const documents_read_only_not_writable = /** @type {(inputs: Documents_Read_Only_Not_WritableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この文書を書く権限が無いので、読むだけです。`)
};

export const documents_reload = /** @type {(inputs: Documents_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み直す`)
};

export const documents_reload_needed = /** @type {(inputs: Documents_Reload_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリが新しくなりました。続けて書くには読み込み直してください。`)
};

export const documents_rename_failed = /** @type {(inputs: Documents_Rename_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名を変えられませんでした`)
};

export const documents_restore = /** @type {(inputs: Documents_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このバージョンに戻す`)
};

export const documents_restore_body = /** @type {(inputs: Documents_Restore_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」の本文がこのバージョンの内容になります。今の本文も履歴に残るので、あとで戻せます。`)
};

export const documents_restore_failed = /** @type {(inputs: Documents_Restore_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻せませんでした`)
};

export const documents_restore_title = /** @type {(inputs: Documents_Restore_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time} のバージョンに戻します`)
};

export const documents_row_menu = /** @type {(inputs: Documents_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」の操作`)
};

export const documents_save_pdf = /** @type {(inputs: Documents_Save_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF で保存`)
};

export const documents_selection_bold = /** @type {(inputs: Documents_Selection_BoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`太字 (${i?.key})`)
};

export const documents_selection_code = /** @type {(inputs: Documents_Selection_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`コード (${i?.key})`)
};

export const documents_selection_edit_link = /** @type {(inputs: Documents_Selection_Edit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクを編集`)
};

export const documents_selection_format = /** @type {(inputs: Documents_Selection_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書式`)
};

export const documents_selection_italic = /** @type {(inputs: Documents_Selection_ItalicInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`斜体 (${i?.key})`)
};

export const documents_selection_link = /** @type {(inputs: Documents_Selection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンク`)
};

export const documents_selection_link_url = /** @type {(inputs: Documents_Selection_Link_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンク先の URL`)
};

export const documents_selection_open_link = /** @type {(inputs: Documents_Selection_Open_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`開く (${i?.key}+クリック)`)
};

export const documents_selection_paste_url = /** @type {(inputs: Documents_Selection_Paste_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL を貼る`)
};

export const documents_selection_strike = /** @type {(inputs: Documents_Selection_StrikeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`打ち消し線 (${i?.key})`)
};

export const documents_selection_unlink = /** @type {(inputs: Documents_Selection_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクを外す`)
};

export const documents_show = /** @type {(inputs: Documents_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示する文書`)
};

export const documents_show_active = /** @type {(inputs: Documents_Show_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用中`)
};

export const documents_show_archived = /** @type {(inputs: Documents_Show_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ`)
};

export const documents_slide_next = /** @type {(inputs: Documents_Slide_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のスライド`)
};

export const documents_slide_previous = /** @type {(inputs: Documents_Slide_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のスライド`)
};

export const documents_source = /** @type {(inputs: Documents_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソース`)
};

export const documents_source_close = /** @type {(inputs: Documents_Source_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示に戻る`)
};

export const documents_source_conflict = /** @type {(inputs: Documents_Source_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかで本文が変わっていたので、今の本文を読み込みました。直しをもう一度当ててから保存してください。`)
};

export const documents_source_edit = /** @type {(inputs: Documents_Source_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースを編集`)
};

export const documents_source_query = /** @type {(inputs: Documents_Source_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示するときのクエリ`)
};

export const documents_source_query_failed = /** @type {(inputs: Documents_Source_Query_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クエリを保存できませんでした`)
};

export const documents_source_save = /** @type {(inputs: Documents_Source_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

export const documents_source_save_failed = /** @type {(inputs: Documents_Source_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存できませんでした`)
};

export const documents_source_saved = /** @type {(inputs: Documents_Source_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存しました`)
};

export const documents_suggest_empty = /** @type {(inputs: Documents_Suggest_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`候補がありません`)
};

export const documents_title = /** @type {(inputs: Documents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名`)
};

export const documents_title_placeholder = /** @type {(inputs: Documents_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名`)
};

export const documents_unarchive = /** @type {(inputs: Documents_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブを戻す`)
};

export const documents_unarchive_failed = /** @type {(inputs: Documents_Unarchive_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」のアーカイブを戻せませんでした`)
};

export const documents_untitled = /** @type {(inputs: Documents_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無題`)
};

export const editor_diff_block_count = /** @type {(inputs: Editor_Diff_Block_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ブロック数が違います(live ${i?.live} / 候補 ${i?.candidate})`)
};

export const editor_excerpt_callout = /** @type {(inputs: Editor_Excerpt_CalloutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(コールアウト)`)
};

export const editor_excerpt_code = /** @type {(inputs: Editor_Excerpt_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(コード)`)
};

export const editor_excerpt_empty = /** @type {(inputs: Editor_Excerpt_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(空のブロック)`)
};

export const editor_excerpt_html = /** @type {(inputs: Editor_Excerpt_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(HTML)`)
};

export const editor_excerpt_mermaid = /** @type {(inputs: Editor_Excerpt_MermaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(mermaid)`)
};

export const editor_excerpt_rule = /** @type {(inputs: Editor_Excerpt_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(区切り線)`)
};

export const editor_excerpt_table = /** @type {(inputs: Editor_Excerpt_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(表)`)
};

export const editor_shape_attr_differs = /** @type {(inputs: Editor_Shape_Attr_DiffersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} が違います`)
};

export const editor_shape_block_count_differs = /** @type {(inputs: Editor_Shape_Block_Count_DiffersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ブロックの数が違います(${i?.from} → ${i?.to})`)
};

export const editor_shape_child_count_differs = /** @type {(inputs: Editor_Shape_Child_Count_DiffersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`子ブロックの数が違います(${i?.from} → ${i?.to})`)
};

export const editor_shape_type_differs = /** @type {(inputs: Editor_Shape_Type_DiffersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`種別が違います(${i?.from} → ${i?.to})`)
};

export const editor_table_option_fix_range = /** @type {(inputs: Editor_Table_Option_Fix_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} は 0〜2`)
};

export const editor_table_option_shape = /** @type {(inputs: Editor_Table_Option_ShapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オプション行の形が違います`)
};

export const editor_table_option_twice = /** @type {(inputs: Editor_Table_Option_TwiceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} が 2 回`)
};

export const editor_table_option_unknown_key = /** @type {(inputs: Editor_Table_Option_Unknown_KeyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`知らないキー ${i?.key}`)
};

export const editor_table_option_widths = /** @type {(inputs: Editor_Table_Option_WidthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`widths は正の数のカンマ区切り`)
};

export const editor_toggle_body_placeholder = /** @type {(inputs: Editor_Toggle_Body_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容`)
};

export const editor_toggle_summary_placeholder = /** @type {(inputs: Editor_Toggle_Summary_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トグル`)
};

export const inbox_answered_by_parent = /** @type {(inputs: Inbox_Answered_By_ParentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} が代わりに答えた`)
};

export const inbox_case = /** @type {(inputs: Inbox_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case で絞る`)
};

export const inbox_case_all = /** @type {(inputs: Inbox_Case_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての Case`)
};

export const inbox_chat = /** @type {(inputs: Inbox_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話で絞る`)
};

export const inbox_chat_all = /** @type {(inputs: Inbox_Chat_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての会話`)
};

export const inbox_done = /** @type {(inputs: Inbox_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`済んだもの`)
};

export const inbox_done_by_agent = /** @type {(inputs: Inbox_Done_By_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent が済ませた`)
};

export const inbox_done_empty = /** @type {(inputs: Inbox_Done_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`済んだ件はまだありません`)
};

export const inbox_dot = /** @type {(inputs: Inbox_DotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いま自分の番があります`)
};

export const inbox_from = /** @type {(inputs: Inbox_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} から`)
};

export const inbox_go = /** @type {(inputs: Inbox_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox を開く`)
};

export const inbox_kind_dm = /** @type {(inputs: Inbox_Kind_DmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM`)
};

export const inbox_kind_mention = /** @type {(inputs: Inbox_Kind_MentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンション`)
};

export const inbox_kind_question = /** @type {(inputs: Inbox_Kind_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`質問`)
};

export const inbox_kind_reply = /** @type {(inputs: Inbox_Kind_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返事`)
};

export const inbox_load_failed = /** @type {(inputs: Inbox_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox を読めませんでした`)
};

export const inbox_narrow = /** @type {(inputs: Inbox_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox を絞り込む`)
};

export const inbox_narrow_placeholder = /** @type {(inputs: Inbox_Narrow_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題と答えで探す`)
};

export const inbox_nav = /** @type {(inputs: Inbox_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

export const inbox_no_match = /** @type {(inputs: Inbox_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまるものはありません`)
};

export const inbox_now = /** @type {(inputs: Inbox_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いま自分の番`)
};

export const inbox_now_empty = /** @type {(inputs: Inbox_Now_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いま待っているものはありません`)
};

export const inbox_unread = /** @type {(inputs: Inbox_UnreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`未読 ${i?.count} 件`)
};

export const inbox_withdrawn = /** @type {(inputs: Inbox_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り下げ`)
};

export const inbox_workspace_unreachable = /** @type {(inputs: Inbox_Workspace_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace の DM・メンションは前に読んだままです`)
};

export const inbox_workspace_unreachable_empty = /** @type {(inputs: Inbox_Workspace_Unreachable_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace の DM・メンションを読めません`)
};

export const inbox_workspace_unreachable_why = /** @type {(inputs: Inbox_Workspace_Unreachable_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に繋がらず、読めませんでした。繋がれば出ます`)
};

export const labels_color_custom = /** @type {(inputs: Labels_Color_CustomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」の好きな色`)
};

export const labels_color_failed = /** @type {(inputs: Labels_Color_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ラベル「${i?.name}」の色を変えられませんでした`)
};

export const labels_color_of = /** @type {(inputs: Labels_Color_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」の色`)
};

export const labels_create_failed = /** @type {(inputs: Labels_Create_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ラベル「${i?.name}」を作れませんでした`)
};

export const labels_create_named = /** @type {(inputs: Labels_Create_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`新しいラベル「${i?.name}」を作る`)
};

export const labels_delete = /** @type {(inputs: Labels_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を削除`)
};

export const labels_delete_body = /** @type {(inputs: Labels_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付いている Case からも外れます。`)
};

export const labels_delete_failed = /** @type {(inputs: Labels_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ラベル「${i?.name}」を削除できませんでした`)
};

export const labels_delete_title = /** @type {(inputs: Labels_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ラベル「${i?.name}」を削除しますか?`)
};

export const labels_move_down = /** @type {(inputs: Labels_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を下へ`)
};

export const labels_move_failed = /** @type {(inputs: Labels_Move_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベルの並びを変えられませんでした`)
};

export const labels_move_up = /** @type {(inputs: Labels_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を上へ`)
};

export const labels_name = /** @type {(inputs: Labels_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベルの名前`)
};

export const labels_new = /** @type {(inputs: Labels_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベルを作る`)
};

export const labels_pick_empty = /** @type {(inputs: Labels_Pick_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベルはまだありません。名前を打つと作れます`)
};

export const labels_pick_placeholder = /** @type {(inputs: Labels_Pick_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベルを探す / 新しいラベルの名前`)
};

export const labels_rename_failed = /** @type {(inputs: Labels_Rename_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ラベル「${i?.name}」の名前を変えられませんでした`)
};

export const labels_settings_description = /** @type {(inputs: Labels_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case に付けるラベル。名前・色・並びを決めます。`)
};

export const labels_title = /** @type {(inputs: Labels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

export const local_agent_diagram = /** @type {(inputs: Local_Agent_DiagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の Agent に指示を送れるデバイス`)
};

export const local_agent_diagram_browser = /** @type {(inputs: Local_Agent_Diagram_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザ`)
};

export const local_agent_diagram_carrier = /** @type {(inputs: Local_Agent_Diagram_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud・Vault`)
};

export const local_agent_diagram_carrier_note = /** @type {(inputs: Local_Agent_Diagram_Carrier_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指示を届けるだけ`)
};

export const local_agent_diagram_devices = /** @type {(inputs: Local_Agent_Diagram_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマートフォン・ほかの PC`)
};

export const local_agent_diagram_in_list = /** @type {(inputs: Local_Agent_Diagram_In_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリスト`)
};

export const local_agent_diagram_refused = /** @type {(inputs: Local_Agent_Diagram_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用できない`)
};

export const local_agent_diagram_signed = /** @type {(inputs: Local_Agent_Diagram_SignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`署名`)
};

export const local_agent_diagram_this_app = /** @type {(inputs: Local_Agent_Diagram_This_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC のアプリ`)
};

export const local_agent_help_browser = /** @type {(inputs: Local_Agent_Help_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザと、デバイスリストにないデバイスからは、オンでも利用できません。`)
};

export const local_agent_help_signed = /** @type {(inputs: Local_Agent_Help_SignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指示は送ったデバイスで署名され、Agent が確認します。Cloud や Vault は指示を書き換えられません。`)
};

export const local_agent_help_title = /** @type {(inputs: Local_Agent_Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスからの利用`)
};

export const local_agent_others = /** @type {(inputs: Local_Agent_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスからの利用を許可`)
};

export const local_agent_others_note = /** @type {(inputs: Local_Agent_Others_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマートフォンやほかの PC からも利用できます。`)
};

export const local_agent_others_off_note = /** @type {(inputs: Local_Agent_Others_Off_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフにすると、この PC のアプリからだけ利用できます。`)
};

export const local_agent_others_vault_off_note = /** @type {(inputs: Local_Agent_Others_Vault_Off_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オフにすると、${i?.name} のアプリからだけ利用できます。`)
};

export const local_agent_use = /** @type {(inputs: Local_Agent_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の Agent を使う`)
};

export const local_agent_use_note = /** @type {(inputs: Local_Agent_Use_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフにすると、この PC では Agent を動かしません。`)
};

export const local_backup = /** @type {(inputs: Local_BackupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バックアップ`)
};

export const local_backup_choose = /** @type {(inputs: Local_Backup_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダを選ぶ…`)
};

export const local_backup_default = /** @type {(inputs: Local_Backup_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既定(データのフォルダの中)`)
};

export const local_backup_description = /** @type {(inputs: Local_Backup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データベースとファイルのバックアップを、アプリを終了するときと 3 時間ごとに取ります。データベースが開けなくなったときは、ここから戻します。`)
};

export const local_backup_error_failed = /** @type {(inputs: Local_Backup_Error_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存先を変えられませんでした。`)
};

export const local_backup_error_inside_data = /** @type {(inputs: Local_Backup_Error_Inside_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データのフォルダそのものと、その中のデータベースやファイルの保存先は選べません。`)
};

export const local_backup_error_not_absolute = /** @type {(inputs: Local_Backup_Error_Not_AbsoluteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダはフルパスで指定してください。`)
};

export const local_backup_error_not_writable = /** @type {(inputs: Local_Backup_Error_Not_WritableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このフォルダには書き込めません。`)
};

export const local_backup_failed = /** @type {(inputs: Local_Backup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バックアップの設定を読めませんでした。`)
};

export const local_backup_folder = /** @type {(inputs: Local_Backup_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存先`)
};

export const local_backup_folder_note = /** @type {(inputs: Local_Backup_Folder_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外付けのドライブや NAS のフォルダを選ぶと、この PC やディスクが壊れてもバックアップが残ります。保存先を変えても、前の保存先のバックアップは消しません。`)
};

export const local_backup_last = /** @type {(inputs: Local_Backup_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後のバックアップ`)
};

export const local_backup_missing = /** @type {(inputs: Local_Backup_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このフォルダが見つからないので、いまはデータのフォルダの中にバックアップしています。ドライブを繋ぐと、次のバックアップからこのフォルダに戻ります。`)
};

export const local_backup_none = /** @type {(inputs: Local_Backup_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだありません`)
};

export const local_backup_not_writable = /** @type {(inputs: Local_Backup_Not_WritableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このフォルダに書き込めないので、いまはデータのフォルダの中にバックアップしています。`)
};

export const local_backup_path = /** @type {(inputs: Local_Backup_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダのパス`)
};

export const local_backup_reset = /** @type {(inputs: Local_Backup_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既定に戻す`)
};

export const local_backup_use = /** @type {(inputs: Local_Backup_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使う`)
};

export const local_cloud = /** @type {(inputs: Local_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud`)
};

export const local_cloud_account = /** @type {(inputs: Local_Cloud_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント`)
};

export const local_cloud_account_settings = /** @type {(inputs: Local_Cloud_Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud のアカウント`)
};

export const local_cloud_account_settings_description = /** @type {(inputs: Local_Cloud_Account_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セキュリティ・パスキー・連携しているアプリなど、Cloud のアカウントの設定を開きます。`)
};

export const local_cloud_again_done = /** @type {(inputs: Local_Cloud_Again_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインし直しました。`)
};

export const local_cloud_agent_failed = /** @type {(inputs: Local_Cloud_Agent_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud にこの PC を登録できませんでした。オフにしてから、もう一度オンにしてください。`)
};

export const local_cloud_agent_removed = /** @type {(inputs: Local_Cloud_Agent_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud でこの PC が削除されました。もう一度使うには、オフにしてからオンにしてください。`)
};

export const local_cloud_code_note = /** @type {(inputs: Local_Cloud_Code_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザで開いたページに同じコードが出ているのを確かめてから、連携してください。コードを求められたら、このコードを入力してください。`)
};

export const local_cloud_denied = /** @type {(inputs: Local_Cloud_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拒否されました。`)
};

export const local_cloud_description = /** @type {(inputs: Local_Cloud_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC を trameria Cloud のアカウントと連携します。サインインするまで、この PC は Cloud と通信しません。`)
};

export const local_cloud_device = /** @type {(inputs: Local_Cloud_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC のサインイン`)
};

export const local_cloud_device_done = /** @type {(inputs: Local_Cloud_Device_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインしました。`)
};

export const local_cloud_device_hub_not_tied = /** @type {(inputs: Local_Cloud_Device_Hub_Not_TiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先に Vault を Cloud のアカウントと連携してください。`)
};

export const local_cloud_device_hub_unreachable = /** @type {(inputs: Local_Cloud_Device_Hub_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続できないため、Vault のアカウントを確認できません。Vault に接続してからサインインしてください。`)
};

export const local_cloud_device_in = /** @type {(inputs: Local_Cloud_Device_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} でサインインしています。token はこの PC だけが持ち、Vault には渡しません。`)
};

export const local_cloud_device_mismatch = /** @type {(inputs: Local_Cloud_Device_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault は ${i?.hub} と連携しています。この PC は ${i?.mine} でサインインしているため、サインアウトしてから ${i?.hub} でサインインしてください。`)
};

export const local_cloud_device_needs_hub = /** @type {(inputs: Local_Cloud_Device_Needs_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault を連携すると、この PC も同じアカウントでサインインできます。`)
};

export const local_cloud_device_none = /** @type {(inputs: Local_Cloud_Device_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインしていません。サインインすると、この PC が自分の token で Cloud に接続します。Vault が止まっていても使えます。`)
};

export const local_cloud_device_other = /** @type {(inputs: Local_Cloud_Device_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.account} ではサインインできません。Vault は ${i?.tied} と連携しています。`)
};

export const local_cloud_expired = /** @type {(inputs: Local_Cloud_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードの期限が切れました。もう一度サインインしてください。`)
};

export const local_cloud_frame = /** @type {(inputs: Local_Cloud_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud のページ`)
};

export const local_cloud_frame_signed_out_body = /** @type {(inputs: Local_Cloud_Frame_Signed_Out_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリの設定の「Cloud」でサインインし直してください。サインインはブラウザで行います。`)
};

export const local_cloud_from_login = /** @type {(inputs: Local_Cloud_From_LoginInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} でこの PC をデバイスリストに追加したときに、自動的にサインインしました。`)
};

export const local_cloud_hub_away = /** @type {(inputs: Local_Cloud_Hub_AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続できません。この PC のサインインは、そのまま使えます。`)
};

export const local_cloud_hub_row = /** @type {(inputs: Local_Cloud_Hub_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault(${i?.main})の連携`)
};

export const local_cloud_hub_token = /** @type {(inputs: Local_Cloud_Hub_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC から始めても、token は Vault だけが持ちます。`)
};

export const local_cloud_linked = /** @type {(inputs: Local_Cloud_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続している間は、ここからサインインできません。`)
};

export const local_cloud_login = /** @type {(inputs: Local_Cloud_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインイン`)
};

export const local_cloud_login_again = /** @type {(inputs: Local_Cloud_Login_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインし直す`)
};

export const local_cloud_logout = /** @type {(inputs: Local_Cloud_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインアウト`)
};

export const local_cloud_logout_body = /** @type {(inputs: Local_Cloud_Logout_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の token を Cloud に返して、この PC から消します。Vault の連携とデータはそのまま残ります。`)
};

export const local_cloud_logout_failed = /** @type {(inputs: Local_Cloud_Logout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインアウトできませんでした`)
};

export const local_cloud_logout_title = /** @type {(inputs: Local_Cloud_Logout_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} からサインアウトしますか`)
};

export const local_cloud_none = /** @type {(inputs: Local_Cloud_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携していません`)
};

export const local_cloud_open = /** @type {(inputs: Local_Cloud_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザで開く`)
};

export const local_cloud_other = /** @type {(inputs: Local_Cloud_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.account} ではサインインできません。この PC は ${i?.tied} と連携しています。`)
};

export const local_cloud_restarting = /** @type {(inputs: Local_Cloud_RestartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携しました。trameria を起こし直しています…`)
};

export const local_cloud_retry = /** @type {(inputs: Local_Cloud_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一度試す`)
};

export const local_cloud_signed_out_body = /** @type {(inputs: Local_Cloud_Signed_Out_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは Cloud にあります。アプリの設定の「Cloud」でサインインし直すと、また表示されます。`)
};

export const local_cloud_signed_out_open = /** @type {(inputs: Local_Cloud_Signed_Out_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリの設定を開く`)
};

export const local_cloud_signed_out_title = /** @type {(inputs: Local_Cloud_Signed_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud からサインアウトしています`)
};

export const local_cloud_tied = /** @type {(inputs: Local_Cloud_TiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} と連携しています。連携を解除するまで、ほかのアカウントとは連携できません。`)
};

export const local_cloud_unlink = /** @type {(inputs: Local_Cloud_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携を解除`)
};

export const local_cloud_unlink_body = /** @type {(inputs: Local_Cloud_Unlink_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC は Cloud と通信しなくなります。この PC のデータはそのまま残ります。解除した後は、別のアカウントとも連携できます。`)
};

export const local_cloud_unlink_failed = /** @type {(inputs: Local_Cloud_Unlink_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携を解除できませんでした`)
};

export const local_cloud_unlink_title = /** @type {(inputs: Local_Cloud_Unlink_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} との連携を解除しますか`)
};

export const local_cloud_unreachable = /** @type {(inputs: Local_Cloud_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に接続できませんでした`)
};

export const local_cloud_unreached_body = /** @type {(inputs: Local_Cloud_Unreached_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワークか Cloud の状態を確かめてから、もう一度試してください。Personal はこのまま使えます。`)
};

export const local_cloud_unreached_title = /** @type {(inputs: Local_Cloud_Unreached_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に接続できません`)
};

export const local_cloud_waiting = /** @type {(inputs: Local_Cloud_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザでの連携を待っています…`)
};

export const local_dms = /** @type {(inputs: Local_DmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM`)
};

export const local_dms_unread = /** @type {(inputs: Local_Dms_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未読あり`)
};

export const local_headless_backup_dir = /** @type {(inputs: Local_Headless_Backup_DirInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`バックアップの保存先: ${i?.dir}`)
};

export const local_headless_backup_dir_refused = /** @type {(inputs: Local_Headless_Backup_Dir_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`--backup-dir ${i?.dir} は使えません: ${i?.reason}`)
};

export const local_headless_connect_to = /** @type {(inputs: Local_Headless_Connect_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ほかのデバイスからの接続先: ${i?.addresses}`)
};

export const local_headless_could_not_start = /** @type {(inputs: Local_Headless_Could_Not_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} を起動できませんでした: ${i?.error}`)
};

export const local_headless_linked = /** @type {(inputs: Local_Headless_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dir} の ${i?.app} は Vault に繋いでいるため、Vault として動かせません。設定「Vault」で繋ぐのをやめてから、起動し直してください。`)
};

export const local_headless_login_again = /** @type {(inputs: Local_Headless_Login_AgainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.account} でサインインし直しました。`)
};

export const local_headless_login_bound = /** @type {(inputs: Local_Headless_Login_BoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.account} と連携しました。${i?.app} を起こし直します。`)
};

export const local_headless_login_denied = /** @type {(inputs: Local_Headless_Login_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拒否されました。連携していません。`)
};

export const local_headless_login_expired = /** @type {(inputs: Local_Headless_Login_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードの期限が切れました。もう一度 --headless --login を打ってください。`)
};

export const local_headless_login_failed = /** @type {(inputs: Local_Headless_Login_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cloud にサインインできませんでした: ${i?.error}`)
};

export const local_headless_login_linked = /** @type {(inputs: Local_Headless_Login_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dir} の ${i?.app} は Vault に繋いでいるため、Cloud にサインインできません。`)
};

export const local_headless_login_not_running = /** @type {(inputs: Local_Headless_Login_Not_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dir} で ${i?.app} が動いていません。先に起動してから(${i?.app} --headless か、サービスで)、もう一度 --headless --login を打ってください。`)
};

export const local_headless_login_open = /** @type {(inputs: Local_Headless_Login_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ブラウザで ${i?.url} を開き、コード ${i?.code} を入れて連携してください(あと ${i?.minutes} 分有効)。`)
};

export const local_headless_login_other = /** @type {(inputs: Local_Headless_Login_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.account} ではサインインできません。この Vault は ${i?.tied} と連携しています。`)
};

export const local_headless_login_waiting = /** @type {(inputs: Local_Headless_Login_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携を待っています…`)
};

export const local_headless_others_not_running = /** @type {(inputs: Local_Headless_Others_Not_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dir} で ${i?.app} が動いていません。先に起動してから(${i?.app} --headless か、サービスで)、もう一度 --headless --other-devices を打ってください。`)
};

export const local_headless_others_off = /** @type {(inputs: Local_Headless_Others_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の Agent は、ほかのデバイスからの利用を許可していません。`)
};

export const local_headless_others_on = /** @type {(inputs: Local_Headless_Others_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の Agent は、ほかのデバイスからの利用を許可しています。`)
};

export const local_headless_others_usage = /** @type {(inputs: Local_Headless_Others_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`--other-devices の後に on か off を書いてください。`)
};

export const local_headless_pair_failed = /** @type {(inputs: Local_Headless_Pair_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ペアリングのコードを作れませんでした: ${i?.error}`)
};

export const local_headless_pair_no_pairing = /** @type {(inputs: Local_Headless_Pair_No_PairingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dir} で動いている ${i?.app} はこの方法でコードを作れません。更新してから起動し直してください。`)
};

export const local_headless_pair_not_running = /** @type {(inputs: Local_Headless_Pair_Not_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dir} で ${i?.app} が動いていません。先に起動してから(${i?.app} --headless か、サービスで)、もう一度 --headless --pair を打ってください。`)
};

export const local_headless_pair_port_in_use = /** @type {(inputs: Local_Headless_Pair_Port_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dir} で動いている ${i?.app} にほかのデバイスから繋げません: ポート ${i?.port} を別のプログラムが使っています。空けてから ${i?.app} を起動し直してください。`)
};

export const local_headless_pair_remote_off = /** @type {(inputs: Local_Headless_Pair_Remote_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dir} で動いている ${i?.app} は、ほかのデバイスからの接続を切っています。`)
};

export const local_headless_pairing_code = /** @type {(inputs: Local_Headless_Pairing_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ペアリングのコード(1 回だけ使えます。あと ${i?.minutes} 分有効): ${i?.code}`)
};

export const local_headless_port = /** @type {(inputs: Local_Headless_PortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ポート ${i?.port}`)
};

export const local_headless_port_in_use = /** @type {(inputs: Local_Headless_Port_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ほかのデバイスからは繋げません: ポート ${i?.port} が使われています(${i?.error})`)
};

export const local_headless_restored = /** @type {(inputs: Local_Headless_RestoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`データベースを開けなかったため、${i?.time} のバックアップから戻しました。それより後の変更は失われています。`)
};

export const local_headless_running = /** @type {(inputs: Local_Headless_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} をウィンドウを開かずに動かしています(データ: ${i?.dir})`)
};

export const local_headless_unlink_done = /** @type {(inputs: Local_Headless_Unlink_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.account} との連携を解除しました。`)
};

export const local_headless_unlink_none = /** @type {(inputs: Local_Headless_Unlink_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携していません。`)
};

export const local_headless_unlink_not_running = /** @type {(inputs: Local_Headless_Unlink_Not_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dir} で ${i?.app} が動いていません。先に起動してから(${i?.app} --headless か、サービスで)、もう一度 --headless --unlink を打ってください。`)
};

export const local_link_connected = /** @type {(inputs: Local_Link_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続しています。`)
};

export const local_link_connected_cloud = /** @type {(inputs: Local_Link_Connected_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud 経由で接続しています。`)
};

export const local_link_connected_via = /** @type {(inputs: Local_Link_Connected_ViaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.where} で接続しています。`)
};

export const local_link_connecting = /** @type {(inputs: Local_Link_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再接続しています。`)
};

export const local_link_hub_door = /** @type {(inputs: Local_Link_Hub_DoorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault(${i?.main})で Cloud 経由の接続を受け付ける`)
};

export const local_link_hub_door_away = /** @type {(inputs: Local_Link_Hub_Door_AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続していないため、変更できません。`)
};

export const local_link_hub_door_not_tied = /** @type {(inputs: Local_Link_Hub_Door_Not_TiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault が Cloud と連携すると使えます。`)
};

export const local_link_hub_door_note = /** @type {(inputs: Local_Link_Hub_Door_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault の設定です。オンにすると、ネットワーク外のデバイスが Cloud 経由で Vault に接続できます。`)
};

export const local_link_hub_door_via_cloud = /** @type {(inputs: Local_Link_Hub_Door_Via_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud 経由で接続している間は変更できません。`)
};

export const local_link_invalid_code = /** @type {(inputs: Local_Link_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードの形が違います。`)
};

export const local_link_is_hub = /** @type {(inputs: Local_Link_Is_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC は Vault なので接続できません。`)
};

export const local_link_join = /** @type {(inputs: Local_Link_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続する`)
};

export const local_link_join_button = /** @type {(inputs: Local_Link_Join_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続`)
};

export const local_link_join_note = /** @type {(inputs: Local_Link_Join_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault にする PC の設定「デバイスを接続」で表示されるコードを入力します。接続している間は Vault のデータを利用し、この PC のデータはそのまま残ります。`)
};

export const local_link_leave = /** @type {(inputs: Local_Link_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続をやめる`)
};

export const local_link_leave_body = /** @type {(inputs: Local_Link_Leave_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC のもとのデータに戻ります。Vault のデータはそのまま残ります。`)
};

export const local_link_leave_title = /** @type {(inputs: Local_Link_Leave_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} への接続をやめますか`)
};

export const local_link_main = /** @type {(inputs: Local_Link_MainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} のデータを使っています`)
};

export const local_link_network_settings = /** @type {(inputs: Local_Link_Network_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローカルネットワークの設定を開く`)
};

export const local_link_open_settings = /** @type {(inputs: Local_Link_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を開く`)
};

export const local_link_reconnecting = /** @type {(inputs: Local_Link_ReconnectingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} に再接続しています`)
};

export const local_link_reconnecting_not_listening = /** @type {(inputs: Local_Link_Reconnecting_Not_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再接続しています。Vault が Cloud 経由の接続を受け付けていません。`)
};

export const local_link_reconnecting_sign_in = /** @type {(inputs: Local_Link_Reconnecting_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再接続しています。「Cloud」の項目で、この PC からサインインし直してください。`)
};

export const local_link_refused = /** @type {(inputs: Local_Link_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このコードは使えませんでした。Vault で新しいコードを出してください。`)
};

export const local_link_removed = /** @type {(inputs: Local_Link_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} から外されました`)
};

export const local_link_removed_short = /** @type {(inputs: Local_Link_Removed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault から外されました。接続をやめてから、もう一度接続してください。`)
};

export const local_link_routes = /** @type {(inputs: Local_Link_RoutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワーク外では Cloud 経由で Vault に接続する`)
};

export const local_link_routes_cloud_home = /** @type {(inputs: Local_Link_Routes_Cloud_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データが Cloud にあるため、いまは使われません。`)
};

export const local_link_routes_no_sign_in = /** @type {(inputs: Local_Link_Routes_No_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「Cloud」の項目でこの PC からサインインすると使えます。`)
};

export const local_link_routes_note = /** @type {(inputs: Local_Link_Routes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続できない場所でも、Cloud 経由で Vault の Personal データを利用できます。通信は暗号化されたままです。`)
};

export const local_link_screen_app_outdated = /** @type {(inputs: Local_Link_Screen_App_OutdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この PC のアプリが ${i?.main} より古いため、この PC の画面で表示しています。アプリを更新すると ${i?.main} と同じ画面になります。`)
};

export const local_link_screen_hub_outdated = /** @type {(inputs: Local_Link_Screen_Hub_OutdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} のアプリが古いため、この PC の画面で表示しています。`)
};

export const local_link_unreachable = /** @type {(inputs: Local_Link_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続できませんでした。Vault が接続を受け付けているか、同じネットワークか Tailscale にいるかを確認してください。`)
};

export const local_link_unreachable_mac = /** @type {(inputs: Local_Link_Unreachable_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じネットワークにいるのに接続できないときは、システム設定のローカルネットワークでこのアプリが許可されているかも確認してください。`)
};

export const local_link_unreachable_now = /** @type {(inputs: Local_Link_Unreachable_NowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} に接続していません`)
};

export const local_link_write_failed = /** @type {(inputs: Local_Link_Write_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} に接続していないため、保存できませんでした。`)
};

export const local_mcp = /** @type {(inputs: Local_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP クライアント`)
};

export const local_mcp_claude_code_note = /** @type {(inputs: Local_Mcp_Claude_Code_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターミナルで実行します。`)
};

export const local_mcp_claude_desktop_note = /** @type {(inputs: Local_Mcp_Claude_Desktop_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定の「開発者」→「構成を編集」で開く claude_desktop_config.json の mcpServers に足します。`)
};

export const local_mcp_codex_note = /** @type {(inputs: Local_Mcp_Codex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~/.codex/config.toml に足します。`)
};

export const local_mcp_copied = /** @type {(inputs: Local_Mcp_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーしました`)
};

export const local_mcp_copy = /** @type {(inputs: Local_Mcp_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

export const local_mcp_copy_failed = /** @type {(inputs: Local_Mcp_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーできませんでした`)
};

export const local_mcp_description = /** @type {(inputs: Local_Mcp_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claude Code・Codex・Claude Desktop から、この PC の Case・People・文書を読み書きできるようにします。このアプリが開いている間だけ繋がります。`)
};

export const local_mcp_load_failed = /** @type {(inputs: Local_Mcp_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした`)
};

export const local_mcp_retry = /** @type {(inputs: Local_Mcp_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一度`)
};

export const local_mcp_unavailable = /** @type {(inputs: Local_Mcp_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここからは MCP クライアントに繋げません。`)
};

export const local_me_cancel = /** @type {(inputs: Local_Me_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消す`)
};

export const local_me_cancel_body = /** @type {(inputs: Local_Me_Cancel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは元の場所に戻り、また書き込めるようになります。`)
};

export const local_me_cancel_title = /** @type {(inputs: Local_Me_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移すのを取り消しますか`)
};

export const local_me_cancelled = /** @type {(inputs: Local_Me_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移すのを取り消しました`)
};

export const local_me_changes = /** @type {(inputs: Local_Me_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変わること`)
};

export const local_me_check_far_note = /** @type {(inputs: Local_Me_Check_Far_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Vault に繋がらない場所からは読み書きできなくなります。`)
};

export const local_me_check_far_title = /** @type {(inputs: Local_Me_Check_Far_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外のアプリの MCP・離れた場所の agent`)
};

export const local_me_check_google_note = /** @type {(inputs: Local_Me_Check_Google_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移した後に、もう一度繋いでください。`)
};

export const local_me_check_google_title = /** @type {(inputs: Local_Me_Check_Google_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google カレンダー`)
};

export const local_me_check_hub_agents_note = /** @type {(inputs: Local_Me_Check_Hub_Agents_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に再接続するまで、Personal データを受け取りません。`)
};

export const local_me_check_hub_agents_title = /** @type {(inputs: Local_Me_Check_Hub_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Vault の Agent`)
};

export const local_me_check_phone_note = /** @type {(inputs: Local_Me_Check_Phone_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データの通知は届かなくなります。Workspace の通知は届きます。`)
};

export const local_me_check_phone_title = /** @type {(inputs: Local_Me_Check_Phone_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマホへの通知`)
};

export const local_me_check_published_note = /** @type {(inputs: Local_Me_Check_Published_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移すときに公開を止めます(Cloud に戻しても公開は戻りません)。`)
};

export const local_me_check_published_title = /** @type {(inputs: Local_Me_Check_Published_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開中の個人の Documents`)
};

export const local_me_check_sandbox_note = /** @type {(inputs: Local_Me_Check_Sandbox_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sandbox の agent は止まります。`)
};

export const local_me_check_sandbox_title = /** @type {(inputs: Local_Me_Check_Sandbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud の sandbox`)
};

export const local_me_check_web_gets = /** @type {(inputs: Local_Me_Check_Web_GetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データも開けるようになります。`)
};

export const local_me_check_web_loses = /** @type {(inputs: Local_Me_Check_Web_LosesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは開けなくなります。Workspace はそのまま使えます。`)
};

export const local_me_check_web_title = /** @type {(inputs: Local_Me_Check_Web_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`web・スマホのアプリ(PWA)`)
};

export const local_me_elsewhere_body = /** @type {(inputs: Local_Me_Elsewhere_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは Cloud に移しました。この Vault には控えだけがあります。web か、Cloud に繋いだ desktop で開いてください。`)
};

export const local_me_elsewhere_title = /** @type {(inputs: Local_Me_Elsewhere_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは Cloud にあります`)
};

export const local_me_estimate = /** @type {(inputs: Local_Me_EstimateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`かかる時間の目安: ${i?.length}`)
};

export const local_me_estimate_long = /** @type {(inputs: Local_Me_Estimate_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 分以上`)
};

export const local_me_estimate_minute = /** @type {(inputs: Local_Me_Estimate_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 分ほど`)
};

export const local_me_estimate_minutes = /** @type {(inputs: Local_Me_Estimate_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数分`)
};

export const local_me_estimate_seconds = /** @type {(inputs: Local_Me_Estimate_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数秒`)
};

export const local_me_failed = /** @type {(inputs: Local_Me_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`止まりました: ${i?.message}`)
};

export const local_me_failed_changed = /** @type {(inputs: Local_Me_Failed_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移している間に Personal データが変わったため止まりました(Agent の実行が終わったときなど)。「続ける」で、変わった分だけ送り直します。`)
};

export const local_me_failed_limit = /** @type {(inputs: Local_Me_Failed_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切り替えの回数の上限に達したため止まりました。時間をおいて「続ける」を押してください。`)
};

export const local_me_failed_unreachable = /** @type {(inputs: Local_Me_Failed_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud かファイルの保存先に届かなかったため止まりました。つながったら「続ける」を押してください。`)
};

export const local_me_finished = /** @type {(inputs: Local_Me_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time}で ${i?.place} に移しました。`)
};

export const local_me_finished_merge = /** @type {(inputs: Local_Me_Finished_MergeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.time}で、${i?.what}を ${i?.place} に足しました。`)
};

export const local_me_finished_place_cloud = /** @type {(inputs: Local_Me_Finished_Place_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud`)
};

export const local_me_finished_place_hub = /** @type {(inputs: Local_Me_Finished_Place_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Vault`)
};

export const local_me_finished_what = /** @type {(inputs: Local_Me_Finished_WhatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.count} 件`)
};

export const local_me_finished_what_more = /** @type {(inputs: Local_Me_Finished_What_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.count} 件など`)
};

export const local_me_item_created = /** @type {(inputs: Local_Me_Item_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} に作成`)
};

export const local_me_merge = /** @type {(inputs: Local_Me_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`足すもの`)
};

export const local_me_merge_body = /** @type {(inputs: Local_Me_Merge_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud とこの Vault の Personal データを足して 1 つにします。足した後は選んだ側が元になり、もう一方には同じものを控えとして 30 日残します。まとめている間は読むだけになります。`)
};

export const local_me_merge_from_cloud = /** @type {(inputs: Local_Me_Merge_From_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud にだけあるもの`)
};

export const local_me_merge_from_hub = /** @type {(inputs: Local_Me_Merge_From_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Vault にだけあるもの`)
};

export const local_me_merge_kept = /** @type {(inputs: Local_Me_Merge_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どちらにもあるものはそのまま 1 つです。`)
};

export const local_me_merge_labels = /** @type {(inputs: Local_Me_Merge_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じ名前のラベルは 1 つにします`)
};

export const local_me_merge_none = /** @type {(inputs: Local_Me_Merge_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ありません`)
};

export const local_me_merge_persons = /** @type {(inputs: Local_Me_Merge_PersonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じ人は 1 人にまとめます`)
};

export const local_me_merge_persons_note = /** @type {(inputs: Local_Me_Merge_Persons_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slack・メールなどの ID か trameria のユーザーが同じ人`)
};

export const local_me_merge_to_cloud = /** @type {(inputs: Local_Me_Merge_To_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まとめて Cloud に置く`)
};

export const local_me_merge_to_cloud_title = /** @type {(inputs: Local_Me_Merge_To_Cloud_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを 1 つにまとめて、Cloud に置きますか`)
};

export const local_me_merge_to_hub = /** @type {(inputs: Local_Me_Merge_To_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まとめて Vault に置く`)
};

export const local_me_merge_to_hub_title = /** @type {(inputs: Local_Me_Merge_To_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを 1 つにまとめて、この Vault に置きますか`)
};

export const local_me_move_body = /** @type {(inputs: Local_Me_Move_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移している間は読むだけになります。移した後も、元の側に控えを 30 日残します(戻すときは違うところだけを送ります)。`)
};

export const local_me_moves = /** @type {(inputs: Local_Me_MovesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移すもの`)
};

export const local_me_moving_digest = /** @type {(inputs: Local_Me_Moving_DigestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移しています(違いを調べています)…`)
};

export const local_me_moving_digest_of = /** @type {(inputs: Local_Me_Moving_Digest_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personal データを移しています(違いを調べています ${i?.done}/${i?.total})…`)
};

export const local_me_moving_files = /** @type {(inputs: Local_Me_Moving_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移しています(ファイルを送っています)…`)
};

export const local_me_moving_merge = /** @type {(inputs: Local_Me_Moving_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データをまとめています(足しています)…`)
};

export const local_me_moving_note = /** @type {(inputs: Local_Me_Moving_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移しています。終わるまで変更できません。`)
};

export const local_me_moving_send = /** @type {(inputs: Local_Me_Moving_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移しています(送っています)…`)
};

export const local_me_moving_verify = /** @type {(inputs: Local_Me_Moving_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移しています(確かめています)…`)
};

export const local_me_place = /** @type {(inputs: Local_Me_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データの保存先`)
};

export const local_me_place_both_now = /** @type {(inputs: Local_Me_Place_Both_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud とこの Vault の両方に Personal データがあります。`)
};

export const local_me_place_cloud = /** @type {(inputs: Local_Me_Place_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは Cloud にあります。`)
};

export const local_me_place_cloud_copy = /** @type {(inputs: Local_Me_Place_Cloud_CopyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personal データは Cloud にあります。この Vault には ${i?.date} まで控えを残します(読み書きはできません)。`)
};

export const local_me_place_cloud_only = /** @type {(inputs: Local_Me_Place_Cloud_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは Cloud にあります。この Vault に移すと、web とスマホのアプリからは Workspace だけを使います。`)
};

export const local_me_place_hub = /** @type {(inputs: Local_Me_Place_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データはこの Vault にあります。Workspace は Cloud にあります。`)
};

export const local_me_place_other_hub = /** @type {(inputs: Local_Me_Place_Other_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは別の Vault にあります。`)
};

export const local_me_place_unreachable = /** @type {(inputs: Local_Me_Place_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に届きません。`)
};

export const local_me_place_update = /** @type {(inputs: Local_Me_Place_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud とこの Vault のバージョンが違います。Vault を更新してから移してください。`)
};

export const local_me_queue_cancel = /** @type {(inputs: Local_Me_Queue_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待つのをやめる`)
};

export const local_me_queued = /** @type {(inputs: Local_Me_QueuedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`順番待ち(前に ${i?.ahead} 人・始まるまで約 ${i?.minutes} 分)。順番が来たら自動で始まります。`)
};

export const local_me_queued_note = /** @type {(inputs: Local_Me_Queued_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待っている間も Personal データはそのまま使えます。`)
};

export const local_me_queued_soon = /** @type {(inputs: Local_Me_Queued_SoonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`順番待ち(前に ${i?.ahead} 人・まもなく始まります)。順番が来たら自動で始まります。`)
};

export const local_me_retry = /** @type {(inputs: Local_Me_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続ける`)
};

export const local_me_side_cloud = /** @type {(inputs: Local_Me_Side_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud`)
};

export const local_me_side_hub = /** @type {(inputs: Local_Me_Side_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

export const local_me_stopped = /** @type {(inputs: Local_Me_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移す途中で止まっています。「続ける」で続きから、「取り消す」で元に戻せます。`)
};

export const local_me_time_minutes = /** @type {(inputs: Local_Me_Time_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} 分 ${i?.seconds} 秒`)
};

export const local_me_time_seconds = /** @type {(inputs: Local_Me_Time_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} 秒`)
};

export const local_me_to_cloud = /** @type {(inputs: Local_Me_To_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に移す`)
};

export const local_me_to_cloud_title = /** @type {(inputs: Local_Me_To_Cloud_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを Cloud に移しますか`)
};

export const local_me_to_hub = /** @type {(inputs: Local_Me_To_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に移す`)
};

export const local_me_to_hub_title = /** @type {(inputs: Local_Me_To_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データをこの Vault に移しますか`)
};

export const local_me_untitled = /** @type {(inputs: Local_Me_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(題名なし)`)
};

export const local_menubar = /** @type {(inputs: Local_MenubarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニューバー`)
};

export const local_menubar_agent = /** @type {(inputs: Local_Menubar_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agent: ${i?.name}`)
};

export const local_menubar_agent_cloud_off = /** @type {(inputs: Local_Menubar_Agent_Cloud_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に接続できません`)
};

export const local_menubar_agent_cloud_on = /** @type {(inputs: Local_Menubar_Agent_Cloud_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud から仕事を受けています`)
};

export const local_menubar_agent_hub_on = /** @type {(inputs: Local_Menubar_Agent_Hub_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault(${i?.main})から仕事を受けています`)
};

export const local_menubar_agent_unused = /** @type {(inputs: Local_Menubar_Agent_UnusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「この PC の Agent を使う」がオフです`)
};

export const local_menubar_cloud_signed_in = /** @type {(inputs: Local_Menubar_Cloud_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud にサインイン中`)
};

export const local_menubar_description = /** @type {(inputs: Local_Menubar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mac のメニューバーのアイコン。この Mac に保存されます。`)
};

export const local_menubar_hub_devices = /** @type {(inputs: Local_Menubar_Hub_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault として待ち受け中 · デバイス ${i?.count} 台が接続中`)
};

export const local_menubar_hub_listening = /** @type {(inputs: Local_Menubar_Hub_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault として待ち受け中(接続しているデバイスはありません)`)
};

export const local_menubar_hub_off = /** @type {(inputs: Local_Menubar_Hub_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault(${i?.main})に接続できません`)
};

export const local_menubar_hub_on = /** @type {(inputs: Local_Menubar_Hub_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault(${i?.main})に接続中`)
};

export const local_menubar_hub_on_cloud = /** @type {(inputs: Local_Menubar_Hub_On_CloudInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault(${i?.main})に Cloud 経由で接続中`)
};

export const local_menubar_hub_on_where = /** @type {(inputs: Local_Menubar_Hub_On_WhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault(${i?.main})に接続中 · ${i?.where}`)
};

export const local_menubar_hub_port_in_use = /** @type {(inputs: Local_Menubar_Hub_Port_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault のポートがほかのプログラムに使われていて、デバイスを受け付けられません`)
};

export const local_menubar_icon = /** @type {(inputs: Local_Menubar_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニューバーのアイコン`)
};

export const local_menubar_icon_logo = /** @type {(inputs: Local_Menubar_Icon_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria のロゴ`)
};

export const local_menubar_icon_note = /** @type {(inputs: Local_Menubar_Icon_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用上限にすると、Claude Code か Codex の 5 時間と 1 週間の利用上限の使った割合を横棒で表示します。`)
};

export const local_menubar_icon_usage = /** @type {(inputs: Local_Menubar_Icon_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用上限`)
};

export const local_menubar_provider = /** @type {(inputs: Local_Menubar_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用上限を表示する CLI`)
};

export const local_menubar_provider_note = /** @type {(inputs: Local_Menubar_Provider_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイコンの横棒に、どちらの利用上限を出すか。`)
};

export const local_menubar_provider_note_unused = /** @type {(inputs: Local_Menubar_Provider_Note_UnusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイコンの横棒に、どちらの利用上限を出すか。この PC で使っていない CLI は選べません。`)
};

export const local_menubar_show = /** @type {(inputs: Local_Menubar_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニューバーにアイコンを表示する`)
};

export const local_menubar_show_note = /** @type {(inputs: Local_Menubar_Show_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切ると、アイコンは Dock に出ます。窓を閉じてもアプリは動き続け(Agent も止まりません)、Dock のアイコンを押すと窓が開きます。終わるときは ⌘Q で終了します。`)
};

export const local_notice_cloud_login = /** @type {(inputs: Local_Notice_Cloud_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud にサインインしました`)
};

export const local_notice_cloud_login_body = /** @type {(inputs: Local_Notice_Cloud_Login_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} でこの PC をデバイスリストに追加したので、${i?.name} で自動的にサインインしました。不要な場合は、設定でサインアウトできます。`)
};

export const local_notice_failed = /** @type {(inputs: Local_Notice_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chat} がエラーで止まりました`)
};

export const local_notice_failed_body = /** @type {(inputs: Local_Notice_Failed_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返事を書けませんでした。`)
};

export const local_notice_reply = /** @type {(inputs: Local_Notice_ReplyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chat} が返事を書き終えました`)
};

export const local_notice_turn = /** @type {(inputs: Local_Notice_TurnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chat} があなたの答えを待っています`)
};

export const local_open_in_new_window = /** @type {(inputs: Local_Open_In_New_WindowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいウインドウで開く`)
};

export const local_rail = /** @type {(inputs: Local_RailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

export const local_rail_new = /** @type {(inputs: Local_Rail_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace を作る`)
};

export const local_release = /** @type {(inputs: Local_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace に移す`)
};

export const local_release_action = /** @type {(inputs: Local_Release_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移す`)
};

export const local_release_body = /** @type {(inputs: Local_Release_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移すと、文書は Cloud の Workspace のものになります。選んだ Space が見える人が読めて、Workspace で文書を書ける人が書けるようになります。この Vault の個人の Documents からは外れ、元には戻せません(残したいならコピーを作ってから)。`)
};

export const local_release_failed = /** @type {(inputs: Local_Release_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を移せませんでした`)
};

export const local_release_no_space = /** @type {(inputs: Local_Release_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace には、文書を書ける Space がありません。`)
};

export const local_release_none = /** @type {(inputs: Local_Release_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移せる Workspace がありません。`)
};

export const local_release_space = /** @type {(inputs: Local_Release_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const local_release_title = /** @type {(inputs: Local_Release_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を Workspace に移す`)
};

export const local_release_unavailable = /** @type {(inputs: Local_Release_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データがこの Vault にあり、Cloud に届くときだけ移せます。`)
};

export const local_release_workspace = /** @type {(inputs: Local_Release_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

export const local_released = /** @type {(inputs: Local_ReleasedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を ${i?.workspace} に移しました`)
};

export const local_remote = /** @type {(inputs: Local_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

export const local_remote_add = /** @type {(inputs: Local_Remote_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスを接続`)
};

export const local_remote_add_note = /** @type {(inputs: Local_Remote_Add_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続するデバイスの trameria で、この QR を読むか、コードを入れます。10 分間、1 回だけ使えます。`)
};

export const local_remote_cloud = /** @type {(inputs: Local_Remote_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud 経由の接続も受け付ける`)
};

export const local_remote_cloud_connecting = /** @type {(inputs: Local_Remote_Cloud_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に接続しています…`)
};

export const local_remote_cloud_needs_tie = /** @type {(inputs: Local_Remote_Cloud_Needs_TieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud と連携すると使えます。`)
};

export const local_remote_cloud_note = /** @type {(inputs: Local_Remote_Cloud_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワーク外のデバイスが、Cloud 経由でこの Vault に接続できます。通信は暗号化されたままで、Cloud からは読めません。`)
};

export const local_remote_cloud_open = /** @type {(inputs: Local_Remote_Cloud_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud 経由の接続を受け付けています。`)
};

export const local_remote_cloud_refused = /** @type {(inputs: Local_Remote_Cloud_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に接続できませんでした。「Cloud」の項目でサインインし直してください。`)
};

export const local_remote_code = /** @type {(inputs: Local_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コード`)
};

export const local_remote_connected = /** @type {(inputs: Local_Remote_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続中`)
};

export const local_remote_connected_from = /** @type {(inputs: Local_Remote_Connected_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`接続中 · ${i?.where}`)
};

export const local_remote_description = /** @type {(inputs: Local_Remote_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスの trameria をこの PC に接続し、同じデータと Agent を利用できるようにします。接続できるのは、ペアリングしたデバイスだけです。`)
};

export const local_remote_devices = /** @type {(inputs: Local_Remote_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続したデバイス`)
};

export const local_remote_devices_none = /** @type {(inputs: Local_Remote_Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだありません。`)
};

export const local_remote_failed = /** @type {(inputs: Local_Remote_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした。`)
};

export const local_remote_linked = /** @type {(inputs: Local_Remote_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続しているため、この PC は Vault になれません。`)
};

export const local_remote_listen = /** @type {(inputs: Local_Remote_ListenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスからの接続を受け付ける`)
};

export const local_remote_listen_note = /** @type {(inputs: Local_Remote_Listen_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンにすると、この PC がほかのデバイスの接続先(Vault)になります。オンの間だけ、この PC のポートを 1 つ開きます。`)
};

export const local_remote_port_in_use = /** @type {(inputs: Local_Remote_Port_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ポート ${i?.port} がほかのアプリに使われていて開けません。`)
};

export const local_remote_remove = /** @type {(inputs: Local_Remote_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外す`)
};

export const local_remote_remove_body = /** @type {(inputs: Local_Remote_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC には接続できなくなります。もう一度使うには、ペアリングし直してください。`)
};

export const local_remote_remove_title = /** @type {(inputs: Local_Remote_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を外しますか`)
};

export const local_remote_retry = /** @type {(inputs: Local_Remote_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一度`)
};

export const local_route_anywhere = /** @type {(inputs: Local_Route_AnywhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どこからでも`)
};

export const local_route_client_cloud_home = /** @type {(inputs: Local_Route_Client_Cloud_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データが Cloud にあるため、この PC は Cloud に直接接続します。この設定は、Personal データが Vault にあるときに使われます。`)
};

export const local_route_client_diagram = /** @type {(inputs: Local_Route_Client_DiagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC から Vault への接続`)
};

export const local_route_client_needs = /** @type {(inputs: Local_Route_Client_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC と Vault が同じアカウントで Cloud にサインインし、Vault が Cloud 経由の接続を受け付けているときに使えます。`)
};

export const local_route_client_title = /** @type {(inputs: Local_Route_Client_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワーク外から Vault に接続する`)
};

export const local_route_devices = /** @type {(inputs: Local_Route_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC・スマートフォン`)
};

export const local_route_direct = /** @type {(inputs: Local_Route_DirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直接`)
};

export const local_route_direct_first = /** @type {(inputs: Local_Route_Direct_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続できるときは直接利用します。Cloud を経由するのはネットワーク外にいるときだけです。`)
};

export const local_route_help = /** @type {(inputs: Local_Route_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`図で見る`)
};

export const local_route_help_close = /** @type {(inputs: Local_Route_Help_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const local_route_hub = /** @type {(inputs: Local_Route_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

export const local_route_hub_cloud_home = /** @type {(inputs: Local_Route_Hub_Cloud_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud 経由の接続は、Personal データがこの Vault にあるときだけ使われます。いまは Personal データが Cloud にあるため、ほかのデバイスは Cloud に直接接続します。`)
};

export const local_route_hub_copy = /** @type {(inputs: Local_Route_Hub_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データの控え`)
};

export const local_route_hub_diagram = /** @type {(inputs: Local_Route_Hub_DiagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Vault に Cloud 経由で接続する`)
};

export const local_route_hub_first_direct = /** @type {(inputs: Local_Route_Hub_First_DirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初めてのデバイスは、同じネットワークか Tailscale で接続してください。`)
};

export const local_route_hub_paired_only = /** @type {(inputs: Local_Route_Hub_Paired_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud 経由で接続できるのは、この Vault と一度直接接続した(ペアリングした)デバイスだけです。`)
};

export const local_route_hub_title = /** @type {(inputs: Local_Route_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud 経由の接続`)
};

export const local_route_network = /** @type {(inputs: Local_Route_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じネットワーク`)
};

export const local_route_network_note = /** @type {(inputs: Local_Route_Network_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じ Wi-Fi か Tailscale`)
};

export const local_route_off = /** @type {(inputs: Local_Route_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフ`)
};

export const local_route_outside = /** @type {(inputs: Local_Route_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワーク外`)
};

export const local_route_personal_data = /** @type {(inputs: Local_Route_Personal_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データ`)
};

export const local_route_relay = /** @type {(inputs: Local_Route_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中継`)
};

export const local_route_relay_note = /** @type {(inputs: Local_Route_Relay_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中身は読めません`)
};

export const local_route_sealed = /** @type {(inputs: Local_Route_SealedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暗号化`)
};

export const local_route_this_agent = /** @type {(inputs: Local_Route_This_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の Agent`)
};

export const local_route_this_hub = /** @type {(inputs: Local_Route_This_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Vault`)
};

export const local_route_this_hub_note = /** @type {(inputs: Local_Route_This_Hub_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データ・会話`)
};

export const local_route_this_pc = /** @type {(inputs: Local_Route_This_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC`)
};

export const local_setting_change_failed = /** @type {(inputs: Local_Setting_Change_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更できませんでした。もう一度お試しください。`)
};

export const local_trust = /** @type {(inputs: Local_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリスト`)
};

export const local_trust_accept = /** @type {(inputs: Local_Trust_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストを信用する`)
};

export const local_trust_accept_body = /** @type {(inputs: Local_Trust_Accept_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の画面に表示されているデバイス ID が ${i?.fingerprint} と同じか確認してください。信用すると、このデバイスリストにあるデバイスがこの PC の Agent に指示を出せるようになります。`)
};

export const local_trust_accept_button = /** @type {(inputs: Local_Trust_Accept_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信用する`)
};

export const local_trust_accept_first = /** @type {(inputs: Local_Trust_Accept_FirstInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最初のデバイス: ${i?.name}`)
};

export const local_trust_accept_note = /** @type {(inputs: Local_Trust_Accept_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスで作成したデバイスリストです。最初のデバイスの画面に表示されているデバイス ID と同じものだけを信用してください。`)
};

export const local_trust_accept_title = /** @type {(inputs: Local_Trust_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスリストを信用しますか`)
};

export const local_trust_add = /** @type {(inputs: Local_Trust_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスを追加`)
};

export const local_trust_add_another = /** @type {(inputs: Local_Trust_Add_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスを追加`)
};

export const local_trust_add_button = /** @type {(inputs: Local_Trust_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

export const local_trust_add_note = /** @type {(inputs: Local_Trust_Add_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加するデバイスの「このデバイスを追加」に表示されているコードを入力します。`)
};

export const local_trust_agent_problem = /** @type {(inputs: Local_Trust_Agent_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストが、この PC に保存されているものと一致しないため、この PC の Agent は指示の実行を停止しています。`)
};

export const local_trust_agent_settings = /** @type {(inputs: Local_Trust_Agent_SettingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の Agent の設定`)
};

export const local_trust_already_member = /** @type {(inputs: Local_Trust_Already_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`そのデバイスはもうデバイスリストにあります。`)
};

export const local_trust_approve_adding = /** @type {(inputs: Local_Trust_Approve_AddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加しています…`)
};

export const local_trust_approve_button = /** @type {(inputs: Local_Trust_Approve_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認`)
};

export const local_trust_approve_compare = /** @type {(inputs: Local_Trust_Approve_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手の画面に出ているデバイス ID と同じなら追加してください。`)
};

export const local_trust_approve_done = /** @type {(inputs: Local_Trust_Approve_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} をデバイスリストに追加しました。`)
};

export const local_trust_approve_finding = /** @type {(inputs: Local_Trust_Approve_FindingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードを表示しているデバイスを探しています…`)
};

export const local_trust_candidates = /** @type {(inputs: Local_Trust_CandidatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加を待っているデバイス`)
};

export const local_trust_candidates_note = /** @type {(inputs: Local_Trust_Candidates_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Vault とペアリングしたデバイスです。デバイス ID が相手の画面と同じなら追加してください。`)
};

export const local_trust_cli_accepted = /** @type {(inputs: Local_Trust_Cli_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストを信用しました。`)
};

export const local_trust_cli_agent_problem = /** @type {(inputs: Local_Trust_Cli_Agent_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストが、この PC に保存されているものと一致しないため、この PC の Agent は指示の実行を停止しています。`)
};

export const local_trust_cli_approve_done = /** @type {(inputs: Local_Trust_Cli_Approve_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} をデバイスリストに追加しました。`)
};

export const local_trust_cli_approve_finding = /** @type {(inputs: Local_Trust_Cli_Approve_FindingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードを表示しているデバイスを探しています…`)
};

export const local_trust_cli_approve_peer = /** @type {(inputs: Local_Trust_Cli_Approve_PeerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}(${i?.kind}、デバイス ID: ${i?.fingerprint})をデバイスリストに追加します。相手の画面のデバイス ID と同じなら、パスフレーズを入力してください(空のままなら拒否します)。`)
};

export const local_trust_cli_available = /** @type {(inputs: Local_Trust_Cli_AvailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`デバイスリスト ${i?.list}(最初のデバイス: ${i?.name}、デバイス ID: ${i?.fingerprint})`)
};

export const local_trust_cli_compare = /** @type {(inputs: Local_Trust_Cli_CompareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最初のデバイスの画面に表示されているデバイス ID が ${i?.fingerprint} と同じか確認してください。同じなら、パスフレーズを入力するとこのデバイスリストを信用します。`)
};

export const local_trust_cli_created = /** @type {(inputs: Local_Trust_Cli_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストを作成しました。最初のデバイスはこの PC です。`)
};

export const local_trust_cli_failed = /** @type {(inputs: Local_Trust_Cli_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`できませんでした(${i?.error})。`)
};

export const local_trust_cli_fingerprint = /** @type {(inputs: Local_Trust_Cli_FingerprintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この PC のデバイス ID: ${i?.fingerprint}`)
};

export const local_trust_cli_invite = /** @type {(inputs: Local_Trust_Cli_InviteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`承認のコード(1 回だけ使えます。あと ${i?.minutes} 分有効): ${i?.code}
デバイスリストにあるデバイスの「デバイスを追加」でこのコードを入力するか、QR コードを読み取ってください。`)
};

export const local_trust_cli_invite_approved = /** @type {(inputs: Local_Trust_Cli_Invite_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストに追加されました。`)
};

export const local_trust_cli_invite_declined = /** @type {(inputs: Local_Trust_Cli_Invite_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加が拒否されました。`)
};

export const local_trust_cli_invite_expired = /** @type {(inputs: Local_Trust_Cli_Invite_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードの期限が切れました。`)
};

export const local_trust_cli_invite_proved = /** @type {(inputs: Local_Trust_Cli_Invite_ProvedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} でコードを確認しました。追加されるのを待っています…`)
};

export const local_trust_cli_invite_refused = /** @type {(inputs: Local_Trust_Cli_Invite_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードを確認できなかったため、このコードは無効になりました。`)
};

export const local_trust_cli_keys_made = /** @type {(inputs: Local_Trust_Cli_Keys_MadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC のキーを作成しました。`)
};

export const local_trust_cli_list = /** @type {(inputs: Local_Trust_Cli_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`デバイスリスト(バージョン ${i?.n}):`)
};

export const local_trust_cli_made = /** @type {(inputs: Local_Trust_Cli_MadeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`    ${i?.date} に作成`)
};

export const local_trust_cli_no_list = /** @type {(inputs: Local_Trust_Cli_No_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだデバイスリストを信用していません。`)
};

export const local_trust_cli_no_lists = /** @type {(inputs: Local_Trust_Cli_No_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存先にデバイスリストがありません。`)
};

export const local_trust_cli_not_found = /** @type {(inputs: Local_Trust_Cli_Not_FoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`見つかりません: ${i?.what}`)
};

export const local_trust_cli_not_running = /** @type {(inputs: Local_Trust_Cli_Not_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dir} で ${i?.app} が動いていません。先に起動してから(${i?.app} --headless か、サービスで)、もう一度打ってください。`)
};

export const local_trust_cli_others = /** @type {(inputs: Local_Trust_Cli_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`保存先に、ほかのデバイスで作成したデバイスリストがあります。${i?.app} --headless --trust lists で確認できます。`)
};

export const local_trust_cli_pair_note = /** @type {(inputs: Local_Trust_Cli_Pair_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このコードでペアリングしたデバイスは、デバイスリストにも追加されます。`)
};

export const local_trust_cli_passphrase = /** @type {(inputs: Local_Trust_Cli_PassphraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスフレーズ: `)
};

export const local_trust_cli_passphrase_again = /** @type {(inputs: Local_Trust_Cli_Passphrase_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一度: `)
};

export const local_trust_cli_passphrase_mismatch = /** @type {(inputs: Local_Trust_Cli_Passphrase_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 回の入力が違います。`)
};

export const local_trust_cli_passphrase_new = /** @type {(inputs: Local_Trust_Cli_Passphrase_NewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`パスフレーズを設定してください。この PC でデバイスを追加・削除するときに入力します。忘れると、この PC からはデバイスリストを変更できなくなります(${i?.min} 文字以上): `)
};

export const local_trust_cli_problem = /** @type {(inputs: Local_Trust_Cli_ProblemInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`保存先(${i?.place})のデバイスリストが、この PC のデバイスリストと一致しません。`)
};

export const local_trust_cli_remove_done = /** @type {(inputs: Local_Trust_Cli_Remove_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} をデバイスリストから削除しました。`)
};

export const local_trust_cli_switch = /** @type {(inputs: Local_Trust_Cli_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今のデバイスリストから、このデバイスリストに切り替えます。今のデバイスリストにあるデバイスからは、この PC の Agent に指示を出せなくなり、今のデバイスリストには戻せません。`)
};

export const local_trust_cli_switched = /** @type {(inputs: Local_Trust_Cli_SwitchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストを切り替えました。`)
};

export const local_trust_cli_usage = /** @type {(inputs: Local_Trust_Cli_UsageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`使い方: ${i?.app} --headless --trust [status | init | create | lists | accept <デバイスリスト> | invite [vault|cloud] | approve <コード> | remove <デバイス> | pair]`)
};

export const local_trust_cli_waiting = /** @type {(inputs: Local_Trust_Cli_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待っています…`)
};

export const local_trust_cli_wrong_passphrase = /** @type {(inputs: Local_Trust_Cli_Wrong_PassphraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスフレーズが違います。`)
};

export const local_trust_cloud = /** @type {(inputs: Local_Trust_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria cloud`)
};

export const local_trust_cloud_add = /** @type {(inputs: Local_Trust_Cloud_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

export const local_trust_cloud_add_when_ready = /** @type {(inputs: Local_Trust_Cloud_Add_When_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備ができたら、追加できます。`)
};

export const local_trust_cloud_adding = /** @type {(inputs: Local_Trust_Cloud_AddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備ができたら、デバイスリストに追加します。`)
};

export const local_trust_cloud_create = /** @type {(inputs: Local_Trust_Cloud_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

export const local_trust_cloud_create_limit = /** @type {(inputs: Local_Trust_Cloud_Create_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成できるのは 1 日 3 回までです。`)
};

export const local_trust_cloud_delete = /** @type {(inputs: Local_Trust_Cloud_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const local_trust_cloud_delete_body = /** @type {(inputs: Local_Trust_Cloud_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストから削除し、Cloud の中のファイルもすべて削除します。`)
};

export const local_trust_cloud_delete_title = /** @type {(inputs: Local_Trust_Cloud_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を削除しますか`)
};

export const local_trust_cloud_failed = /** @type {(inputs: Local_Trust_Cloud_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud で操作できませんでした。`)
};

export const local_trust_cloud_name_dev = /** @type {(inputs: Local_Trust_Cloud_Name_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria cloud (dev)`)
};

export const local_trust_cloud_name_general = /** @type {(inputs: Local_Trust_Cloud_Name_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria cloud`)
};

export const local_trust_cloud_none = /** @type {(inputs: Local_Trust_Cloud_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ作成していません`)
};

export const local_trust_cloud_note = /** @type {(inputs: Local_Trust_Cloud_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud で Agent を動かすデバイスです。デバイスリストのデバイスから指示を受けます。`)
};

export const local_trust_cloud_other_list = /** @type {(inputs: Local_Trust_Cloud_Other_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のデバイスリストのデバイスです。作り直すと、このデバイスリストに追加できます。`)
};

export const local_trust_cloud_phase_asleep = /** @type {(inputs: Local_Trust_Cloud_Phase_AsleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`休止中`)
};

export const local_trust_cloud_phase_deleting = /** @type {(inputs: Local_Trust_Cloud_Phase_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除しています`)
};

export const local_trust_cloud_phase_error = /** @type {(inputs: Local_Trust_Cloud_Phase_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

export const local_trust_cloud_phase_preparing = /** @type {(inputs: Local_Trust_Cloud_Phase_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`準備しています`)
};

export const local_trust_cloud_phase_queued = /** @type {(inputs: Local_Trust_Cloud_Phase_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順番待ち`)
};

export const local_trust_cloud_phase_queued_at = /** @type {(inputs: Local_Trust_Cloud_Phase_Queued_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`順番待ち · ${i?.n} 番目`)
};

export const local_trust_cloud_phase_remaking = /** @type {(inputs: Local_Trust_Cloud_Phase_RemakingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作り直しています`)
};

export const local_trust_cloud_phase_running = /** @type {(inputs: Local_Trust_Cloud_Phase_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実行中`)
};

export const local_trust_cloud_phase_starting = /** @type {(inputs: Local_Trust_Cloud_Phase_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起動しています`)
};

export const local_trust_cloud_remake = /** @type {(inputs: Local_Trust_Cloud_RemakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作り直す`)
};

export const local_trust_cloud_remake_body = /** @type {(inputs: Local_Trust_Cloud_Remake_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を削除してから新しく作成し、このデバイスリストに追加します。中のファイルはすべて削除されます。`)
};

export const local_trust_cloud_remake_title = /** @type {(inputs: Local_Trust_Cloud_Remake_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を作り直しますか`)
};

export const local_trust_cloud_unlisted = /** @type {(inputs: Local_Trust_Cloud_UnlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストに追加するまで、指示を受けません。`)
};

export const local_trust_cloud_update_clis = /** @type {(inputs: Local_Trust_Cloud_Update_ClisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI を更新`)
};

export const local_trust_cloud_updating = /** @type {(inputs: Local_Trust_Cloud_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI を更新しています`)
};

export const local_trust_cloud_wake = /** @type {(inputs: Local_Trust_Cloud_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起動`)
};

export const local_trust_cloud_wake_to_add = /** @type {(inputs: Local_Trust_Cloud_Wake_To_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起動すると、デバイスリストに追加できます。`)
};

export const local_trust_code = /** @type {(inputs: Local_Trust_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コード`)
};

export const local_trust_code_expired = /** @type {(inputs: Local_Trust_Code_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードの期限が切れました。`)
};

export const local_trust_create = /** @type {(inputs: Local_Trust_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストを作成`)
};

export const local_trust_create_again_body = /** @type {(inputs: Local_Trust_Create_Again_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} で作成したデバイスリストがすでにあります。新しく作成すると、そのデバイスリストのデバイスからは、この PC の Agent に指示を出せません。${i?.name} などのデバイスをすべてなくしたときだけ作成してください。`)
};

export const local_trust_create_again_note = /** @type {(inputs: Local_Trust_Create_Again_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見つかったデバイスリストのデバイスをすべてなくしたときだけ使います。そのデバイスが 1 台でも手元にあるときは、上の「このデバイスを追加」か「デバイスリストを信用する」を使ってください。`)
};

export const local_trust_create_again_title = /** @type {(inputs: Local_Trust_Create_Again_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいデバイスリストを作成しますか`)
};

export const local_trust_create_button = /** @type {(inputs: Local_Trust_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

export const local_trust_create_note = /** @type {(inputs: Local_Trust_Create_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスを最初のデバイスにして、新しいデバイスリストを作成します。`)
};

export const local_trust_decline = /** @type {(inputs: Local_Trust_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拒否`)
};

export const local_trust_description = /** @type {(inputs: Local_Trust_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent に指示を出せるデバイスです。デバイスを選ぶと、そのデバイスの Agent の設定を変更できます。`)
};

export const local_trust_device_not_found = /** @type {(inputs: Local_Trust_Device_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスはデバイスリストにありません。削除された可能性があります。`)
};

export const local_trust_failed = /** @type {(inputs: Local_Trust_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`できませんでした。`)
};

export const local_trust_guide = /** @type {(inputs: Local_Trust_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスを追加するには`)
};

export const local_trust_guide_add = /** @type {(inputs: Local_Trust_Guide_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスを追加する`)
};

export const local_trust_guide_add_this = /** @type {(inputs: Local_Trust_Guide_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスを追加する`)
};

export const local_trust_guide_agent = /** @type {(inputs: Local_Trust_Guide_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各 PC の Agent`)
};

export const local_trust_guide_agent_note = /** @type {(inputs: Local_Trust_Guide_Agent_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送ったデバイスがデバイスリストにあるかを確かめます`)
};

export const local_trust_guide_by_vault = /** @type {(inputs: Local_Trust_Guide_By_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続して追加することもできます`)
};

export const local_trust_guide_by_vault_linked = /** @type {(inputs: Local_Trust_Guide_By_Vault_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加する PC が Vault に接続すると、Vault の「追加を待っているデバイス」に出ます。デバイス ID を見比べて「追加」を押します。`)
};

export const local_trust_guide_by_vault_self = /** @type {(inputs: Local_Trust_Guide_By_Vault_SelfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`追加する PC が ${i?.name} に接続すると、${i?.name} の「追加を待っているデバイス」に出ます。デバイス ID を見比べて「追加」を押します。`)
};

export const local_trust_guide_code_goes = /** @type {(inputs: Local_Trust_Guide_Code_GoesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コード`)
};

export const local_trust_guide_create_made = /** @type {(inputs: Local_Trust_Guide_Create_MadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC だけが入ったデバイスリストができます。この PC が最初のデバイスです。`)
};

export const local_trust_guide_create_next = /** @type {(inputs: Local_Trust_Guide_Create_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスは、この PC で「デバイスを追加」から追加します。この欄にも追加の手順が出るようになります。`)
};

export const local_trust_guide_create_once = /** @type {(inputs: Local_Trust_Guide_Create_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストは 1 つだけ作成します。ほかのデバイスですでに作成しているときは、ここで作成しないでください。別のデバイスリストになり、そのデバイスからの指示を、この PC の Agent が受けなくなります。`)
};

export const local_trust_guide_create_passphrase = /** @type {(inputs: Local_Trust_Guide_Create_PassphraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC ではキーチェーンが使えないため、パスフレーズを設定します。デバイスリストを変更するたびに入力します。`)
};

export const local_trust_guide_create_press = /** @type {(inputs: Local_Trust_Guide_Create_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下の「デバイスリストを作成」で「作成」を押します。`)
};

export const local_trust_guide_example_pc = /** @type {(inputs: Local_Trust_Guide_Example_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MacBook`)
};

export const local_trust_guide_example_phone = /** @type {(inputs: Local_Trust_Guide_Example_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone`)
};

export const local_trust_guide_flow_check = /** @type {(inputs: Local_Trust_Guide_Flow_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受け取った PC`)
};

export const local_trust_guide_flow_from = /** @type {(inputs: Local_Trust_Guide_Flow_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指示を送ったのは`)
};

export const local_trust_guide_flow_result = /** @type {(inputs: Local_Trust_Guide_Flow_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果`)
};

export const local_trust_guide_found = /** @type {(inputs: Local_Trust_Guide_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスで作成したデバイスリストが見つかりました。そのデバイスで、この PC を追加します。`)
};

export const local_trust_guide_found_trust = /** @type {(inputs: Local_Trust_Guide_Found_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下に「デバイスリストを信用する」も出ますが、上の手順で追加すれば信用も済むので、押さなくてかまいません。`)
};

export const local_trust_guide_here = /** @type {(inputs: Local_Trust_Guide_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の画面`)
};

export const local_trust_guide_here_name = /** @type {(inputs: Local_Trust_Guide_Here_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の名前`)
};

export const local_trust_guide_in_list = /** @type {(inputs: Local_Trust_Guide_In_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにあるデバイス`)
};

export const local_trust_guide_join_first = /** @type {(inputs: Local_Trust_Guide_Join_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先に、デバイスリストにあるデバイスと同じ Cloud アカウントにサインインするか、同じ Vault に接続します。コードを表示できるようになります。`)
};

export const local_trust_guide_kind_headless = /** @type {(inputs: Local_Trust_Guide_Kind_HeadlessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面の無い PC`)
};

export const local_trust_guide_kind_headless_note = /** @type {(inputs: Local_Trust_Guide_Kind_Headless_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーバーなど、コマンドで trameria を動かす PC`)
};

export const local_trust_guide_kind_pc = /** @type {(inputs: Local_Trust_Guide_Kind_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面のある PC`)
};

export const local_trust_guide_kind_pc_note = /** @type {(inputs: Local_Trust_Guide_Kind_Pc_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria のアプリを画面で使う Mac・Windows・Linux`)
};

export const local_trust_guide_kind_phone = /** @type {(inputs: Local_Trust_Guide_Kind_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone`)
};

export const local_trust_guide_kind_phone_note = /** @type {(inputs: Local_Trust_Guide_Kind_Phone_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone の trameria アプリ`)
};

export const local_trust_guide_kind_question = /** @type {(inputs: Local_Trust_Guide_Kind_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加したいデバイスは？`)
};

export const local_trust_guide_member_screen = /** @type {(inputs: Local_Trust_Guide_Member_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにある PC の画面`)
};

export const local_trust_guide_more_add = /** @type {(inputs: Local_Trust_Guide_More_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスを追加する手順を見る`)
};

export const local_trust_guide_more_add_this = /** @type {(inputs: Local_Trust_Guide_More_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスを追加する手順を見る`)
};

export const local_trust_guide_more_start = /** @type {(inputs: Local_Trust_Guide_More_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストを始める手順を見る`)
};

export const local_trust_guide_new_pc = /** @type {(inputs: Local_Trust_Guide_New_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加する PC の画面`)
};

export const local_trust_guide_new_phone = /** @type {(inputs: Local_Trust_Guide_New_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加する iPhone の画面`)
};

export const local_trust_guide_others = /** @type {(inputs: Local_Trust_Guide_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにないデバイス、乗っ取られた Cloud や Vault`)
};

export const local_trust_guide_reach_cloud = /** @type {(inputs: Local_Trust_Guide_Reach_CloudInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} と同じ Cloud アカウントにサインインしているデバイスを追加できます。`)
};

export const local_trust_guide_reach_none = /** @type {(inputs: Local_Trust_Guide_Reach_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続するか、Cloud にサインインすると追加できます。`)
};

export const local_trust_guide_reach_outside = /** @type {(inputs: Local_Trust_Guide_Reach_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにあるデバイスと同じ Vault に接続しているか、同じ Cloud アカウントにサインインしていれば追加できます。`)
};

export const local_trust_guide_reach_self = /** @type {(inputs: Local_Trust_Guide_Reach_SelfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} に接続しているデバイスを追加できます。Cloud にサインインすると、ほかのネットワークのデバイスも追加できます。`)
};

export const local_trust_guide_reach_self_cloud = /** @type {(inputs: Local_Trust_Guide_Reach_Self_CloudInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} に接続しているか、${i?.name} と同じ Cloud アカウントにサインインしているデバイスを追加できます。`)
};

export const local_trust_guide_reach_vault = /** @type {(inputs: Local_Trust_Guide_Reach_VaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} と同じ Vault に接続しているデバイスを追加できます。Cloud にサインインすると、ほかのネットワークのデバイスも追加できます。`)
};

export const local_trust_guide_reach_vault_cloud = /** @type {(inputs: Local_Trust_Guide_Reach_Vault_CloudInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} と同じ Vault に接続しているか、同じ Cloud アカウントにサインインしているデバイスを追加できます。`)
};

export const local_trust_guide_refused = /** @type {(inputs: Local_Trust_Guide_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実行しない`)
};

export const local_trust_guide_runs = /** @type {(inputs: Local_Trust_Guide_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実行する`)
};

export const local_trust_guide_screen_of = /** @type {(inputs: Local_Trust_Guide_Screen_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の画面`)
};

export const local_trust_guide_start = /** @type {(inputs: Local_Trust_Guide_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストを始める`)
};

export const local_trust_guide_start_create = /** @type {(inputs: Local_Trust_Guide_Start_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいデバイスリストを作成`)
};

export const local_trust_guide_start_create_note = /** @type {(inputs: Local_Trust_Guide_Start_Create_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだどこにも無いとき。この PC が最初のデバイスになります`)
};

export const local_trust_guide_start_join = /** @type {(inputs: Local_Trust_Guide_Start_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既存のデバイスリストに追加`)
};

export const local_trust_guide_start_join_note = /** @type {(inputs: Local_Trust_Guide_Start_Join_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスで作成したデバイスリストに、この PC を入れます`)
};

export const local_trust_guide_start_none = /** @type {(inputs: Local_Trust_Guide_Start_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault と Cloud には、ほかのデバイスで作成したデバイスリストが見つかりませんでした。ほかの Vault や Cloud アカウントに保存されていることもあります。`)
};

export const local_trust_guide_start_question = /** @type {(inputs: Local_Trust_Guide_Start_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC をどうしますか？`)
};

export const local_trust_guide_start_unreached = /** @type {(inputs: Local_Trust_Guide_Start_UnreachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC は Cloud にサインインしておらず、Vault にも接続していないため、ほかのデバイスで作成したデバイスリストを探せません。`)
};

export const local_trust_guide_step_add = /** @type {(inputs: Local_Trust_Guide_Step_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じなら「追加」を押します。追加したデバイスも、Agent に指示を出せるようになります。`)
};

export const local_trust_guide_step_compare = /** @type {(inputs: Local_Trust_Guide_Step_CompareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} に出たデバイス ID と、追加する側の画面の「このデバイスの ID」が、同じ文字か見比べます。違うときは「拒否」を押します。`)
};

export const local_trust_guide_step_compare_headless = /** @type {(inputs: Local_Trust_Guide_Step_Compare_HeadlessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} に出たデバイス ID と、ターミナルに出たデバイス ID が、同じ文字か見比べます。違うときは「拒否」を押します。`)
};

export const local_trust_guide_step_compare_member = /** @type {(inputs: Local_Trust_Guide_Step_Compare_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その PC に出たデバイス ID と、この PC の「このデバイスの ID」が、同じ文字か見比べます。違うときは「拒否」を押します。`)
};

export const local_trust_guide_step_enter = /** @type {(inputs: Local_Trust_Guide_Step_EnterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} で、設定 › デバイスリスト の「デバイスを追加」にそのコードを入力し、「確認」を押します。`)
};

export const local_trust_guide_step_enter_member = /** @type {(inputs: Local_Trust_Guide_Step_Enter_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにある PC で、設定 › デバイスリスト の「デバイスを追加」にそのコードを入力し、「確認」を押します。`)
};

export const local_trust_guide_step_show_headless = /** @type {(inputs: Local_Trust_Guide_Step_Show_HeadlessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加する PC のターミナルでコマンドを実行します。コードと、その PC のデバイス ID が出ます。`)
};

export const local_trust_guide_step_show_here = /** @type {(inputs: Local_Trust_Guide_Step_Show_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC で、下の「このデバイスを追加」の「コードを表示」を押します。`)
};

export const local_trust_guide_step_show_pc = /** @type {(inputs: Local_Trust_Guide_Step_Show_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加する PC で、設定 › デバイスリスト の「このデバイスを追加」で「コードを表示」を押します。コードと、その PC のデバイス ID が出ます。`)
};

export const local_trust_guide_step_show_phone = /** @type {(inputs: Local_Trust_Guide_Step_Show_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone で、設定 › デバイスリスト の「このデバイスを追加」で「コードを表示」を押します。コードと、その iPhone のデバイス ID が出ます。`)
};

export const local_trust_guide_term_code = /** @type {(inputs: Local_Trust_Guide_Term_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`承認のコード: ${i?.code}`)
};

export const local_trust_guide_what = /** @type {(inputs: Local_Trust_Guide_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストとは`)
};

export const local_trust_guide_what_body = /** @type {(inputs: Local_Trust_Guide_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent に指示を出せるデバイスの一覧です。各 PC の Agent は、デバイスリストにあるデバイスから送った指示だけを実行します。Cloud や Vault が乗っ取られても、デバイスリストにないところからの指示は実行されません。`)
};

export const local_trust_guide_where = /** @type {(inputs: Local_Trust_Guide_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定 › デバイスリスト`)
};

export const local_trust_invalid_code = /** @type {(inputs: Local_Trust_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードが違います。`)
};

export const local_trust_invite = /** @type {(inputs: Local_Trust_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスを追加`)
};

export const local_trust_invite_approved = /** @type {(inputs: Local_Trust_Invite_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストに追加されました。`)
};

export const local_trust_invite_button = /** @type {(inputs: Local_Trust_Invite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードを表示`)
};

export const local_trust_invite_declined = /** @type {(inputs: Local_Trust_Invite_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加が拒否されました。`)
};

export const local_trust_invite_note = /** @type {(inputs: Local_Trust_Invite_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにあるデバイスで、このデバイスを追加します。`)
};

export const local_trust_invite_proved = /** @type {(inputs: Local_Trust_Invite_ProvedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} でコードを確認しました。追加されるのを待っています。`)
};

export const local_trust_invite_refused = /** @type {(inputs: Local_Trust_Invite_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードを確認できなかったため、このコードは無効になりました。`)
};

export const local_trust_invite_waiting = /** @type {(inputs: Local_Trust_Invite_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにあるデバイスの「デバイスを追加」で、このコードを入力してください。1 回だけ使えます。`)
};

export const local_trust_kind_cloud = /** @type {(inputs: Local_Trust_Kind_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud`)
};

export const local_trust_kind_pc = /** @type {(inputs: Local_Trust_Kind_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC`)
};

export const local_trust_kind_phone = /** @type {(inputs: Local_Trust_Kind_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマートフォン`)
};

export const local_trust_last_approver = /** @type {(inputs: Local_Trust_Last_ApproverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストを変更できる最後のデバイスは削除できません。`)
};

export const local_trust_left = /** @type {(inputs: Local_Trust_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切り替える前のデバイスリストには戻せません。`)
};

export const local_trust_list_made = /** @type {(inputs: Local_Trust_List_MadeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} に作成`)
};

export const local_trust_members = /** @type {(inputs: Local_Trust_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイス`)
};

export const local_trust_members_note = /** @type {(inputs: Local_Trust_Members_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスからデバイスリストを変更できます。`)
};

export const local_trust_members_note_outside = /** @type {(inputs: Local_Trust_Members_Note_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスはデバイスリストにありません。`)
};

export const local_trust_members_note_receiver = /** @type {(inputs: Local_Trust_Members_Note_ReceiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスからはデバイスリストを変更できません。`)
};

export const local_trust_no_keys = /** @type {(inputs: Local_Trust_No_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだキーがありません`)
};

export const local_trust_no_place = /** @type {(inputs: Local_Trust_No_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続するか、Cloud にサインインするとコードを表示できます。`)
};

export const local_trust_no_place_failed = /** @type {(inputs: Local_Trust_No_Place_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続するか、Cloud にサインインしてください。`)
};

export const local_trust_outside = /** @type {(inputs: Local_Trust_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにないデバイス`)
};

export const local_trust_outside_not_taking = /** @type {(inputs: Local_Trust_Outside_Not_TakingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストを信用していないため、指示を受けません。`)
};

export const local_trust_outside_note = /** @type {(inputs: Local_Trust_Outside_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにあるデバイスからの指示は受けますが、そのデバイスからは指示を出せません。追加するには、そのデバイスでコードを表示し、「デバイスを追加」に入力します。`)
};

export const local_trust_outside_page_note = /** @type {(inputs: Local_Trust_Outside_Page_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにないデバイスです。この Agent は、デバイスリストにあるデバイスからの指示を受けます。`)
};

export const local_trust_passphrase = /** @type {(inputs: Local_Trust_PassphraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスフレーズ`)
};

export const local_trust_passphrase_again = /** @type {(inputs: Local_Trust_Passphrase_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一度入力`)
};

export const local_trust_passphrase_ask_body = /** @type {(inputs: Local_Trust_Passphrase_Ask_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC でデバイスリストを変更するには、パスフレーズを入力してください。`)
};

export const local_trust_passphrase_ask_button = /** @type {(inputs: Local_Trust_Passphrase_Ask_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続ける`)
};

export const local_trust_passphrase_ask_title = /** @type {(inputs: Local_Trust_Passphrase_Ask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスフレーズを入力`)
};

export const local_trust_passphrase_mismatch = /** @type {(inputs: Local_Trust_Passphrase_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 回の入力が違います。`)
};

export const local_trust_passphrase_new_note = /** @type {(inputs: Local_Trust_Passphrase_New_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC ではキーチェーンが使えないため、デバイスを追加・削除するときにパスフレーズを入力します。8 文字以上で設定してください。忘れると、この PC からはデバイスリストを変更できなくなります。`)
};

export const local_trust_passphrase_set_title = /** @type {(inputs: Local_Trust_Passphrase_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスフレーズを設定`)
};

export const local_trust_passphrase_short = /** @type {(inputs: Local_Trust_Passphrase_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 文字以上にしてください。`)
};

export const local_trust_problem = /** @type {(inputs: Local_Trust_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存先のデバイスリストが、このデバイスのデバイスリストと一致しません。誰かがデバイスリストを書き換えようとしているおそれがあります。`)
};

export const local_trust_receiver_mark = /** @type {(inputs: Local_Trust_Receiver_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指示を受けるだけ`)
};

export const local_trust_remove = /** @type {(inputs: Local_Trust_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const local_trust_remove_body = /** @type {(inputs: Local_Trust_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除したデバイスからは、Agent に指示を出せなくなります。戻すには、もう一度追加します。`)
};

export const local_trust_remove_self_body = /** @type {(inputs: Local_Trust_Remove_Self_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスから Agent に指示を出せなくなり、デバイスリストも変更できなくなります。戻すには、ほかのデバイスでもう一度追加します。`)
};

export const local_trust_remove_title = /** @type {(inputs: Local_Trust_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} をデバイスリストから削除しますか`)
};

export const local_trust_switch = /** @type {(inputs: Local_Trust_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストを切り替える`)
};

export const local_trust_switch_body = /** @type {(inputs: Local_Trust_Switch_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の画面に表示されているデバイス ID が ${i?.fingerprint} と同じか確認してください。切り替えると、今のデバイスリストにあるデバイスからは、この PC の Agent に指示を出せなくなります。今のデバイスリストには戻せません。`)
};

export const local_trust_switch_button = /** @type {(inputs: Local_Trust_Switch_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切り替える`)
};

export const local_trust_switch_note = /** @type {(inputs: Local_Trust_Switch_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスで作成した新しいデバイスリストです。デバイスをすべてなくしてデバイスリストを作成し直したときだけ、最初のデバイスの画面に表示されているデバイス ID と同じか確認して切り替えてください。`)
};

export const local_trust_switch_title = /** @type {(inputs: Local_Trust_Switch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスリストに切り替えますか`)
};

export const local_trust_this_device = /** @type {(inputs: Local_Trust_This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスの ID`)
};

export const local_trust_this_device_mark = /** @type {(inputs: Local_Trust_This_Device_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイス`)
};

export const local_trust_this_device_note = /** @type {(inputs: Local_Trust_This_Device_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのデバイスでこのデバイスを追加するとき、相手の画面と同じか確かめます。`)
};

export const local_trust_unreachable = /** @type {(inputs: Local_Trust_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存先に接続できませんでした。`)
};

export const local_trust_wrong_passphrase = /** @type {(inputs: Local_Trust_Wrong_PassphraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスフレーズが違います。`)
};

export const local_trust_wrong_proof = /** @type {(inputs: Local_Trust_Wrong_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードを確認できませんでした。`)
};

export const local_via_cloud_refused = /** @type {(inputs: Local_Via_Cloud_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワーク外からは Vault の設定を変更できません。Vault に接続できるときに変更してください。`)
};

export const local_where_cloud = /** @type {(inputs: Local_Where_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud`)
};

export const media_close = /** @type {(inputs: Media_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const media_download = /** @type {(inputs: Media_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロード`)
};

export const media_image_actions = /** @type {(inputs: Media_Image_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像の操作`)
};

export const media_image_next = /** @type {(inputs: Media_Image_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の画像`)
};

export const media_image_position = /** @type {(inputs: Media_Image_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 枚中 ${i?.n} 枚目`)
};

export const media_image_previous = /** @type {(inputs: Media_Image_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前の画像`)
};

export const media_more_actions = /** @type {(inputs: Media_More_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他の操作`)
};

export const media_open_in_tab = /** @type {(inputs: Media_Open_In_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいタブで開く`)
};

export const media_video_exit_fullscreen = /** @type {(inputs: Media_Video_Exit_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面を終了`)
};

export const media_video_fullscreen = /** @type {(inputs: Media_Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面`)
};

export const media_video_label = /** @type {(inputs: Media_Video_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`動画: ${i?.name}`)
};

export const media_video_mute = /** @type {(inputs: Media_Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミュート`)
};

export const media_video_native_fullscreen = /** @type {(inputs: Media_Video_Native_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準プレイヤーで全画面`)
};

export const media_video_pause = /** @type {(inputs: Media_Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一時停止`)
};

export const media_video_play = /** @type {(inputs: Media_Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生`)
};

export const media_video_play_named = /** @type {(inputs: Media_Video_Play_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を再生`)
};

export const media_video_seconds = /** @type {(inputs: Media_Video_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} 秒`)
};

export const media_video_seek = /** @type {(inputs: Media_Video_SeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生位置`)
};

export const media_video_speed = /** @type {(inputs: Media_Video_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生速度`)
};

export const media_video_speed_normal = /** @type {(inputs: Media_Video_Speed_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準`)
};

export const media_video_unmute = /** @type {(inputs: Media_Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミュートを解除`)
};

export const media_video_unplayable = /** @type {(inputs: Media_Video_UnplayableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この動画は再生できません`)
};

export const media_video_volume = /** @type {(inputs: Media_Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音量`)
};

export const media_zoom_in = /** @type {(inputs: Media_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡大`)
};

export const media_zoom_out = /** @type {(inputs: Media_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`縮小`)
};

export const memos_close = /** @type {(inputs: Memos_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const memos_handover = /** @type {(inputs: Memos_HandoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申し送り`)
};

export const memos_handover_placeholder = /** @type {(inputs: Memos_Handover_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の AI への申し送り(いまの状態)`)
};

export const memos_load_failed = /** @type {(inputs: Memos_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした`)
};

export const memos_log = /** @type {(inputs: Memos_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`経過`)
};

export const memos_log_delete = /** @type {(inputs: Memos_Log_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この経過を消す`)
};

export const memos_log_delete_failed = /** @type {(inputs: Memos_Log_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`経過を消せませんでした`)
};

export const memos_log_empty = /** @type {(inputs: Memos_Log_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`経過はまだありません`)
};

export const memos_log_more = /** @type {(inputs: Memos_Log_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もっと見る`)
};

export const memos_save_failed = /** @type {(inputs: Memos_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存できませんでした(入力は残っています)`)
};

export const memos_title = /** @type {(inputs: Memos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI メモ`)
};

export const notices_agent_title = /** @type {(inputs: Notices_Agent_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agent · ${i?.name}`)
};

export const notices_app_denied = /** @type {(inputs: Notices_App_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} の設定で通知が許可されていません`)
};

export const notices_app_destinations = /** @type {(inputs: Notices_App_DestinationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`届け先`)
};

export const notices_app_failed = /** @type {(inputs: Notices_App_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受け取りを切り替えられませんでした`)
};

export const notices_app_label = /** @type {(inputs: Notices_App_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device}(アプリ)`)
};

export const notices_app_open_settings = /** @type {(inputs: Notices_App_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を開く`)
};

export const notices_app_receive = /** @type {(inputs: Notices_App_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスで受け取る`)
};

export const notices_app_this_device = /** @type {(inputs: Notices_App_This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイス`)
};

export const notices_app_untied = /** @type {(inputs: Notices_App_UntiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault が Cloud と連携していないため、アプリを閉じている間は届きません`)
};

export const notices_file_only = /** @type {(inputs: Notices_File_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル`)
};

export const notices_settings_denied = /** @type {(inputs: Notices_Settings_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知が許可されていません。ブラウザか OS の設定で許可すると、ここで入れられます`)
};

export const notices_settings_description = /** @type {(inputs: Notices_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent の返事や「あなたの番」を、OS の通知とアプリのバッジで知らせます`)
};

export const notices_settings_os = /** @type {(inputs: Notices_Settings_OsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS の通知を出す`)
};

export const notices_settings_os_blocked = /** @type {(inputs: Notices_Settings_Os_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mac の通知が許可されていません`)
};

export const notices_settings_os_description = /** @type {(inputs: Notices_Settings_Os_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent の返事と「あなたの番」を、窓が前に出ていないときに OS の通知で知らせます`)
};

export const notices_settings_os_open_settings = /** @type {(inputs: Notices_Settings_Os_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`システム設定を開く`)
};

export const notices_settings_os_unsigned = /** @type {(inputs: Notices_Settings_Os_UnsignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`署名されていないビルドでは、mac の通知を出せません`)
};

export const notices_settings_title = /** @type {(inputs: Notices_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

export const notices_settings_unsupported = /** @type {(inputs: Notices_Settings_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブラウザは通知に対応していません`)
};

export const notices_test_body = /** @type {(inputs: Notices_Test_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テスト通知です`)
};

export const notices_test_title = /** @type {(inputs: Notices_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria`)
};

export const notices_trust_added_body = /** @type {(inputs: Notices_Trust_Added_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} がデバイスリストに追加されました。覚えがなければ、デバイスリストから削除してください。`)
};

export const notices_trust_added_title = /** @type {(inputs: Notices_Trust_Added_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストにデバイスが追加されました`)
};

export const notices_turn_edited_prefix = /** @type {(inputs: Notices_Turn_Edited_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書き換えた: `)
};

export const notices_turn_proposal_prefix = /** @type {(inputs: Notices_Turn_Proposal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容を変えたい: `)
};

export const persons_agent_memo = /** @type {(inputs: Persons_Agent_MemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI メモ`)
};

export const persons_alias_add = /** @type {(inputs: Persons_Alias_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別名を足す`)
};

export const persons_alias_add_failed = /** @type {(inputs: Persons_Alias_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`別名「${i?.alias}」を足せませんでした`)
};

export const persons_alias_placeholder = /** @type {(inputs: Persons_Alias_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よみ・呼び名`)
};

export const persons_alias_remove = /** @type {(inputs: Persons_Alias_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`別名「${i?.alias}」を外す`)
};

export const persons_alias_remove_failed = /** @type {(inputs: Persons_Alias_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`別名「${i?.alias}」を外せませんでした`)
};

export const persons_aliases = /** @type {(inputs: Persons_AliasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別名`)
};

export const persons_aliases_ids = /** @type {(inputs: Persons_Aliases_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別名と外の ID`)
};

export const persons_context = /** @type {(inputs: Persons_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Context`)
};

export const persons_context_placeholder = /** @type {(inputs: Persons_Context_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`誰か・関係・いま気をつけること`)
};

export const persons_create = /** @type {(inputs: Persons_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person を作る`)
};

export const persons_create_failed = /** @type {(inputs: Persons_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person を作れませんでした`)
};

export const persons_create_failed_kept = /** @type {(inputs: Persons_Create_Failed_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作れませんでした(入力は残っています)`)
};

export const persons_create_named = /** @type {(inputs: Persons_Create_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`新しい Person「${i?.name}」を作る`)
};

export const persons_creating = /** @type {(inputs: Persons_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作っています`)
};

export const persons_delete_body = /** @type {(inputs: Persons_Delete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`外の ID と AI メモも消えます。Case の中では ${i?.name} の名前のまま残ります`)
};

export const persons_delete_failed = /** @type {(inputs: Persons_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を削除できませんでした`)
};

export const persons_delete_title = /** @type {(inputs: Persons_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を削除します`)
};

export const persons_empty = /** @type {(inputs: Persons_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person はまだありません`)
};

export const persons_external_ids = /** @type {(inputs: Persons_External_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外の ID`)
};

export const persons_go = /** @type {(inputs: Persons_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People へ`)
};

export const persons_history = /** @type {(inputs: Persons_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これまで`)
};

export const persons_id_add = /** @type {(inputs: Persons_Id_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID を足す`)
};

export const persons_id_add_failed = /** @type {(inputs: Persons_Id_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.value}」を足せませんでした`)
};

export const persons_id_kind = /** @type {(inputs: Persons_Id_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID の種類`)
};

export const persons_id_remove = /** @type {(inputs: Persons_Id_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.value}」を外す`)
};

export const persons_id_remove_failed = /** @type {(inputs: Persons_Id_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.value}」を外せませんでした`)
};

export const persons_id_value = /** @type {(inputs: Persons_Id_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID の値`)
};

export const persons_id_value_placeholder = /** @type {(inputs: Persons_Id_Value_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス・ユーザー名・電話番号・URL`)
};

export const persons_kind_email = /** @type {(inputs: Persons_Kind_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール`)
};

export const persons_kind_github = /** @type {(inputs: Persons_Kind_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

export const persons_kind_phone = /** @type {(inputs: Persons_Kind_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電話`)
};

export const persons_kind_slack = /** @type {(inputs: Persons_Kind_SlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slack`)
};

export const persons_kind_url = /** @type {(inputs: Persons_Kind_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL`)
};

export const persons_link_empty = /** @type {(inputs: Persons_Link_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結べるメンバーがいません(自分と、ほかの Person に結んだメンバーは出しません)`)
};

export const persons_link_failed = /** @type {(inputs: Persons_Link_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を結べませんでした`)
};

export const persons_link_label = /** @type {(inputs: Persons_Link_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバーと結ぶ`)
};

export const persons_link_menu = /** @type {(inputs: Persons_Link_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバーと結ぶ…`)
};

export const persons_link_search = /** @type {(inputs: Persons_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結ぶメンバーを探す`)
};

export const persons_link_search_placeholder = /** @type {(inputs: Persons_Link_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前で探す`)
};

export const persons_link_title = /** @type {(inputs: Persons_Link_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} と結ぶメンバー`)
};

export const persons_linked_former = /** @type {(inputs: Persons_Linked_FormerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元メンバー`)
};

export const persons_list = /** @type {(inputs: Persons_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person の一覧`)
};

export const persons_load_failed = /** @type {(inputs: Persons_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした`)
};

export const persons_menu = /** @type {(inputs: Persons_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」の操作`)
};

export const persons_merge_action = /** @type {(inputs: Persons_Merge_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まとめる`)
};

export const persons_merge_body = /** @type {(inputs: Persons_Merge_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`待ち先・関連・本文の参照・外の ID・別名・AI メモが ${i?.keep} に移り、${i?.from} は消えます`)
};

export const persons_merge_failed = /** @type {(inputs: Persons_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} を ${i?.keep} にまとめられませんでした`)
};

export const persons_merge_label = /** @type {(inputs: Persons_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じ Person をまとめる`)
};

export const persons_merge_menu = /** @type {(inputs: Persons_Merge_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じ Person をまとめる…`)
};

export const persons_merge_note = /** @type {(inputs: Persons_Merge_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`同じ人のもう一方を選びます。選んだ Person は ${i?.name} にまとまって消えます`)
};

export const persons_merge_pick_title = /** @type {(inputs: Persons_Merge_Pick_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} にまとめる Person`)
};

export const persons_merge_search = /** @type {(inputs: Persons_Merge_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まとめる Person を探す`)
};

export const persons_merge_title = /** @type {(inputs: Persons_Merge_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} を ${i?.keep} にまとめます`)
};

export const persons_name = /** @type {(inputs: Persons_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const persons_name_failed = /** @type {(inputs: Persons_Name_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を変えられませんでした`)
};

export const persons_narrow = /** @type {(inputs: Persons_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絞り込む`)
};

export const persons_narrow_placeholder = /** @type {(inputs: Persons_Narrow_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前・ひとこと・ID で絞る`)
};

export const persons_new = /** @type {(inputs: Persons_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい Person`)
};

export const persons_no_match = /** @type {(inputs: Persons_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該当する Person はありません`)
};

export const persons_not_found = /** @type {(inputs: Persons_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Person は見つかりませんでした`)
};

export const persons_now = /** @type {(inputs: Persons_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いま`)
};

export const persons_now_empty = /** @type {(inputs: Persons_Now_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いま待っていることはありません`)
};

export const persons_open_email = /** @type {(inputs: Persons_Open_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールを書く`)
};

export const persons_open_github = /** @type {(inputs: Persons_Open_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub で開く`)
};

export const persons_open_phone = /** @type {(inputs: Persons_Open_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電話をかける`)
};

export const persons_open_slack = /** @type {(inputs: Persons_Open_SlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slack で開く`)
};

export const persons_open_url = /** @type {(inputs: Persons_Open_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く`)
};

export const persons_pick_action = /** @type {(inputs: Persons_Pick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手を選ぶ`)
};

export const persons_pick_candidates = /** @type {(inputs: Persons_Pick_CandidatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`候補`)
};

export const persons_pick_clear = /** @type {(inputs: Persons_Pick_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手を外す`)
};

export const persons_pick_none = /** @type {(inputs: Persons_Pick_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見つかりません`)
};

export const persons_pick_placeholder = /** @type {(inputs: Persons_Pick_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手`)
};

export const persons_pick_search = /** @type {(inputs: Persons_Pick_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手を探す`)
};

export const persons_pick_search_or_create = /** @type {(inputs: Persons_Pick_Search_Or_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前・別名で探す / 新しい Person の名前`)
};

export const persons_pick_search_placeholder = /** @type {(inputs: Persons_Pick_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前・別名で探す`)
};

export const persons_slack_workspace = /** @type {(inputs: Persons_Slack_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ワークスペース ID`)
};

export const persons_slack_workspace_placeholder = /** @type {(inputs: Persons_Slack_Workspace_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ワークスペース ID(T…)`)
};

export const persons_summary = /** @type {(inputs: Persons_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ひとこと`)
};

export const persons_summary_failed = /** @type {(inputs: Persons_Summary_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ひとことを変えられませんでした`)
};

export const persons_summary_placeholder = /** @type {(inputs: Persons_Summary_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所属と関係を 1 行で`)
};

export const persons_title = /** @type {(inputs: Persons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

export const persons_unlink = /** @type {(inputs: Persons_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結びを外す`)
};

export const persons_unlink_failed = /** @type {(inputs: Persons_Unlink_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結びを外せませんでした`)
};

export const persons_waiting_count = /** @type {(inputs: Persons_Waiting_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`待ち ${i?.count}`)
};

export const phone_doc_redo = /** @type {(inputs: Phone_Doc_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やり直す`)
};

export const phone_doc_undo = /** @type {(inputs: Phone_Doc_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻す`)
};

export const phone_dock_settings = /** @type {(inputs: Phone_Dock_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマホの Dock`)
};

export const phone_dock_settings_cutoff = /** @type {(inputs: Phone_Dock_Settings_CutoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここまでが下の段に並びます`)
};

export const phone_dock_settings_description = /** @type {(inputs: Phone_Dock_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スマホの下の段に並べる場所と順番。このデバイスに保存されます。`)
};

export const phone_dock_settings_me = /** @type {(inputs: Phone_Dock_Settings_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me`)
};

export const phone_dock_settings_move = /** @type {(inputs: Phone_Dock_Settings_MoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} を動かす`)
};

export const phone_dock_settings_no_place = /** @type {(inputs: Phone_Dock_Settings_No_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace に入ると、その Workspace の場所もここに並びます。`)
};

export const phone_dock_settings_note = /** @type {(inputs: Phone_Dock_Settings_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上から順に、画面の幅に入るだけ下の段に並びます。Me のものと Workspace のものは段の中で分けて並びます。`)
};

export const phone_dock_settings_show = /** @type {(inputs: Phone_Dock_Settings_ShowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} を Dock とメニューに出す`)
};

export const phone_menu = /** @type {(inputs: Phone_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニュー`)
};

export const phone_menu_all = /** @type {(inputs: Phone_Menu_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての場所`)
};

export const phone_menu_arrange = /** @type {(inputs: Phone_Menu_ArrangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dock の並び替え`)
};

export const phone_menu_open = /** @type {(inputs: Phone_Menu_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニューを開く`)
};

export const phone_more = /** @type {(inputs: Phone_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他`)
};

export const phone_more_current = /** @type {(inputs: Phone_More_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`その他(いま: ${i?.label})`)
};

export const phone_place_menu = /** @type {(inputs: Phone_Place_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」のメニュー`)
};

export const phone_unread_named = /** @type {(inputs: Phone_Unread_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}(新着あり)`)
};

export const publishing_action = /** @type {(inputs: Publishing_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開する`)
};

export const publishing_building = /** @type {(inputs: Publishing_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開しました。リンクで読めるようになるまで数秒かかります。`)
};

export const publishing_close = /** @type {(inputs: Publishing_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const publishing_copied = /** @type {(inputs: Publishing_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクをコピーしました`)
};

export const publishing_copy = /** @type {(inputs: Publishing_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

export const publishing_copy_failed = /** @type {(inputs: Publishing_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーできませんでした`)
};

export const publishing_dataset_more_fields = /** @type {(inputs: Publishing_Dataset_More_FieldsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ほか ${i?.count} 個`)
};

export const publishing_dataset_not_allowed = /** @type {(inputs: Publishing_Dataset_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace はリンクでの公開を許可していません`)
};

export const publishing_dataset_not_writable = /** @type {(inputs: Publishing_Dataset_Not_WritableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Dataset を書く権限がありません`)
};

export const publishing_dataset_rows = /** @type {(inputs: Publishing_Dataset_RowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 行`)
};

export const publishing_datasets_blocked = /** @type {(inputs: Publishing_Datasets_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`公開できない Dataset が ${i?.count} 個あります。公開したページでは、その UI にデータが出ません。`)
};

export const publishing_datasets_confirm_body = /** @type {(inputs: Publishing_Datasets_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部の行と項目を、リンクを知っている人なら誰でも読めるようになります。`)
};

export const publishing_datasets_confirm_title = /** @type {(inputs: Publishing_Datasets_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 個の Dataset を公開`)
};

export const publishing_datasets_failed = /** @type {(inputs: Publishing_Datasets_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset を公開できませんでした`)
};

export const publishing_datasets_hidden = /** @type {(inputs: Publishing_Datasets_HiddenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`見つからない Dataset が ${i?.count} 個あります`)
};

export const publishing_datasets_intro = /** @type {(inputs: Publishing_Datasets_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この文書の UI が読む Dataset です。全部の行と項目を、リンクを知っている人なら誰でも読めるようになります。`)
};

export const publishing_datasets_pending = /** @type {(inputs: Publishing_Datasets_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この文書は、まだ公開していない Dataset を読んでいます。公開したページでは、その UI にデータが出ません。`)
};

export const publishing_datasets_publish = /** @type {(inputs: Publishing_Datasets_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset を公開`)
};

export const publishing_datasets_published = /** @type {(inputs: Publishing_Datasets_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開中の Dataset`)
};

export const publishing_datasets_title = /** @type {(inputs: Publishing_Datasets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一緒に公開される Dataset`)
};

export const publishing_failed = /** @type {(inputs: Publishing_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開できませんでした`)
};

export const publishing_failing = /** @type {(inputs: Publishing_FailingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開したページを更新できていません。自動でやり直しています。`)
};

export const publishing_html_scripts = /** @type {(inputs: Publishing_Html_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML の文書は、書いた script も公開したページで動きます。`)
};

export const publishing_intro = /** @type {(inputs: Publishing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推測できない URL を知っている人なら誰でも、サインインせずに読めるようになります。本文を変えると、少し後に公開したページも変わります。`)
};

export const publishing_menu = /** @type {(inputs: Publishing_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクで公開`)
};

export const publishing_open = /** @type {(inputs: Publishing_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く`)
};

export const publishing_preview = /** @type {(inputs: Publishing_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開したときの見え方`)
};

export const publishing_preview_failed = /** @type {(inputs: Publishing_Preview_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見え方を作れませんでした`)
};

export const publishing_published = /** @type {(inputs: Publishing_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクで公開中`)
};

export const publishing_published_at = /** @type {(inputs: Publishing_Published_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} に公開しました`)
};

export const publishing_published_pending = /** @type {(inputs: Publishing_Published_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクで公開中(公開していない Dataset があります)`)
};

export const publishing_stop = /** @type {(inputs: Publishing_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開を止める`)
};

export const publishing_stop_body = /** @type {(inputs: Publishing_Stop_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクを開いても読めなくなります。もう一度公開すると別の URL になります。`)
};

export const publishing_stop_failed = /** @type {(inputs: Publishing_Stop_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開を止められませんでした`)
};

export const publishing_stop_title = /** @type {(inputs: Publishing_Stop_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」の公開を止める`)
};

export const publishing_title = /** @type {(inputs: Publishing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクで公開`)
};

export const publishing_unpublished_links = /** @type {(inputs: Publishing_Unpublished_LinksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`公開していない文書へのリンクが ${i?.count} 個あります。公開したページではリンクが外れます。`)
};

export const publishing_unpublished_refs = /** @type {(inputs: Publishing_Unpublished_RefsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`公開していないものへの参照が ${i?.count} 個あります。公開したページでは種類の名前だけになります。`)
};

export const publishing_url = /** @type {(inputs: Publishing_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開の URL`)
};

export const refs_cannot_open_here = /** @type {(inputs: Refs_Cannot_Open_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアプリでは開けません`)
};

export const refs_in_cloud = /** @type {(inputs: Refs_In_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud の Workspace にあります(ここでは開けません)`)
};

export const refs_missing_label = /** @type {(inputs: Refs_Missing_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}(${i?.why})`)
};

export const refs_not_found = /** @type {(inputs: Refs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見つかりません`)
};

export const refs_note_conflict = /** @type {(inputs: Refs_Note_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかの所で書き換えられていたので保存しませんでした。いまの本文を上に出しています。`)
};

export const refs_note_conflict_drop = /** @type {(inputs: Refs_Note_Conflict_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書いた分を捨てる`)
};

export const refs_note_conflict_use_mine = /** @type {(inputs: Refs_Note_Conflict_Use_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書いた分で置き換える`)
};

export const refs_note_conflict_yours = /** @type {(inputs: Refs_Note_Conflict_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書いた分`)
};

export const refs_save_failed_kept = /** @type {(inputs: Refs_Save_Failed_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存できませんでした(入力は残っています)`)
};

export const refs_unreachable = /** @type {(inputs: Refs_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に繋がらず、読めませんでした。繋がれば出ます`)
};

export const settings_app_open = /** @type {(inputs: Settings_App_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリの設定`)
};

export const settings_app_open_description = /** @type {(inputs: Settings_App_Open_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の trameria の設定(Cloud・Vault・バックアップ・外観など)を、別の窓で開きます。`)
};

export const settings_app_open_description_device = /** @type {(inputs: Settings_App_Open_Description_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスの trameria アプリの設定(外観・通知・Cloud・Vault)を開きます。`)
};

export const settings_app_window_description = /** @type {(inputs: Settings_App_Window_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の trameria の設定。Cloud の画面にも効きます。`)
};

export const settings_appearance = /** @type {(inputs: Settings_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外観`)
};

export const settings_appearance_description = /** @type {(inputs: Settings_Appearance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスに保存されます。`)
};

export const settings_back_to_index = /** @type {(inputs: Settings_Back_To_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定の一覧へ戻る`)
};

export const settings_general = /** @type {(inputs: Settings_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般`)
};

export const settings_general_description = /** @type {(inputs: Settings_General_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語・タイムゾーン。どのデバイスでも同じです。`)
};

export const settings_general_description_account = /** @type {(inputs: Settings_General_Description_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイコン・名前・言語・タイムゾーン。どのデバイスでも同じです。`)
};

export const settings_group_app = /** @type {(inputs: Settings_Group_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアプリ`)
};

export const settings_input = /** @type {(inputs: Settings_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力`)
};

export const settings_input_description = /** @type {(inputs: Settings_Input_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスに保存されます。キーボードはデバイスごとに違うためです。`)
};

export const settings_language = /** @type {(inputs: Settings_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語`)
};

export const settings_language_browser = /** @type {(inputs: Settings_Language_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザに合わせる`)
};

export const settings_language_note = /** @type {(inputs: Settings_Language_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変えると画面を読み直します。`)
};

export const settings_name = /** @type {(inputs: Settings_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const settings_picture = /** @type {(inputs: Settings_PictureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイコン`)
};

export const settings_save_failed = /** @type {(inputs: Settings_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存できませんでした`)
};

export const settings_send_key = /** @type {(inputs: Settings_Send_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信キー`)
};

export const settings_send_key_enter = /** @type {(inputs: Settings_Send_Key_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter で送る`)
};

export const settings_send_key_mod = /** @type {(inputs: Settings_Send_Key_ModInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘/Ctrl+Enter で送る`)
};

export const settings_send_key_note = /** @type {(inputs: Settings_Send_Key_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一方は改行になります。`)
};

export const settings_theme = /** @type {(inputs: Settings_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマ`)
};

export const settings_theme_auto = /** @type {(inputs: Settings_Theme_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動`)
};

export const settings_theme_dark = /** @type {(inputs: Settings_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダーク`)
};

export const settings_theme_light = /** @type {(inputs: Settings_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライト`)
};

export const settings_theme_note = /** @type {(inputs: Settings_Theme_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動は OS の設定に従います。`)
};

export const settings_time_zone = /** @type {(inputs: Settings_Time_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムゾーン`)
};

export const settings_time_zone_browser = /** @type {(inputs: Settings_Time_Zone_BrowserInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このデバイスに合わせる(${i?.zone})`)
};

export const settings_time_zone_note = /** @type {(inputs: Settings_Time_Zone_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日時の表示と、期日・秘書のジョブの時刻に使います。`)
};

export const shell_account_menu = /** @type {(inputs: Shell_Account_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントメニュー`)
};

export const shell_back = /** @type {(inputs: Shell_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻る`)
};

export const shell_back_to_list = /** @type {(inputs: Shell_Back_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一覧へ戻る`)
};

export const shell_clear_picks = /** @type {(inputs: Shell_Clear_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択を解除`)
};

export const shell_copied = /** @type {(inputs: Shell_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーしました`)
};

export const shell_copy_failed = /** @type {(inputs: Shell_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーできませんでした`)
};

export const shell_copy_link = /** @type {(inputs: Shell_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクをコピー`)
};

export const shell_error_body = /** @type {(inputs: Shell_Error_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み直しても直らないときは、下の 1 行を添えて知らせてください。`)
};

export const shell_error_reload = /** @type {(inputs: Shell_Error_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み直す`)
};

export const shell_error_title = /** @type {(inputs: Shell_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面を表示できませんでした`)
};

export const shell_favorites = /** @type {(inputs: Shell_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorites`)
};

export const shell_favorites_add = /** @type {(inputs: Shell_Favorites_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お気に入りに入れる`)
};

export const shell_favorites_add_failed = /** @type {(inputs: Shell_Favorites_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」をお気に入りに入れられませんでした`)
};

export const shell_favorites_create_folder_failed = /** @type {(inputs: Shell_Favorites_Create_Folder_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フォルダ「${i?.name}」を作れませんでした`)
};

export const shell_favorites_delete_folder = /** @type {(inputs: Shell_Favorites_Delete_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダを削除`)
};

export const shell_favorites_delete_folder_body = /** @type {(inputs: Shell_Favorites_Delete_Folder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中のお気に入りはフォルダの外に移ります。`)
};

export const shell_favorites_delete_folder_failed = /** @type {(inputs: Shell_Favorites_Delete_Folder_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フォルダ「${i?.name}」を削除できませんでした`)
};

export const shell_favorites_delete_folder_title = /** @type {(inputs: Shell_Favorites_Delete_Folder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フォルダ「${i?.name}」を削除します`)
};

export const shell_favorites_empty = /** @type {(inputs: Shell_Favorites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`星を押すとここに並びます`)
};

export const shell_favorites_folder_menu = /** @type {(inputs: Shell_Favorites_Folder_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」のメニュー`)
};

export const shell_favorites_folder_name = /** @type {(inputs: Shell_Favorites_Folder_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダ名`)
};

export const shell_favorites_move_failed = /** @type {(inputs: Shell_Favorites_Move_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お気に入りを動かせませんでした`)
};

export const shell_favorites_new_folder = /** @type {(inputs: Shell_Favorites_New_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダを作る`)
};

export const shell_favorites_remove = /** @type {(inputs: Shell_Favorites_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お気に入りから外す`)
};

export const shell_favorites_remove_failed = /** @type {(inputs: Shell_Favorites_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」をお気に入りから外せませんでした`)
};

export const shell_favorites_rename = /** @type {(inputs: Shell_Favorites_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を変更`)
};

export const shell_favorites_rename_failed = /** @type {(inputs: Shell_Favorites_Rename_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フォルダ「${i?.name}」の名前を変えられませんでした`)
};

export const shell_fold_sidebar = /** @type {(inputs: Shell_Fold_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドバーを畳む`)
};

export const shell_hub_away = /** @type {(inputs: Shell_Hub_AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続できません。再接続で更新内容を反映します`)
};

export const shell_keep_sidebar_open = /** @type {(inputs: Shell_Keep_Sidebar_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドバーを開いたままにする`)
};

export const shell_language_auto = /** @type {(inputs: Shell_Language_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動`)
};

export const shell_list_fold = /** @type {(inputs: Shell_List_FoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`折りたたむ`)
};

export const shell_list_fold_rest = /** @type {(inputs: Shell_List_Fold_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`残り ${i?.count} 件`)
};

export const shell_list_narrow = /** @type {(inputs: Shell_List_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一覧を絞り込む`)
};

export const shell_list_narrow_title = /** @type {(inputs: Shell_List_Narrow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名で絞る`)
};

export const shell_list_no_match = /** @type {(inputs: Shell_List_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまるものはありません`)
};

export const shell_me = /** @type {(inputs: Shell_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me`)
};

export const shell_me_away_settings = /** @type {(inputs: Shell_Me_Away_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を開く`)
};

export const shell_me_empty = /** @type {(inputs: Shell_Me_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここに Inbox・Cases・People・Agents・Documents が並びます。`)
};

export const shell_me_moving_almost = /** @type {(inputs: Shell_Me_Moving_AlmostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まもなく終わります`)
};

export const shell_me_moving_done = /** @type {(inputs: Shell_Me_Moving_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}%・${i?.left}`)
};

export const shell_me_moving_measuring = /** @type {(inputs: Shell_Me_Moving_MeasuringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`残り時間を計っています`)
};

export const shell_me_moving_minutes = /** @type {(inputs: Shell_Me_Moving_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`あと約 ${i?.minutes} 分`)
};

export const shell_me_moving_progress = /** @type {(inputs: Shell_Me_Moving_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移している進み具合`)
};

export const shell_me_moving_under_minute = /** @type {(inputs: Shell_Me_Moving_Under_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あと 1 分ほど`)
};

export const shell_not_found_body = /** @type {(inputs: Shell_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL が違うか、削除されました。`)
};

export const shell_not_found_title = /** @type {(inputs: Shell_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見つかりません`)
};

export const shell_open_sidebar = /** @type {(inputs: Shell_Open_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドバーを開く`)
};

export const shell_personal_data_not_workspace = /** @type {(inputs: Shell_Personal_Data_Not_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace の Documents・Space・DM・Issue は含みません。`)
};

export const shell_personal_documents = /** @type {(inputs: Shell_Personal_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人の Documents`)
};

export const shell_personal_in_cloud = /** @type {(inputs: Shell_Personal_In_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud に保存。ここのアイテムはすべてあなたにしか見えません`)
};

export const shell_personal_in_vault = /** @type {(inputs: Shell_Personal_In_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に保存。ここのアイテムはすべてあなたにしか見えません`)
};

export const shell_personal_only = /** @type {(inputs: Shell_Personal_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここのアイテムはすべてあなたにしか見えません`)
};

export const shell_pick_actions = /** @type {(inputs: Shell_Pick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作`)
};

export const shell_pick_count_label = /** @type {(inputs: Shell_Pick_Count_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.base}(${i?.n} 件)`)
};

export const shell_pick_names_join = /** @type {(inputs: Shell_Pick_Names_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`、`)
};

export const shell_pick_names_more = /** @type {(inputs: Shell_Pick_Names_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.head}ほか ${i?.rest} 件`)
};

export const shell_pick_quoted = /** @type {(inputs: Shell_Pick_QuotedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」`)
};

export const shell_pick_row = /** @type {(inputs: Shell_Pick_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}を選択`)
};

export const shell_picked_actions = /** @type {(inputs: Shell_Picked_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択中の操作`)
};

export const shell_picked_count = /** @type {(inputs: Shell_Picked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件を選択`)
};

export const shell_rail_personal = /** @type {(inputs: Shell_Rail_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データ`)
};

export const shell_resize_sidebar = /** @type {(inputs: Shell_Resize_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドバーの幅`)
};

export const shell_route_pending = /** @type {(inputs: Shell_Route_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`織り上げ中…`)
};

export const shell_settings = /** @type {(inputs: Shell_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

export const shell_settings_back = /** @type {(inputs: Shell_Settings_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を閉じる`)
};

export const shell_settings_description = /** @type {(inputs: Shell_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの画面にも効く、自分の設定。`)
};

export const shell_settings_no_match = /** @type {(inputs: Shell_Settings_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる設定はありません`)
};

export const shell_settings_search = /** @type {(inputs: Shell_Settings_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を検索`)
};

export const shell_shortcuts = /** @type {(inputs: Shell_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーボードショートカット`)
};

export const shell_shortcuts_group_create = /** @type {(inputs: Shell_Shortcuts_Group_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

export const shell_shortcuts_group_general = /** @type {(inputs: Shell_Shortcuts_Group_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全般`)
};

export const shell_shortcuts_group_navigate = /** @type {(inputs: Shell_Shortcuts_Group_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移動`)
};

export const shell_shortcuts_group_view = /** @type {(inputs: Shell_Shortcuts_Group_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示`)
};

export const shell_side_close = /** @type {(inputs: Shell_Side_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const shell_side_open_full = /** @type {(inputs: Shell_Side_Open_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通常の画面で開く`)
};

export const shell_toggle_sidebar = /** @type {(inputs: Shell_Toggle_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドバーを畳む・広げる`)
};

export const shell_unreachable_cannot_open = /** @type {(inputs: Shell_Unreachable_Cannot_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault に接続できません。一度開いた画面だけ表示できます`)
};

export const shell_wide = /** @type {(inputs: Shell_WideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全幅`)
};

export const shell_wide_off = /** @type {(inputs: Shell_Wide_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全幅を解く`)
};

export const shell_wide_toggle = /** @type {(inputs: Shell_Wide_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全幅の切替`)
};

export const shell_window_close = /** @type {(inputs: Shell_Window_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const shell_window_maximize = /** @type {(inputs: Shell_Window_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大化`)
};

export const shell_window_minimize = /** @type {(inputs: Shell_Window_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小化`)
};

export const shell_window_restore = /** @type {(inputs: Shell_Window_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元のサイズに戻す`)
};

export const shell_workspace_change = /** @type {(inputs: Shell_Workspace_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workspace を変える(${i?.name})`)
};

export const shell_workspace_change_many = /** @type {(inputs: Shell_Workspace_Change_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workspace を変える(${i?.names})`)
};

export const shell_workspace_col = /** @type {(inputs: Shell_Workspace_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS`)
};

export const shell_workspace_failed = /** @type {(inputs: Shell_Workspace_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace を変えられませんでした`)
};

export const shell_workspace_left = /** @type {(inputs: Shell_Workspace_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}(抜けた Workspace)`)
};

export const shell_workspace_offline = /** @type {(inputs: Shell_Workspace_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud につながっていないので変えられません`)
};

export const shell_workspace_remove = /** @type {(inputs: Shell_Workspace_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace から外す`)
};

export const shell_workspace_set = /** @type {(inputs: Shell_Workspace_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace を選ぶ`)
};

export const timeblocker_accounts = /** @type {(inputs: Timeblocker_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`つないだアカウント`)
};

export const timeblocker_activity_agent_run = /** @type {(inputs: Timeblocker_Activity_Agent_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話が動いた`)
};

export const timeblocker_activity_case_closed = /** @type {(inputs: Timeblocker_Activity_Case_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case を完了`)
};

export const timeblocker_activity_step_closed = /** @type {(inputs: Timeblocker_Activity_Step_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action を完了`)
};

export const timeblocker_add_block = /** @type {(inputs: Timeblocker_Add_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block を置く`)
};

export const timeblocker_add_lane = /** @type {(inputs: Timeblocker_Add_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レーンを足す`)
};

export const timeblocker_all_day = /** @type {(inputs: Timeblocker_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終日`)
};

export const timeblocker_block_ended = /** @type {(inputs: Timeblocker_Block_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終えた`)
};

export const timeblocker_block_label = /** @type {(inputs: Timeblocker_Block_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title}(${i?.start}–${i?.end})`)
};

export const timeblocker_block_remove = /** @type {(inputs: Timeblocker_Block_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block を消す`)
};

export const timeblocker_calendar = /** @type {(inputs: Timeblocker_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カレンダー`)
};

export const timeblocker_calendar_error = /** @type {(inputs: Timeblocker_Calendar_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を読めませんでした`)
};

export const timeblocker_calendar_settings = /** @type {(inputs: Timeblocker_Calendar_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カレンダーの設定`)
};

export const timeblocker_calendars = /** @type {(inputs: Timeblocker_CalendarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カレンダー`)
};

export const timeblocker_cancel = /** @type {(inputs: Timeblocker_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やめる`)
};

export const timeblocker_case_add_whole = /** @type {(inputs: Timeblocker_Case_Add_WholeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case 全体を追加`)
};

export const timeblocker_case_whole = /** @type {(inputs: Timeblocker_Case_WholeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case 全体`)
};

export const timeblocker_cases = /** @type {(inputs: Timeblocker_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const timeblocker_change_deferred = /** @type {(inputs: Timeblocker_Change_DeferredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`延期`)
};

export const timeblocker_change_moved = /** @type {(inputs: Timeblocker_Change_MovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更`)
};

export const timeblocker_close = /** @type {(inputs: Timeblocker_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const timeblocker_color = /** @type {(inputs: Timeblocker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色`)
};

export const timeblocker_color_of = /** @type {(inputs: Timeblocker_Color_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の色`)
};

export const timeblocker_connect_description = /** @type {(inputs: Timeblocker_Connect_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可画面で Google アカウントを選んでください。サインインに使うアカウントと違ってもかまいません`)
};

export const timeblocker_connect_failed = /** @type {(inputs: Timeblocker_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google カレンダーとつなげませんでした`)
};

export const timeblocker_connect_google = /** @type {(inputs: Timeblocker_Connect_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google カレンダーをつなぐ`)
};

export const timeblocker_connect_more = /** @type {(inputs: Timeblocker_Connect_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほかのアカウントをつなぐ`)
};

export const timeblocker_create_event = /** @type {(inputs: Timeblocker_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

export const timeblocker_date = /** @type {(inputs: Timeblocker_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付`)
};

export const timeblocker_delete_event = /** @type {(inputs: Timeblocker_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定を削除`)
};

export const timeblocker_delete_event_confirm = /** @type {(inputs: Timeblocker_Delete_Event_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を Google カレンダーから削除しますか?`)
};

export const timeblocker_delete_lane = /** @type {(inputs: Timeblocker_Delete_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レーンを消す`)
};

export const timeblocker_detail = /** @type {(inputs: Timeblocker_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block`)
};

export const timeblocker_did_activity = /** @type {(inputs: Timeblocker_Did_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動きあり`)
};

export const timeblocker_did_none = /** @type {(inputs: Timeblocker_Did_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動きなし`)
};

export const timeblocker_did_started = /** @type {(inputs: Timeblocker_Did_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`始めた`)
};

export const timeblocker_did_upcoming = /** @type {(inputs: Timeblocker_Did_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これから`)
};

export const timeblocker_disconnect = /** @type {(inputs: Timeblocker_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続を外す`)
};

export const timeblocker_disconnect_body = /** @type {(inputs: Timeblocker_Disconnect_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアカウントのカレンダーは TimeBlocker に出なくなります。`)
};

export const timeblocker_disconnect_failed = /** @type {(inputs: Timeblocker_Disconnect_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.email}」の接続を外せませんでした`)
};

export const timeblocker_disconnect_title = /** @type {(inputs: Timeblocker_Disconnect_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.email}」の接続を外します`)
};

export const timeblocker_done = /** @type {(inputs: Timeblocker_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

export const timeblocker_empty_done = /** @type {(inputs: Timeblocker_Empty_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この日に終えた Action はありません`)
};

export const timeblocker_empty_todo = /** @type {(inputs: Timeblocker_Empty_TodoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この日にやる Action はありません`)
};

export const timeblocker_end = /** @type {(inputs: Timeblocker_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了`)
};

export const timeblocker_end_block = /** @type {(inputs: Timeblocker_End_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終える`)
};

export const timeblocker_end_date = /** @type {(inputs: Timeblocker_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了日`)
};

export const timeblocker_event_bad_dates = /** @type {(inputs: Timeblocker_Event_Bad_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了日は開始日以降にしてください`)
};

export const timeblocker_event_conflict = /** @type {(inputs: Timeblocker_Event_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カレンダー側で変更されていたため、最新の内容を表示しました`)
};

export const timeblocker_event_detail = /** @type {(inputs: Timeblocker_Event_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定の詳細`)
};

export const timeblocker_event_title = /** @type {(inputs: Timeblocker_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定の名前`)
};

export const timeblocker_event_too_short = /** @type {(inputs: Timeblocker_Event_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定は 15 分以上にしてください`)
};

export const timeblocker_go = /** @type {(inputs: Timeblocker_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TimeBlocker へ`)
};

export const timeblocker_go_today = /** @type {(inputs: Timeblocker_Go_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日`)
};

export const timeblocker_google_connected = /** @type {(inputs: Timeblocker_Google_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google カレンダーとつなぎました`)
};

export const timeblocker_google_denied = /** @type {(inputs: Timeblocker_Google_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google で許可されなかったため、つないでいません`)
};

export const timeblocker_google_failed = /** @type {(inputs: Timeblocker_Google_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google カレンダーとつなげませんでした。もう一度お試しください`)
};

export const timeblocker_google_not_granted = /** @type {(inputs: Timeblocker_Google_Not_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カレンダーへのアクセスが許可されませんでした。もう一度つなぎ、許可画面でカレンダーの項目にチェックを入れてください`)
};

export const timeblocker_google_unavailable = /** @type {(inputs: Timeblocker_Google_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このサーバでは Google カレンダーをつなげません`)
};

export const timeblocker_google_wrong_account = /** @type {(inputs: Timeblocker_Google_Wrong_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可画面で、別の Google アカウントが選ばれました。つなぎ直すアカウントを選んでください`)
};

export const timeblocker_group_after = /** @type {(inputs: Timeblocker_Group_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}より後`)
};

export const timeblocker_group_after_today = /** @type {(inputs: Timeblocker_Group_After_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明日以降`)
};

export const timeblocker_group_before = /** @type {(inputs: Timeblocker_Group_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}より前`)
};

export const timeblocker_group_before_today = /** @type {(inputs: Timeblocker_Group_Before_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日より前`)
};

export const timeblocker_group_today = /** @type {(inputs: Timeblocker_Group_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日`)
};

export const timeblocker_group_undated = /** @type {(inputs: Timeblocker_Group_UndatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付なし`)
};

export const timeblocker_item_start = /** @type {(inputs: Timeblocker_Item_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を開始`)
};

export const timeblocker_item_stop = /** @type {(inputs: Timeblocker_Item_StopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を止める`)
};

export const timeblocker_item_working = /** @type {(inputs: Timeblocker_Item_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業中`)
};

export const timeblocker_join_here = /** @type {(inputs: Timeblocker_Join_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Block に入れる`)
};

export const timeblocker_join_meeting = /** @type {(inputs: Timeblocker_Join_MeetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会議に参加`)
};

export const timeblocker_kind_action = /** @type {(inputs: Timeblocker_Kind_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

export const timeblocker_kind_case = /** @type {(inputs: Timeblocker_Kind_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const timeblocker_lane_me = /** @type {(inputs: Timeblocker_Lane_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分`)
};

export const timeblocker_lane_name = /** @type {(inputs: Timeblocker_Lane_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レーンの名前`)
};

export const timeblocker_lane_none = /** @type {(inputs: Timeblocker_Lane_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出さない`)
};

export const timeblocker_lane_of = /** @type {(inputs: Timeblocker_Lane_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を出すレーン`)
};

export const timeblocker_lanes = /** @type {(inputs: Timeblocker_LanesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レーン`)
};

export const timeblocker_lanes_note = /** @type {(inputs: Timeblocker_Lanes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「自分」は時間枠と一緒に先頭に並びます。足したレーンは横に並びます`)
};

export const timeblocker_link_empty = /** @type {(inputs: Timeblocker_Link_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見つかりません`)
};

export const timeblocker_link_search = /** @type {(inputs: Timeblocker_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case・Action を探して追加`)
};

export const timeblocker_lists = /** @type {(inputs: Timeblocker_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case・Action の一覧`)
};

export const timeblocker_load_failed = /** @type {(inputs: Timeblocker_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした`)
};

export const timeblocker_mark_done = /** @type {(inputs: Timeblocker_Mark_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了にする`)
};

export const timeblocker_mark_done_of = /** @type {(inputs: Timeblocker_Mark_Done_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を完了`)
};

export const timeblocker_more = /** @type {(inputs: Timeblocker_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ほか ${i?.count} 件`)
};

export const timeblocker_new_event = /** @type {(inputs: Timeblocker_New_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定を追加`)
};

export const timeblocker_next_day = /** @type {(inputs: Timeblocker_Next_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の日`)
};

export const timeblocker_next_week = /** @type {(inputs: Timeblocker_Next_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の週`)
};

export const timeblocker_no_accounts = /** @type {(inputs: Timeblocker_No_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだつないでいません。つなぐと Google の画面で許可を聞かれます`)
};

export const timeblocker_no_actions = /** @type {(inputs: Timeblocker_No_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action はありません`)
};

export const timeblocker_no_writable = /** @type {(inputs: Timeblocker_No_WritableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書き込めるカレンダーがありません。カレンダーの設定で、自分のカレンダーをレーンに出してください`)
};

export const timeblocker_open_case = /** @type {(inputs: Timeblocker_Open_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case を開く`)
};

export const timeblocker_open_google = /** @type {(inputs: Timeblocker_Open_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google カレンダーで開く`)
};

export const timeblocker_pick_action = /** @type {(inputs: Timeblocker_Pick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action を選ぶ`)
};

export const timeblocker_pick_date = /** @type {(inputs: Timeblocker_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を選ぶ`)
};

export const timeblocker_plan = /** @type {(inputs: Timeblocker_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やる日`)
};

export const timeblocker_prev_day = /** @type {(inputs: Timeblocker_Prev_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前の日`)
};

export const timeblocker_prev_week = /** @type {(inputs: Timeblocker_Prev_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前の週`)
};

export const timeblocker_read_only = /** @type {(inputs: Timeblocker_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閲覧のみ`)
};

export const timeblocker_recurring_one = /** @type {(inputs: Timeblocker_Recurring_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繰り返しの予定は、この回だけが変わります`)
};

export const timeblocker_redo = /** @type {(inputs: Timeblocker_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やり直す`)
};

export const timeblocker_redo_failed = /** @type {(inputs: Timeblocker_Redo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やり直せませんでした`)
};

export const timeblocker_reopen = /** @type {(inputs: Timeblocker_ReopenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未完了に戻す`)
};

export const timeblocker_reset_color = /** @type {(inputs: Timeblocker_Reset_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google の色に戻す`)
};

export const timeblocker_resume_block = /** @type {(inputs: Timeblocker_Resume_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再開`)
};

export const timeblocker_resync = /** @type {(inputs: Timeblocker_ResyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一覧を取り直す`)
};

export const timeblocker_review = /** @type {(inputs: Timeblocker_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`振り返り`)
};

export const timeblocker_review_actual = /** @type {(inputs: Timeblocker_Review_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実働`)
};

export const timeblocker_review_changes = /** @type {(inputs: Timeblocker_Review_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始後の変更`)
};

export const timeblocker_review_changes_deferred = /** @type {(inputs: Timeblocker_Review_Changes_DeferredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`別の日へ延ばした ${i?.count}`)
};

export const timeblocker_review_changes_moved = /** @type {(inputs: Timeblocker_Review_Changes_MovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`動かした ${i?.count}`)
};

export const timeblocker_review_changes_shortened = /** @type {(inputs: Timeblocker_Review_Changes_ShortenedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`縮めた ${i?.count}`)
};

export const timeblocker_review_deferred_from = /** @type {(inputs: Timeblocker_Review_Deferred_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} ${i?.time} から延期`)
};

export const timeblocker_review_deferred_to = /** @type {(inputs: Timeblocker_Review_Deferred_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`→ ${i?.day} ${i?.time}`)
};

export const timeblocker_review_done = /** @type {(inputs: Timeblocker_Review_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

export const timeblocker_review_done_of = /** @type {(inputs: Timeblocker_Review_Done_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`紐付けた Case・Action`)
};

export const timeblocker_review_empty = /** @type {(inputs: Timeblocker_Review_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この週に Block はありません`)
};

export const timeblocker_review_link = /** @type {(inputs: Timeblocker_Review_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`紐付ける`)
};

export const timeblocker_review_linked = /** @type {(inputs: Timeblocker_Review_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`紐付け済み`)
};

export const timeblocker_review_moved = /** @type {(inputs: Timeblocker_Review_MovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この間に動いたもの ${i?.count}`)
};

export const timeblocker_review_moved_to = /** @type {(inputs: Timeblocker_Review_Moved_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`→ ${i?.time}`)
};

export const timeblocker_review_of = /** @type {(inputs: Timeblocker_Review_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.range} の振り返り`)
};

export const timeblocker_review_planned = /** @type {(inputs: Timeblocker_Review_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`計画`)
};

export const timeblocker_review_planned_committed = /** @type {(inputs: Timeblocker_Review_Planned_CommittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確定した予定の合計`)
};

export const timeblocker_review_planned_of = /** @type {(inputs: Timeblocker_Review_Planned_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これからの分も含む`)
};

export const timeblocker_review_rate = /** @type {(inputs: Timeblocker_Review_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定実行率`)
};

export const timeblocker_review_rate_of = /** @type {(inputs: Timeblocker_Review_Rate_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`終わった Block ${i?.did} / ${i?.all}`)
};

export const timeblocker_review_ratio = /** @type {(inputs: Timeblocker_Review_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実働 ÷ 計画`)
};

export const timeblocker_review_ratio_of = /** @type {(inputs: Timeblocker_Review_Ratio_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`終わった分の計画 ${i?.planned}`)
};

export const timeblocker_review_unlinked_block = /** @type {(inputs: Timeblocker_Review_Unlinked_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`紐付けなし`)
};

export const timeblocker_review_untitled_chat = /** @type {(inputs: Timeblocker_Review_Untitled_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題のない会話`)
};

export const timeblocker_save_failed = /** @type {(inputs: Timeblocker_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存できませんでした`)
};

export const timeblocker_settings_description = /** @type {(inputs: Timeblocker_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google アカウントをつなぎ、どのカレンダーを TimeBlocker のどのレーンに出すかを決めます。サインインに使うアカウントとは関係しません。`)
};

export const timeblocker_settings_title = /** @type {(inputs: Timeblocker_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google カレンダー`)
};

export const timeblocker_show_actions = /** @type {(inputs: Timeblocker_Show_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action も表示`)
};

export const timeblocker_start = /** @type {(inputs: Timeblocker_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始`)
};

export const timeblocker_start_block = /** @type {(inputs: Timeblocker_Start_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`始める`)
};

export const timeblocker_start_date = /** @type {(inputs: Timeblocker_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始日`)
};

export const timeblocker_tabs = /** @type {(inputs: Timeblocker_TabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示する項目`)
};

export const timeblocker_this_week = /** @type {(inputs: Timeblocker_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今週`)
};

export const timeblocker_time = /** @type {(inputs: Timeblocker_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間`)
};

export const timeblocker_timeline = /** @type {(inputs: Timeblocker_TimelineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}の時間軸`)
};

export const timeblocker_title = /** @type {(inputs: Timeblocker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TimeBlocker`)
};

export const timeblocker_title_label = /** @type {(inputs: Timeblocker_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名`)
};

export const timeblocker_todo = /** @type {(inputs: Timeblocker_TodoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やること`)
};

export const timeblocker_undated_drop = /** @type {(inputs: Timeblocker_Undated_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここへ運ぶと日付なしにして、Block から外す`)
};

export const timeblocker_undo = /** @type {(inputs: Timeblocker_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元に戻す`)
};

export const timeblocker_undo_failed = /** @type {(inputs: Timeblocker_Undo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元に戻せませんでした`)
};

export const timeblocker_unlink = /** @type {(inputs: Timeblocker_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`紐付けを外す`)
};

export const timeblocker_untitled = /** @type {(inputs: Timeblocker_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(タイトルなし)`)
};

export const timeblocker_week_range = /** @type {(inputs: Timeblocker_Week_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}〜${i?.to}`)
};

export const timeblocker_work_label = /** @type {(inputs: Timeblocker_Work_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業`)
};

export const timeblocker_work_log = /** @type {(inputs: Timeblocker_Work_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業記録`)
};

export const timeblocker_work_log_delete = /** @type {(inputs: Timeblocker_Work_Log_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消す`)
};

export const timeblocker_work_log_label = /** @type {(inputs: Timeblocker_Work_Log_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`作業記録 ${i?.start}–${i?.end}`)
};

export const timeblocker_work_log_now = /** @type {(inputs: Timeblocker_Work_Log_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いま`)
};

export const timeblocker_work_running = /** @type {(inputs: Timeblocker_Work_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`作業中 ${i?.elapsed}`)
};

export const timeblocker_work_running_of = /** @type {(inputs: Timeblocker_Work_Running_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`作業中: ${i?.title}(${i?.elapsed})`)
};

export const timeblocker_work_start = /** @type {(inputs: Timeblocker_Work_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業を開始`)
};

export const timeblocker_work_start_short = /** @type {(inputs: Timeblocker_Work_Start_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始`)
};

export const timeblocker_work_stop = /** @type {(inputs: Timeblocker_Work_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業を停止`)
};

export const timeblocker_work_stop_short = /** @type {(inputs: Timeblocker_Work_Stop_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停止`)
};

export const timeblocker_work_total = /** @type {(inputs: Timeblocker_Work_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この日 ${i?.total}`)
};

export const uifence_answer = /** @type {(inputs: Uifence_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`答える`)
};

export const uifence_answer_detail = /** @type {(inputs: Uifence_Answer_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欄の UI が答えとして送ろうとしています。送るとこの件は閉じ、Agent が答えとして読みます。`)
};

export const uifence_answer_title = /** @type {(inputs: Uifence_Answer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この件の答えとして、次の文を送りますか?`)
};

export const uifence_building = /** @type {(inputs: Uifence_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UI を組んでいます`)
};

export const uifence_calendar_next_month = /** @type {(inputs: Uifence_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の月`)
};

export const uifence_calendar_pick = /** @type {(inputs: Uifence_Calendar_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付を選ぶ`)
};

export const uifence_calendar_prev_month = /** @type {(inputs: Uifence_Calendar_Prev_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前の月`)
};

export const uifence_calendar_today = /** @type {(inputs: Uifence_Calendar_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日にする`)
};

export const uifence_chart_others = /** @type {(inputs: Uifence_Chart_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ほか ${i?.count} 件`)
};

export const uifence_choose = /** @type {(inputs: Uifence_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選ぶ`)
};

export const uifence_copy_source = /** @type {(inputs: Uifence_Copy_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースをコピー`)
};

export const uifence_count_left = /** @type {(inputs: Uifence_Count_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`← ${i?.count} 件`)
};

export const uifence_count_right = /** @type {(inputs: Uifence_Count_RightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件 →`)
};

export const uifence_data_all_rows = /** @type {(inputs: Uifence_Data_All_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全行`)
};

export const uifence_data_button = /** @type {(inputs: Uifence_Data_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset`)
};

export const uifence_data_not_found = /** @type {(inputs: Uifence_Data_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset を開けません`)
};

export const uifence_data_not_found_detail = /** @type {(inputs: Uifence_Data_Not_Found_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除されたか、見る権限がありません。`)
};

export const uifence_data_query = /** @type {(inputs: Uifence_Data_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クエリ`)
};

export const uifence_date = /** @type {(inputs: Uifence_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付`)
};

export const uifence_end = /** @type {(inputs: Uifence_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了`)
};

export const uifence_failed = /** @type {(inputs: Uifence_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この UI は動かせませんでした`)
};

export const uifence_funnel_from_first = /** @type {(inputs: Uifence_Funnel_From_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初から`)
};

export const uifence_funnel_from_previous = /** @type {(inputs: Uifence_Funnel_From_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前の段階から`)
};

export const uifence_heatmap = /** @type {(inputs: Uifence_HeatmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒートマップ`)
};

export const uifence_hide_source = /** @type {(inputs: Uifence_Hide_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースを隠す`)
};

export const uifence_insert = /** @type {(inputs: Uifence_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動かせる UI`)
};

export const uifence_label = /** @type {(inputs: Uifence_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動かせる UI`)
};

export const uifence_more_left = /** @type {(inputs: Uifence_More_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 続き`)
};

export const uifence_more_right = /** @type {(inputs: Uifence_More_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続き →`)
};

export const uifence_next_image = /** @type {(inputs: Uifence_Next_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の画像`)
};

export const uifence_no = /** @type {(inputs: Uifence_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なし`)
};

export const uifence_no_data = /** @type {(inputs: Uifence_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データなし`)
};

export const uifence_no_events = /** @type {(inputs: Uifence_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定なし`)
};

export const uifence_open_link = /** @type {(inputs: Uifence_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く`)
};

export const uifence_open_link_detail = /** @type {(inputs: Uifence_Open_Link_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UI の中のリンクです。行き先が思っていたものか確かめてから開いてください。新しいタブで開きます。`)
};

export const uifence_open_link_title = /** @type {(inputs: Uifence_Open_Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外のサイトを開きますか?`)
};

export const uifence_picker_clear = /** @type {(inputs: Uifence_Picker_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外す`)
};

export const uifence_prev_image = /** @type {(inputs: Uifence_Prev_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前の画像`)
};

export const uifence_quiz_correct = /** @type {(inputs: Uifence_Quiz_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正解`)
};

export const uifence_quiz_hint = /** @type {(inputs: Uifence_Quiz_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`答えを選ぶと、正解が出ます`)
};

export const uifence_quiz_hint_explained = /** @type {(inputs: Uifence_Quiz_Hint_ExplainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`答えを選ぶと、正解と解説が出ます`)
};

export const uifence_quiz_picked_wrong = /** @type {(inputs: Uifence_Quiz_Picked_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選んだ答え(不正解)`)
};

export const uifence_quiz_wrong = /** @type {(inputs: Uifence_Quiz_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不正解`)
};

export const uifence_range_next_day = /** @type {(inputs: Uifence_Range_Next_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翌`)
};

export const uifence_range_reversed = /** @type {(inputs: Uifence_Range_ReversedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了が開始より前です`)
};

export const uifence_range_same = /** @type {(inputs: Uifence_Range_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始と終了が同じです`)
};

export const uifence_range_sep = /** @type {(inputs: Uifence_Range_SepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`〜`)
};

export const uifence_send = /** @type {(inputs: Uifence_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送る`)
};

export const uifence_send_detail = /** @type {(inputs: Uifence_Send_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返事の中の UI が送ろうとしています。送ると Agent がそれを読んで返事をします。`)
};

export const uifence_send_title = /** @type {(inputs: Uifence_Send_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この会話に、あなたの発言として次の文を送りますか?`)
};

export const uifence_show_source = /** @type {(inputs: Uifence_Show_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースを見る`)
};

export const uifence_source = /** @type {(inputs: Uifence_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソース`)
};

export const uifence_spark_range = /** @type {(inputs: Uifence_Spark_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first} から ${i?.last}(最小 ${i?.min}、最大 ${i?.max})`)
};

export const uifence_stale = /** @type {(inputs: Uifence_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この操作を反映できませんでした`)
};

export const uifence_start = /** @type {(inputs: Uifence_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始`)
};

export const uifence_time = /** @type {(inputs: Uifence_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時刻`)
};

export const uifence_time_hour = /** @type {(inputs: Uifence_Time_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時`)
};

export const uifence_time_minute = /** @type {(inputs: Uifence_Time_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

export const uifence_time_now = /** @type {(inputs: Uifence_Time_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今にする`)
};

export const uifence_time_pick = /** @type {(inputs: Uifence_Time_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時刻を選ぶ`)
};

export const uifence_total = /** @type {(inputs: Uifence_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計`)
};

export const uifence_waterfall_down = /** @type {(inputs: Uifence_Waterfall_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`減少`)
};

export const uifence_waterfall_running = /** @type {(inputs: Uifence_Waterfall_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累計`)
};

export const uifence_waterfall_up = /** @type {(inputs: Uifence_Waterfall_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`増加`)
};

export const uifence_yes = /** @type {(inputs: Uifence_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あり`)
};